/* eslint eqeqeq: "off" */
import * as React from "react";
import { Modal, Button, Form, Dropdown, Image } from "react-bootstrap";
import { hideModal, showCallMeModal, showRequestOTPModal, donateDecreaseToOrganization, referAFriend, showVerifyOTPModal, showLegalScreen, showInterventionErrorModal, showInEditScreen, showReferFriend, showAddNewItem, showFnolCallMeModal, showClaimContinueSuccess, showContinueOnPhoneDifferent, showContinueOnPhone, showSMSsent, showSendContinueOnPhone, showGetBackToYou, requestCancellationLife, showInspectionContinueSuccess } from "../../actions/modalActions";
import { signOut, requestOTP, verifyOTP, linkCustomer, verifyOTPLife, linkLifeCustomer } from "../../actions/authActions";
import { connect } from 'react-redux';
import {
    MODAL_TYPE_CONFIRM_SIGN_OUT,
    MODAL_TYPE_OK,
    MODAL_TYPE_SEND_OTP,
    MODAL_TYPE_VERIFY_OTP,
    MODAL_TYPE_VERIFY_OTP_LIFE,
    MODAL_TYPE_CALL_ME,
    MODAL_TYPE_FNOL_CALL_ME,
    MODAL_TYPE_LINK_POLICY,
    MODAL_TYPE_REFER_A_FRIEND,
    LINK_POLICYNR,
    LINK_IDNUMBER,
    LINK_LIFE_POLICYNR,
    MODAL_TYPE_UPDATE_PROFILE,
    FIELD_PHONENUMBER,
    FIELD_ALTPHONENUMBER,
    FIELD_EMAIL,
    FIELD_WORKADDRESS,
    FIELD_PREFERREDLANGUAGE,
    MODAL_DONATE,
    MODAL_THANK_YOU,
    MODAL_TYPE_REQUEST_DOCS,
    MODAL_TYPE_ERROR,
    MODAL_TYPE_COMING_SOON,
    MODAL_TYPE_REQUEST_DOCS_COVER,
    MODAL_TYPE_REQUEST_DOCS_DATE,
    MODAL_TYPE_REQUEST_DOCS_COVER_DATE,
    MODAL_TYPE_BROKER_DOCS,
    MODAL_TYPE_LOGIN_ERROR,
    MODAL_TYPE_QUOTE_PAYMENT,
    PAYMENT_TYPE_DEBIT,
    PAYMENT_TYPE_CREDIT,
    MODAL_TYPE_INTERVENTION,
    MODAL_TYPE_ADD_VAP,
    MODAL_TYPE_ADD_ACCESSORRY,
    MODAL_TYPE_ADD_CREDIT_SHORTFALL,
    MODAL_TYPE_ADD_VAP_CAR_HIRE,
    MODAL_TYPE_ADD_NEW_QUOTE_ITEM,
    MODAL_TYPE_REMOVE_QUOTE_ITEM,
    MODAL_TYPE_SHOW_BANKING,
    MODAL_TYPE_SHOW_LEGAL,
    MODAL_TYPE_SHOW_EDIT,
    MODAL_TYPE_QUOTE_ITEM_DISCARD,
    MODAL_TYPE_REQUET_CANCELATION,
    MODAL_TYPE_CANCEL_POLICY_EDIT,
    MODAL_TYPE_ANOTHER_SELF_INSPECTION,
    MODAL_TYPE_SUBMIT_SELF_INSPECTION,
    MODAL_DRIVABLE_NO,
    MODAL_TOW_ASSIST,
    MODAL_TYPE_CHANGE_CREDIT_CARD,
    MODAL_SWITCH_TO_MOBILE,
    MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE,
    MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE,
    FNOL_SELECTED_DAMAGE_CAR_SHOW,
    MODAL_TYPE_CLAIM_CONTINUE_SUCCESS,
    MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS,
    MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT,
    MODAL_GET_BACK_TO_YOU,
    FNOL_SELECTED_DAMAGE_MB_SHOW,
    MODAL_TYPE_DUPLICATE_CLAIM,
    MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY,
    DOC_LIFE_POLICY_DOCUMENT,
    MODAL_TAKE_FNOL_PHOTOS,
    MODAL_TYPE_ADD_RAFF_ASSIST,
    MODAL_TYPE_REFER_AGAIN,
    MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE,
    MODAL_TYPE_SMS_SENT,
    MODAL_TYPE_CLAIM_ESTIMATED_TIME,
    MODAL_TYPE_REQUEST_A_CAR,
    MODAL_TYPE_CLAIM_COST_BREAKDOWN,
    MODAL_TYPE_REPAIRS_TAKING_LONGER,
    MODAL_TYPE_GET_BACK_DAMAGE,
    MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK,
    MODAL_TYPE_ESTIMATED_DATE_CHANGED,
    MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE,
    MODAL_TYPE_LIFE_REMOVE_BENEFICIARY,
    MODAL_TYPE_CLAIM_DISCLAIMER,
    MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS,
    MODAL_TYPE_CALL_BACK_REQUEST,
    MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE,
    MODAL_TYPE_QUOTE_SOFT_REJECTED,
    MODAL_TYPE_QUOTE_HARD_REJECTED,
    MODAL_TYPE_QUOTE_MAINLINE_REMOVAL,
    MODAL_TYPE_SEND_IMEI_NUMBER,
    MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE,
    MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES,
    MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM,
    MODAL_TYPE_REMOVE_COVER,
    MODAL_TYPE_REMOVE_COVER_COMPLETE,
    MODAL_TYPE_POLICY_VIEW_AMENDMENTS,
    MODAL_TYPE_REMOVE_LAST_COVER,
    MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS,
    MODAL_TYPE_SHOW_EDIT_REMOVE,
    MODAL_TYPE_REMOVE_REASONS,
    MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE,
    MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP,
    MODAL_TYPE_VIEW_INSPECTION_PHOTO,
    MODAL_TYPE_VIEW_POLICE_REPORT,
    MODAL_TYPE_VIEW_BLACKLIST_PHONE,
    MODAL_TYPE_NO_LONGER_MAINLINE,
    MODAL_TYPE_CELLPHONE_PLEASE_WAIT,
    MODAL_TYPE_NAM_OK,
    MODAL_TYPE_CLICK_AWAY,
    MODAL_FNOL_NOTIFICATION_SUBMIT,
    MODAL_CLEAR_PARTY,
    MODAL_TYPE_CLAIMS_ADDRESS_CHANGE,
    CONFIRMATION_OF_COVER_MOTORBIKE,
    MODAL_SIGN_IN,
    MODAL_REDIRECT_NAM,
    MODAL_REDIRECT_ZA,
    EXISTING_CLIENT_ERROR,
    MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL, CROSS_BORDER_MOTORBIKE, CROSS_BORDER_CAR,
} from './../../constants/constants';
import { callMeBack, fnolCallMeBack, updateInfo, requestDocument, setSelectedCover, setSelectedClaim, damageReportCallBack, requestLifeDocument } from "../../actions/profileActions";
import './../Modals/Modal.css';
import { validateCellphoneNumber, validateName, validateOTP, validateIdNumber, validateSurname, validateEmail } from "../../constants/validation";
import { ERROR_INVALID_OTP, BROKER_DOC_DESCRIPTION, BROKER_DOC_HEADER } from "../../constants/copy";
import { SA_RETENTIONS_EMAIL, NAM_RETENTIONS_EMAIL, NAM_CLIENT_CARE_EMAIL, SA_CLIENT_CARE_EMAIL, NAM_COUNTRY_ID_NUMBER, SA_COUNTRY_ID_NUMBER } from "../../constants/internationalization";
import { NAM_TC_LINK, SA_TC_LINK, DASHBOARD, REFER_A_FRIEND, CALL_ME_BACK, ADDCOVER, SELF_INSPECTION, CLAIMS_IN_THE_MEANTIME, FNOL_CLAIM_DETAILS_MOBILE, CLAIM_HISTORY_V2, CLAIM_END_PAGE, SUBMIT_CLAIM_DETAILS, SUBMIT_CLAIM, OUR_REPAIRERS } from "../../routes/routes";
import ModernDatepicker from 'react-modern-datepicker';
import ModalCoverSelect from "./ModalCoverSelect";
import { RefreshCacheAndReload } from "../../actions/sspActions";
import { logEvent } from "../../firebase/firebase";
import { addVapToQuote, addAccessoryToQoute, addCreditShortfall, removeAccessoryFromQuote, editVapCoverOnQuote, RemoveVapCoverOnQuote, updateCreditShortfall, setLegalQuestions, createPolicy, updatePolicy, setIsInEdit, acceptQuote, getLegalQuestions, setIsOnQuoteScreen, getIsIMEINumberActive, getQuoteCancellationReasons, editPolicyRiskItems, setIsInEditRemove, setQuoteCancellationReasons, removeVapFromQuoteWithReasons } from "../../actions/salesActions";
import { discardCartPortable, removeProductFromCart, removeProductFromCartNavigate } from "../../actions/cartActions";
import OnlineJourneySelect from "../OnlineJourney/OnlineJourneySelect";
import { postToController } from "../../actions/apiActions";
import { navigateTo } from "../../actions/navigationActions";
import { setSelectedCoverSelfInspect, submitSelfInspect, sendInspectionSMS, logInspectionContinueOnPhone, getInspectionContinueAndSetData, removeInspectionNotifyFlag } from "../../actions/selfInspectActions";
import { hideLoadingScreen, showLoadingScreen } from "../../actions/fullscreenActions";
import LegalQuestions from "../OnlineQuotation/LegalStuff/LegalQuestions";
import KPInputTextArea from "../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea";
import KPDropdown from "../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown";
import { updateClaimPartyReducer, sendSMS, logContinueOnPhone, removeNotifyFlag, getContinueAndSetData, getClaimDamagePhotoTypes, setDamagePosition, setSelectedDamagePhotoTypes, setStep, saveDamageSelected, handleNextStep, submitFNOL, submitFNOLNotDriveable, setContinueOnPhone, completeStep, startGlassClaim, setDisclaimer, submitGlassClaim, setFnolReducer, submitDrivableClaim, updateOutcomeOnClaimRepudiate } from "../../actions/claimSubmitActions";
import BasicAuthSignIn from "../SignIn/BasicAuthSignIn";
class ModalComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            OTPToPhone: true,
            OTP: '',
            OTPSubmitted: false,
            otpRegex: false,
            referFullname: '',
            referSurname: '',
            referPhoneNumber: '',
            fullname: '',
            surname: '',
            callBackSubmitted: false,
            nameRegex: false,
            surnameRegex: false,
            idRegex: false,
            policyRegex: false,
            lifePolicyRegex: false,
            cellphoneNumberRegex: false,
            policyLinkMethod: '',
            policyNr: '',
            lifePolicyNr: '',
            idNumber: '',
            linkPolicySubmitted: false,
            phoneNumber: '',
            altPhoneNumber: '',
            email: '',
            preferredLanguageSelection: '',
            preferredLanguageDropdownOpen: false,
            field: '',
            callMeBackDropdownSelection: 'Client care',
            callMeBackTimeDropdownSelection: 'Between 08:00 and 18:00 (office hours)',
            fnolCallMeBackDropdownSelection: 'Who do you want to chat to?',
            callMeBackDropdownOpen: false,
            callMeBackTimeDropdownOpen: false,
            callMeBackDropdownImage: 'Images/red-arrow-down-24-px.svg',
            documentMail: this.props.profile.email,
            referFriendSubmitted: false,
            coverToggle: false,
            selectedCover: null,
            selectedTaxCover: null,
            selectedSelfInspectCover: null,
            startDateTax: "",
            endDateTax: "",
            startDate: "",
            endDate: "",
            maxDate: new Date(),
            requestError: false,
            documentMailRegex: true,
            paymentMethod: PAYMENT_TYPE_CREDIT,
            selectedCreditShortfallDate: "",
            selectedCreditShortfallPayment: "",
            accessorryReplacementValue: this.props.modal.modalProps.accessory === undefined ? "2000" : this.props.modal.modalProps.accessory.replacementValue,
            selectedVap: "",
            nextDisabled: true,
            selectedVapDropDown: false,
            accessoryError: false,
            accessoryErrorDescription: "",
            vapSubmitted: false,
            CriminalOffenceYesState: '',
            CriminalOffenceNoState: '',
            CriminalOffenceAnswer: '',
            SpecialTermsYesState: '',
            SpecialTermsNoState: '',
            SpecialTermsAnswer: '',
            RefusedYesState: '',
            RefusedNoState: '',
            RefusedAnswer: '',
            AdvisedYesState: '',
            AdvisedNoState: '',
            AdvisedAnswer: '',
            CancelledYesState: '',
            CancelledNoState: '',
            CancelledAnswer: '',
            legalList: [],
            claimContinuePhoneNumber: '',
            claimContinuePhoneNumberError: false,
            claimContinuePhoneNumberSubmitted: false,
            claimContinuePhoneNumberIsBusy: false,
            modalDamagePhotoTypes: [],
            fnolCallBackDescription: '',
            mbFront: ["Front fairing", "Front mudguard", "Windshield", "Headlight", "Front tyre", "Handlebars", "Front brake"],
            mbFrontLeft: ["Left shock", "Left indicator", "Left mirror", "Left fairing", "Clutch lever", "Left front footrest", "Gear lever", "Front left brake"],
            mbFrontRight: ["Right shock", "Right indicator", "Right mirror", "Right fairing", "Front brake lever", "Right front footrest", "Right front brake"],
            mbBackLeft: ["Left side engine", "Left rear footrest", "Left side exhaust", "Left side frame", "Left rear indicator", "Left rear suspension", "Left rear brake"],
            mbBackRight: ["Right side engine", "Right rear footrest", "Right side exhaust", "Right side frame", "Right rear indicator", "Right rear suspension", "Right rear brake"],
            mbBack: ["Carrier", "Exhaust", "Tail light", "Rear fairing", "Rear mudguard", "Rear shock", "Rear tyre", "Rear brake"],
            //nextDisabled: true,
            acceptedTCs: false,
            swichToPhoneSubmitted: false,
            swichToPhoneNumber: '',
            IMEINumber: "",
            IMEINumberSubmitted: false,
            IMEINumberRegex: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleHideModal = this.handleHideModal.bind(this);
        this.handleRetryOTP = this.handleRetryOTP.bind(this);
        this.handleSignOut = this.handleSignOut.bind(this);
        this.handleGetOTP = this.handleGetOTP.bind(this);
        this.handleResendOTP = this.handleResendOTP.bind(this);
        this.handleVerifyOTP = this.handleVerifyOTP.bind(this);
        this.handleVerifyOTPLife = this.handleVerifyOTPLife.bind(this);
        this.handleOTPMethodChange = this.handleOTPMethodChange.bind(this);
        this.handleCallMeFromOTP = this.handleCallMeFromOTP.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleCallMeBackClaims = this.handleCallMeBackClaims.bind(this);
        this.handleLinkType = this.handleLinkType.bind(this);
        this.handleRequestDocument = this.handleRequestDocument.bind(this);
        this.linkCustomerPolicies = this.linkCustomerPolicies.bind(this);
        this.handleCallMeBackDropdownSelection = this.handleCallMeBackDropdownSelection.bind(this);
        this.handleCallMeBackTimeDropdownSelection = this.handleCallMeBackTimeDropdownSelection.bind(this);
        this.handleCallMeBackDropdownToggle = this.handleCallMeBackDropdownToggle.bind(this);
        this.handleCallMeBackTimeDropdownToggle = this.handleCallMeBackTimeDropdownToggle.bind(this);
        this.handleFnolCallMeBackDropdownToggle = this.handleFnolCallMeBackDropdownToggle.bind(this);
        this.handlePreferredLanguageSelection = this.handlePreferredLanguageSelection.bind(this);
        this.handlePreferredLanguageDropdownToggle = this.handlePreferredLanguageDropdownToggle.bind(this);
        this.handleUpdateCustomerInfo = this.handleUpdateCustomerInfo.bind(this);
        this.handleDonate = this.handleDonate.bind(this);
        this.handleReferFriend = this.handleReferFriend.bind(this);
        this.handleLinkPolicyLabelClick = this.handleLinkPolicyLabelClick.bind(this);
        this.handleCoverSelection = this.handleCoverSelection.bind(this);
        this.handleTaxCoverSelection = this.handleTaxCoverSelection.bind(this);
        this.handleCoverDropdownToggle = this.handleCoverDropdownToggle.bind(this);
        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.changeEndTaxDate = this.changeEndTaxDate.bind(this);
        this.changeStartTaxDate = this.changeStartTaxDate.bind(this);
        this.handleSignOutAndRefresh = this.handleSignOutAndRefresh.bind(this);
        this.handlePaymentType = this.handlePaymentType.bind(this);
        this.handleCreditShortfallDateChange = this.handleCreditShortfallDateChange.bind(this);
        this.handleAddVap = this.handleAddVap.bind(this);
        this.handleAddAccessorry = this.handleAddAccessorry.bind(this);
        this.handleAddCreditShortfall = this.handleAddCreditShortfall.bind(this);
        this.handleAddVapCarHire = this.handleAddVapCarHire.bind(this);
        this.handleVapItemSelect = this.handleVapItemSelect.bind(this);
        this.handleVapItemDropdownToggle = this.handleVapItemDropdownToggle.bind(this);
        this.handleRemoveAccessorry = this.handleRemoveAccessorry.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleRemoveVapCarHire = this.handleRemoveVapCarHire.bind(this);
        this.handleEditVapCarHire = this.handleEditVapCarHire.bind(this);
        this.handleRemoveVap = this.handleRemoveVap.bind(this);
        this.handleUpdateCreditShortfall = this.handleUpdateCreditShortfall.bind(this);
        this.handleRemoveQuoteItem = this.handleRemoveQuoteItem.bind(this);
        this.handleAcceptBankingDetails = this.handleAcceptBankingDetails.bind(this);
        this.handleCancelledClick = this.handleCancelledClick.bind(this);
        this.handleRefusedClick = this.handleRefusedClick.bind(this);
        this.handleAdvisedClick = this.handleAdvisedClick.bind(this);
        this.handleSpecialTermsClick = this.handleSpecialTermsClick.bind(this);
        this.handleCriminalOffenceClick = this.handleCriminalOffenceClick.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleAcceptLegalClick = this.handleAcceptLegalClick.bind(this);
        this.setInEdit = this.setInEdit.bind(this);
        this.handleCallMeBackPopup = this.handleCallMeBackPopup.bind(this);
        this.handleSelfInspectCoverSelection = this.handleSelfInspectCoverSelection.bind(this);
        this.handleSetSelfInspectCoverSelection = this.handleSetSelfInspectCoverSelection.bind(this);
        this.handleSubmitSelfInspect = this.handleSubmitSelfInspect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.setClaimDamagePhotoTypes = this.setClaimDamagePhotoTypes.bind(this);
        this.handleAddToReport = this.handleAddToReport.bind(this);
        this.handleContinueOnMobile = this.handleContinueOnMobile.bind(this);
        this.handleContinueClaim = this.handleContinueClaim.bind(this);
        this.handleContinueClaimDifferent = this.handleContinueClaimDifferent.bind(this);
        this.handleContinueClaimBack = this.handleContinueClaimBack.bind(this);
        this.handleContinueClaimNoSms = this.handleContinueClaimNoSms.bind(this);
        this.handleClaimShowDifferent = this.handleClaimShowDifferent.bind(this);
        this.handlePhoneClaimsComeback = this.handlePhoneClaimsComeback.bind(this);
        this.handleCancelClaimContinue = this.handleCancelClaimContinue.bind(this);
        this.handleChangeFnolCallBackDescription = this.handleChangeFnolCallBackDescription.bind(this);
        this.handleFnolCallMeBack = this.handleFnolCallMeBack.bind(this);
        this.handleFnolCallMeBackDropdownSelection = this.handleFnolCallMeBackDropdownSelection.bind(this);
        this.checkDamageArr = this.checkDamageArr.bind(this);
        this.handleCheckDuplicateClaim = this.handleCheckDuplicateClaim.bind(this);
        this.handleNotDrivable = this.handleNotDrivable.bind(this);
        this.handleHideModalDamageReport = this.handleHideModalDamageReport.bind(this);
        this.handleSubmitFNOL = this.handleSubmitFNOL.bind(this);
        this.handleTakeFNOLPhoto = this.handleTakeFNOLPhoto.bind(this);
        this.handleContinueOnPhone = this.handleContinueOnPhone.bind(this);
        this.handleToggleTC = this.handleToggleTC.bind(this);
        this.referAgain = this.referAgain.bind(this);
        this.handleSwichToPhoneSendSms = this.handleSwichToPhoneSendSms.bind(this);
        this.showFNOLCallMeBack = this.showFNOLCallMeBack.bind(this);
        this.handleDamageReportCallBack = this.handleDamageReportCallBack.bind(this);
        this.handleWeWillGetBackToYouAsap = this.handleWeWillGetBackToYouAsap.bind(this);
        this.handleDisclaimerContinue = this.handleDisclaimerContinue.bind(this);
        this.handleSubmitGlassClaim = this.handleSubmitGlassClaim.bind(this);
        this.handlePortableCallBack = this.handlePortableCallBack.bind(this);
        this.handleCallBack = this.handleCallBack.bind(this);
        this.handleHideModalToDashboard = this.handleHideModalToDashboard.bind(this);
        this.handleModalToDashboardDiscardCart = this.handleModalToDashboardDiscardCart.bind(this);
        this.handleDiscardCart = this.handleDiscardCart.bind(this);
        this.handleRemoveUnaddedQuoteItem = this.handleRemoveUnaddedQuoteItem.bind(this);
        this.handleSendIMEINumber = this.handleSendIMEINumber.bind(this);
        this.handleChangeNumbers = this.handleChangeNumbers.bind(this);
        this.handleDrivableClaimOther = this.handleDrivableClaimOther.bind(this);
        this.handleDrivableClaimRecord = this.handleDrivableClaimRecord.bind(this);
        this.handleRepairers = this.handleRepairers.bind(this);
        this.handleCloseDrivable = this.handleCloseDrivable.bind(this);
        this.handlePolicyUpdate = this.handlePolicyUpdate.bind(this);
        this.handleRemoveCoverReasons = this.handleRemoveCoverReasons.bind(this);
        this.handleIsInEditRemoveClick = this.handleIsInEditRemoveClick.bind(this);
        this.handlePrimaryReasonSelection = this.handlePrimaryReasonSelection.bind(this);
        this.handleSecondaryReasonSelection = this.handleSecondaryReasonSelection.bind(this);
        this.handleRemoveVapReason = this.handleRemoveVapReason.bind(this);
        this.handlePhoneInspectionComeback = this.handlePhoneInspectionComeback.bind(this);
        this.handleChangeContinueOnPhone = this.handleChangeContinueOnPhone.bind(this);
        this.handleClearParties = this.handleClearParties.bind(this);
        this.handleFacebookLogin = this.handleFacebookLogin.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.handleAppleLogin = this.handleAppleLogin.bind(this);
    }

    async handleClearParties(partyType: string, reducerName: string) {
        await this.props.dispatchAction(updateClaimPartyReducer(partyType, 'clear'));
        this.props.dispatchAction(setFnolReducer(reducerName, false));
        this.props.dispatchHideModal();
    }

    async handlePolicyUpdate(e: any) {
        let value = e.target.value;
        await this.props.dispatchGetQuoteCancellationReasons();
        await this.props.dispatchEditPolicy(this.props.modal.modalProps.productType, this.props.modal.modalProps.filterItem);
    }

    async handleCallBack(e: any) {
        var nameValid;
        var fullName;
        var cellPhoneNr;
        var phoneValid;
        if (this.props.profile.name !== "") {
            nameValid = await validateName.test((this.props.profile.name + ' ' + this.props.profile.surname));
            fullName = (this.props.profile.name + ' ' + this.props.profile.surname);
            cellPhoneNr = this.props.profile.cellphoneNumber !== "" ? this.props.profile.cellphoneNumber : this.props.profile.alternateNumber;
            phoneValid = await validateCellphoneNumber.test(cellPhoneNr);

            await this.setState({ callBackSubmitted: true, nameRegex: nameValid, cellphoneNumberRegex: phoneValid });
            if (this.state.nameRegex && this.state.cellphoneNumberRegex) {
                this.props.dispatchCallMeBack(fullName, cellPhoneNr, this.state.callMeBackDropdownSelection, this.state.callMeBackTimeDropdownSelection, true, "portable");
                this.props.dispatchHideModal();
            }
        } else {
            nameValid = await validateName.test((this.props.sales.name + ' ' + this.props.sales.surname));
            fullName = (this.props.sales.name + ' ' + this.props.sales.surname);
            cellPhoneNr = this.props.sales.cellphoneNumber;
            phoneValid = await validateCellphoneNumber.test(cellPhoneNr);

            await this.setState({ callBackSubmitted: true, nameRegex: nameValid, cellphoneNumberRegex: phoneValid });
            if (this.state.nameRegex && this.state.cellphoneNumberRegex) {
                this.props.dispatchCallMeBack(fullName, cellPhoneNr, this.state.callMeBackDropdownSelection, this.state.callMeBackTimeDropdownSelection, true, "portable");
                this.props.dispatchHideModal();
            }
        }
    }

    async handlePortableCallBack(e: any) {
        var nameValid;
        var fullName;
        var cellPhoneNr;
        var phoneValid;
        if (this.props.profile.name !== "") {
            nameValid = await validateName.test((this.props.profile.name + ' ' + this.props.profile.surname));
            fullName = (this.props.profile.name + ' ' + this.props.profile.surname);
            cellPhoneNr = this.props.profile.cellphoneNumber !== "" ? this.props.profile.cellphoneNumber : this.props.profile.alternateNumber;
            phoneValid = await validateCellphoneNumber.test(cellPhoneNr);

            await this.setState({ callBackSubmitted: true, nameRegex: nameValid, cellphoneNumberRegex: phoneValid });
            if (this.state.nameRegex && this.state.cellphoneNumberRegex) {
                this.props.dispatchCallMeBack(fullName, cellPhoneNr, this.state.callMeBackDropdownSelection, this.state.callMeBackTimeDropdownSelection, true, "portable");
                this.props.dispatchDiscardCartPortable();
                this.props.dispatchHideModal();
            }
        } else {
            nameValid = await validateName.test((this.props.sales.name + ' ' + this.props.sales.surname));
            fullName = (this.props.sales.name + ' ' + this.props.sales.surname);
            cellPhoneNr = this.props.sales.cellphoneNumber;
            phoneValid = await validateCellphoneNumber.test(cellPhoneNr);

            await this.setState({ callBackSubmitted: true, nameRegex: nameValid, cellphoneNumberRegex: phoneValid });
            if (this.state.nameRegex && this.state.cellphoneNumberRegex) {
                this.props.dispatchCallMeBack(fullName, cellPhoneNr, this.state.callMeBackDropdownSelection, this.state.callMeBackTimeDropdownSelection, true, "portable");
                this.props.dispatchDiscardCartPortable();
                this.props.dispatchHideModal();
            }
        }
    }

    async handleDiscardCart() {
        this.props.dispatchDiscardCartPortable();
        this.props.dispatchHideModal();
    }

    showFNOLCallMeBack() {
        this.props.dispatchFnolCallMeModal();
    }

    async handleSwichToPhoneSendSms() {
        var phoneValid = await validateCellphoneNumber.test(this.state.swichToPhoneNumber);
        await this.setState({ cellphoneNumberRegex: phoneValid, swichToPhoneSubmitted: true });
        if (this.state.cellphoneNumberRegex) {
            this.props.dispatchSendSMS(this.state.swichToPhoneNumber);
            this.props.dispatchshowSMSsent();
        }
    }

    async referAgain() {
        await this.setState({
            referFullname: "",
            referSurname: "",
            referPhoneNumber: "",
            acceptedTCs: "",
        });
        this.props.showReferFriend();
    }

    async handleToggleTC(e: any) {
        await this.setState({ acceptedTCs: e.target.checked });
    }

    async handleContinueOnPhone() {
        await this.props.dispatchSetContinueOnMobile();
        await this.props.dispatchSetStep(1, 3);
        this.props.dispatchHideModal();
    }

    handleChangeFnolCallBackDescription(e: any) {

        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    async handleAddToReport() {
        let data = this.state.modalDamagePhotoTypes;
        for (var i = 0; i < data.length; i++) {
            this.props.dispatchSaveDamageSelected(data[i])
        }
        this.setState({ modalDamagePhotoTypes: [] });
        this.props.dispatchHideModal();
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    handleNotDrivable() {
        this.handleRedirect(CLAIMS_IN_THE_MEANTIME);
        this.props.dispatchSubmitFNOLNotDriveable();
        this.props.dispatchHideModal();
    }

    async handleContinueClaim() {
        await this.setState({
            claimContinuePhoneNumberIsBusy: true,
        });
        await this.setState({
            cellphoneNumberRegex: validateCellphoneNumber.test(this.state.claimContinuePhoneNumber),
        });
        if (this.state.cellphoneNumberRegex) {
            if (this.props.modal.modalProps.isSelfInspect) {
                await this.props.dispatchLogInspectionContinueOnPhone();
                this.props.dispatchSendSMSInspection(this.state.claimContinuePhoneNumber);
                this.props.dispatchHideModal();
                this.props.dispatchShowInspectionContinueSuccess();
            }
            else {
                await this.props.dispatchLogContinueOnPhone();
                await this.props.dispatchSendSMS(this.state.claimContinuePhoneNumber);
                this.props.dispatchHideModal();
                this.props.dispatchShowClaimContinueSuccess();
            }
        }
        await this.setState({
            claimContinuePhoneNumberIsBusy: false,
        });
    }

    async handleContinueClaimDifferent() {
        await this.setState({
            claimContinuePhoneNumberError: validateCellphoneNumber.test(this.state.claimContinuePhoneNumber),
            claimContinuePhoneNumberSubmitted: true,
            claimContinuePhoneNumberIsBusy: true,
        });

        if (this.state.claimContinuePhoneNumberError) {
            this.setState({ claimContinuePhoneNumberError: false });
            await this.props.dispatchLogContinueOnPhone();
            await this.props.dispatchSendSMS(this.state.claimContinuePhoneNumber);
            this.props.dispatchHideModal();
            this.props.dispatchShowClaimContinueSuccess();
        }
        await this.setState({
            claimContinuePhoneNumberIsBusy: false,
        });
    }

    async handleClaimShowDifferent() {
        this.props.dispatchHideModal();
        this.props.dispatchShowContinueOnPhoneDifferent();
    }

    async handleContinueClaimBack() {
        this.props.dispatchHideModal();
        this.props.dispatchShowContinueOnPhone(this.props.profile.cellphoneNumber);
    }

    async handlePhoneClaimsComeback() {
        this.props.dispatchGetContinueAndSetData();
        this.props.dispatchHideModal();
    }

    async handlePhoneInspectionComeback() {
        this.props.dispatchGetInspectionContinueAndSetData();
        this.props.dispatchHideModal();
    }

    async handleCancelClaimContinue() {
        this.props.dispatchRemoveNotifyFlag();
        this.props.dispatchHideModal();
    }

    async handleContinueClaimNoSms() {
        this.props.dispatchLogContinueOnPhone();
        this.props.dispatchHideModal();
        this.props.dispatchShowClaimContinueSuccess();
    }

    handleContinueOnMobile() {
        this.props.dispatchHideModal();
        this.props.redirectTo(FNOL_CLAIM_DETAILS_MOBILE);
    }

    async handleCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedCover: coverItem[0] });
    }

    async setClaimDamagePhotoTypes(data: any) {
        await this.props.dispatchSaveDamageSelected(data.description)
        await this.setState({ modalDamagePhotoTypes: [...this.state.modalDamagePhotoTypes, data.description] });
    }

    checkChecked(e: any) {
        var set = this.props.claimSubmit.selectedDamagePhotoTypes.find((el => el.description == e));
        if (set) {
            return ("/my-policy/Images/Claims/grey-checkmark-checked.png");
        } else {
            return ("/my-policy/Images/Claims/grey-checkmark-unchecked.png");
        }
    }

    async handleSetSelfInspectCoverSelection(e: any) {
        if (this.state.selectedSelfInspectCover) {
            this.props.dispatchHideModal();
            await this.props.dispatchSetSelectedCoverSelfInspect(this.state.selectedSelfInspectCover.id)
            this.props.redirectTo(SELF_INSPECTION)
        }
    }

    async handleTaxCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedTaxCover: coverItem[0] });
    }

    async handleSelfInspectCoverSelection(e: any) {
        let coverItem = this.props.profile.personalPolicies[0].covers.filter(function (item) {
            return item.id == e
        })
        await this.setState({ selectedSelfInspectCover: coverItem[0] });
    }

    async handleCoverDropdownToggle(e: any) {
        await this.setState({
            coverToggle: !this.state.coverToggle
        });
    }

    changeStartDate(date) {
        this.setState({
            startDate: date
        });
    }

    changeEndDate(date) {
        this.setState({
            endDate: date
        });
    }

    changeStartTaxDate(date) {
        this.setState({
            startDateTax: date
        });
    }

    changeEndTaxDate(date) {
        this.setState({
            endDateTax: date
        });
    }

    handleShowModal() {
        if (this.props.modal.modalProps.accessory !== undefined) {
            this.setState({
                replacementValue: this.props.modal.modalProps.accessory.replacementValue.toString() === "0" ? 2000 : this.props.modal.modalProps.accessory.replacementValue
            });
        }
        if (this.props.modal.modalProps.continueNumber) {
            var phoneValid = validateCellphoneNumber.test(this.props.modal.modalProps.continueNumber);

            this.setState({
                claimContinuePhoneNumberError: phoneValid,
                claimContinuePhoneNumber: this.props.modal.modalProps.continueNumber
            });
        }
        if (this.props.profile && this.props.profile.cellphoneNumber) {
            this.setState({
                swichToPhoneNumber: this.props.profile.cellphoneNumber,
                phoneNumber: this.props.profile.cellphoneNumber,
            });
        }
        if (this.props.profile && this.props.profile.name && this.props.profile.surname) {
            this.setState({
                fullname: this.props.profile.name + " " + this.props.profile.surname,
                phoneNumber: this.props.profile.cellphoneNumber,
            });
        }
        if (this.props.profile.email.toLowerCase() === "nomail@kingprice.co.za") {
            this.setState({ documentMail: "" });
        } else {
            this.setState({ documentMail: this.props.profile.email });
        }
    }

    componentDidMount() {

        this.setState({
            endDate: "", startDate: ""
        });
        if (this.props.modal.modalProps.accessory !== undefined) {
            this.setState({
                replacementValue: this.props.modal.modalProps.accessory.replacementValue.toString() === "0" ? 2000 : this.props.modal.modalProps.accessory.replacementValue
            });
        }
        if (this.state.legalList.length === 0) {
            this.getLegalQuestion();
        }

        if (this.props.modal.modalProps.continueNumber) {
            this.setState({
                claimContinuePhoneNumber: this.props.modal.modalProps.continueNumber
            });
        }

        if (this.props.profile && this.props.profile.cellphoneNumber) {
            this.setState({
                swichToPhoneNumber: this.props.profile.cellphoneNumber
            });
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value })
    }

    async handleChangeContinueOnPhone(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        var phoneValid = await validateCellphoneNumber.test(value);

        await this.setState({
            [name]: value,
            claimContinuePhoneNumberError: phoneValid,
            claimContinuePhoneNumberSubmitted: true
        })
    }

    async handleChangeNumbers(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        value = value.replace(/[^0-9]/gi, "");
        await this.setState({ [name]: value })
    }

    handleHideModal() {
        const { modal } = this.props;
        this.setState({ acceptedTCs: false });
        if (modal.modalProps.type == MODAL_TYPE_REMOVE_COVER_COMPLETE || modal.modalProps.type == MODAL_TYPE_REMOVE_LAST_COVER || modal.modalProps.type == MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS) {
            this.handleHideModalToDashboard(undefined);
        }
        else {
            if (this.props.modal.modalProps.type === MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE) { //Continue claim on phone
                this.props.dispatchInspectionRemoveNotifyFlag();
            }
            this.props.dispatchHideModal();
        }
    }

    async handleSendIMEINumber(e: any) {
        var IMEINumberValid = this.state.IMEINumber.length == 15;
        await this.setState({ IMEINumberRegex: IMEINumberValid, IMEINumberSubmitted: true });
        if (this.state.IMEINumberRegex) {
            this.props.dispatchSendIMEINumber(this.state.IMEINumber);
            await this.props.dispatchHideModal();
        }
    }

    handleHideModalToDashboard(e: any) {
        this.props.dispatchHideModal();
        this.props.redirectTo(DASHBOARD);
    }

    async handleModalToDashboardDiscardCart() {
        this.props.dispatchDiscardCartPortable();
        this.props.redirectTo(DASHBOARD);
        this.props.dispatchHideModal();
    }

    async handleHideModalDamageReport(e: any) {
        await this.setState({ modalDamagePhotoTypes: [] });
        this.props.dispatchHideModal();
    }

    handleRetryOTP(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchShowVerifyOTPModal();
    }

    handleSignOutAndRefresh(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchRefreshCacheAndReload();
    }

    handleLinkPolicyLabelClick(LinkMethod) {
        this.setState({ policyLinkMethod: LinkMethod });
    }

    handleSignOut(e: any) {
        this.props.dispatchSignOut();
    }

    handleWeWillGetBackToYouAsap() {
        this.props.dispatchLifeRequestCancellation();
    }

    handleGetOTP(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchGetOTP(this.state.OTPToPhone);
    }

    handleResendOTP(e: any) {
        this.setState({ OTPToPhone: true });
        this.props.dispatchHideModal();
        this.props.dispatchResendOTP();
    }

    handleSendDocument(e: any) {
        this.props.dispatchResendOTP();
        this.props.dispatchHideModal();
    }

    async handleVerifyOTP(e: any) {
        var otpValid = await validateOTP.test(this.state.OTP);
        await this.setState({ OTPSubmitted: true, otpRegex: otpValid });
        if (this.state.otpRegex === true) {
            this.props.dispatchVerifyOTP(this.state.OTP);
        }
    }

    async handleVerifyOTPLife(e: any) {
        var otpValid = await validateOTP.test(this.state.OTP);
        await this.setState({ OTPSubmitted: true, otpRegex: otpValid });
        if (this.state.otpRegex === true) {
            this.props.dispatchVerifyOTPLife(this.state.OTP);
        }
    }

    async handleRequestLifeDocument() {
        await this.setState({ documentMailRegex: true, requestError: false, documentSubmitted: true });
        if (validateEmail.test(this.state.documentMail)) {
            await this.props.dispatchRequestLifeDocument({ Email: this.state.documentMail, DocumentName: this.props.modal.modalProps.document })
        } else {
            await this.setState({ documentMailRegex: false, documentSubmitted: true });
        }
    }

    async handleRequestDocument() {
        if (this.props.modal.modalProps.document === DOC_LIFE_POLICY_DOCUMENT) {
            return this.handleRequestLifeDocument();
        }
        await this.setState({ documentMailRegex: true, requestError: false, documentSubmitted: true });
        var dateStart = "";
        var dateEnd = "";
        var cover = "";
        if (validateEmail.test(this.state.documentMail)) {
            if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER) {
                if (this.state.selectedCover === null || this.state.documentMail === "") {
                    await this.setState({ requestError: true });
                }
            }
            else if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER_DATE) {
                if (this.state.selectedCover === null || this.state.endDate === "" || this.state.startDate === "" || this.state.documentMail === "") {
                    await this.setState({ requestError: true });
                }
            }
            else if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_DATE) {
                if (this.state.startDateTax === "" || this.state.endDateTax === "" || this.state.documentMail === "" || this.state.selectedTaxCover === null) {
                    await this.setState({ requestError: true });
                }
            }
            else {
                if (this.state.documentMail === "") {
                    await this.setState({ requestError: true });
                }
            }
            if (this.state.requestError === false) {
                if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_DATE) {
                    dateStart = this.state.startDateTax;
                    dateEnd = this.state.endDateTax;
                    cover = this.state.selectedTaxCover?.id ?? ""
                }
                else if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER) {
                    dateStart = this.state.startDate;
                    dateEnd = this.state.endDate;
                    cover = this.state.selectedCover?.id ?? ""
                }
                else if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER_DATE) {
                    dateStart = this.state.startDate;
                    dateEnd = this.state.endDate;
                    cover = this.state.selectedCover?.id ?? ""
                }

                if (this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER && this.state.selectedCover.productName === "Motorbike") {
                    await this.props.dispatchRequestDocument({ Email: this.state.documentMail, DocumentId: CONFIRMATION_OF_COVER_MOTORBIKE, StartDate: dateStart, EndDate: dateEnd, CoverId: cover })
                }
                else if(this.props.modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER_DATE && this.props.modal.modalProps.documentId === CROSS_BORDER_CAR && this.state.selectedCover.productName === "Motorbike"){
                    await this.props.dispatchRequestDocument({ Email: this.state.documentMail, DocumentId: CROSS_BORDER_MOTORBIKE, StartDate: dateStart, EndDate: dateEnd, CoverId: cover })
                }
                else {
                    await this.props.dispatchRequestDocument({ Email: this.state.documentMail, DocumentId: this.props.modal.modalProps.documentId, StartDate: dateStart, EndDate: dateEnd, CoverId: cover })
                }
            }
        }
        else {
            await this.setState({ documentMailRegex: false, documentSubmitted: true });
        }
    }

    async handleReferFriend(e: any) {
        e.preventDefault();
        await this.setState({
            referFriendSubmitted: true,
            nameRegex: validateName.test(this.state.referFullname),
            cellphoneNumberRegex: validateCellphoneNumber.test(this.state.referPhoneNumber),
        });

        if (this.state.nameRegex &&
            this.state.cellphoneNumberRegex) {
            this.props.dispatchReferFriend(this.state.referFullname, '', this.state.referPhoneNumber);
        }
    }

    async handleUpdateCustomerInfo(e: any) {
        switch (this.props.modal.modalProps.field) {
            case FIELD_PHONENUMBER:
                this.props.dispatchUpdateInfo(this.props.modal.modalProps.field, this.state.phoneNumber)
                break;
            case FIELD_EMAIL:
                this.props.dispatchUpdateInfo(this.props.modal.modalProps.field, this.state.email)
                break;
            case FIELD_ALTPHONENUMBER:
                this.props.dispatchUpdateInfo(this.props.modal.modalProps.field, this.state.altPhoneNumber)
                break;
            case FIELD_PREFERREDLANGUAGE:
                this.props.dispatchUpdateInfo(this.props.modal.modalProps.field, this.state.preferredLanguageSelection)
                break;
            default:
        }
        this.props.dispatchHideModal();
    }

    async handleOTPMethodChange(e: any) {
        await this.setState({ OTPToPhone: !this.state.OTPToPhone });
    }

    handleCallMeFromOTP(e: any) {
        logEvent('SSP_User_selected_Call_me_option_from_OTP', {});
        this.props.dispatchHideModal();
        this.props.dispatchCallMeModal();
    }

    handleRequestDoc(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchCallMeModal();
    }

    async handleCallMeBackPopup(e: any) {
        this.props.dispatchHandleCallMeBack()
    }

    async handleCallMeBack(isLegalPage: boolean) {

        var cellPhoneNr = (this.state.phoneNumber && this.state.phoneNumber !== "") ? this.state.phoneNumber : this.props.sales.cellphoneNumber;

        var fullname = (this.state.fullname && this.state.fullname !== "") ? this.state.fullname : this.props.sales.name + ' ' + this.props.sales.surname;

        var nameValid = await validateName.test(fullname);
        var phoneValid = await validateCellphoneNumber.test(cellPhoneNr);
        await this.setState({ callBackSubmitted: true, nameRegex: nameValid, cellphoneNumberRegex: phoneValid });
        if (this.state.nameRegex === true && this.state.cellphoneNumberRegex === true) {
            this.props.dispatchHideModal();
            this.props.dispatchCallMeBack(fullname, cellPhoneNr, this.state.callMeBackDropdownSelection, this.state.callMeBackTimeDropdownSelection);

            if (isLegalPage) this.handleDiscardCart();
        }
    }

    async handleFnolCallMeBack(e: any) {

        var comments = this.state.fnolCallBackDescription;

        var fullName = this.props.profile.name + " " + this.props.profile.surname;

        var cellphoneNumber = this.props.profile.cellphoneNumber;

        var department = this.state.fnolCallMeBackDropdownSelection;

        if (department === "I want to talk to a claims consultant") {
            department = "claims_consultant";
        }

        if (department === "I need technical assistance") {
            department = "tecnical_assistance";
        }

        if (department === "I want to talk to 1 of your legal advisors") {
            department = "legal_advisor";
        }


        await this.setState({ fnolCallBackSubmitted: true });
        if (this.state.fnolCallBackSubmitted) {
            this.props.dispatchHideModal();
            this.props.dispatchFnolCallMeBack(fullName, cellphoneNumber, comments, department);
        }
    }

    async handleCallMeBackClaims(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchCallMeBack(this.state.fullname, this.state.phoneNumber, 'Claims', false);
        //this.props.redirectTo(CLAIMS_IN_THE_MEANTIME);
    }

    async handleDamageReportCallBack(e: any) {
        this.props.dispatchHideModal();
        this.props.dispatchDamageReportCallBack(this.state.fullname, this.state.phoneNumber, 'Claims', false);
    }

    async handleCallMeBackDropdownSelection(e: any) {
        await this.setState({ callMeBackDropdownSelection: e });
    }

    async handleCallMeBackTimeDropdownSelection(e: any) {
        await this.setState({ callMeBackTimeDropdownSelection: e });
    }

    async handleFnolCallMeBackDropdownSelection(e: any) {
        await this.setState({ fnolCallMeBackDropdownSelection: e });
    }

    async handleSubmitFNOL(e: any) {
        if (!this.props.ssp.drivableClaimsEnabled) {
            this.props.dispatchSubmitFNOL();
            this.props.dispatchHandleNextStep();
            this.props.dispatchHandleNextStep();
            this.props.dispatchHideModal();
        } else {
            this.props.dispatchHandleNextStep();
            this.props.dispatchHandleNextStep();
            this.props.dispatchHideModal();
        }
    }

    async handleTakeFNOLPhoto(e: any) {
        await this.props.dispatchSetStep(6, 1);
        this.props.dispatchHideModal();
    }

    async handleCallMeBackDropdownToggle() {
        await this.setState({
            callMeBackDropdownOpen: !this.state.callMeBackDropdownOpen,
            callMeBackDropdownImage: 'Images/red-arrow-down-24-px.svg',
        });
        if (this.state.callMeBackDropdownOpen === true) {
            await this.setState({
                callMeBackDropdownImage: 'Images/red-arrow-up-24-px.svg',
            });
        } else {
            await this.setState({
                callMeBackDropdownImage: 'Images/red-arrow-down-24-px.svg',
            });
        }
    }

    async handleCallMeBackTimeDropdownToggle() {
        await this.setState({
            callMeBackTimeDropdownOpen: !this.state.callMeBackTimeDropdownOpen,
        });
    }

async handleFnolCallMeBackDropdownToggle() {
        await this.setState({
            callMeBackDropdownOpen: !this.state.callMeBackDropdownOpen,
            callMeBackDropdownImage: 'Images/red-arrow-down-24-px.svg',
        });
        if (this.state.callMeBackDropdownOpen === true) {
            await this.setState({
                callMeBackDropdownImage: 'Images/red-arrow-up-24-px.svg',
            });
        } else {
            await this.setState({
                callMeBackDropdownImage: 'Images/red-arrow-down-24-px.svg',
            });
        }
    }

    async handlePreferredLanguageSelection(e: any) {
        await this.setState({ preferredLanguageSelection: e });
    }

    async handlePreferredLanguageDropdownToggle() {
        await this.setState({
            preferredLanguageDropdownOpen: !this.state.preferredLanguageDropdownOpen,
        });
    }

    handleLinkType(e: any) {
        let value = e.target.value;
        this.setState({ policyLinkMethod: value });
    }

    handlePaymentType(e: any) {
        let value = e.target.value;
        this.setState({ paymentMethod: value });
    }

    async linkCustomerPolicies(e: any) {

        if (this.state.policyLinkMethod === LINK_POLICYNR) {
            var policyValid = false;
            if (this.state.policyNr.toUpperCase().startsWith('KP') || this.state.policyNr.toUpperCase().startsWith('KPT')) {
                policyValid = true;
            }
            await this.setState({ linkPolicySubmitted: true, policyRegex: policyValid });
            if (this.state.policyRegex === true) {
                this.props.dispatchHideModal();
                this.props.dispatchLinkCustomer(this.state.policyNr);
            }
        }
        else if (this.state.policyLinkMethod === LINK_IDNUMBER) {
            var idValid = await validateIdNumber.test(this.state.idNumber);
            await this.setState({ linkPolicySubmitted: true, idRegex: idValid });
            if (this.state.idRegex === true) {
                this.props.dispatchHideModal();
                this.props.dispatchLinkCustomer(this.state.idNumber);
            }
        } else if (this.state.policyLinkMethod === LINK_LIFE_POLICYNR) {
            let policyValid = false;
            if (this.state.lifePolicyNr.toUpperCase().startsWith('KP')) {
                policyValid = true;
            }
            await this.setState({ linkPolicySubmitted: true, lifePolicyRegex: policyValid });
            if (this.state.lifePolicyRegex === true) {
                this.props.dispatchHideModal();
                this.props.dispatchLinkLifeCustomer(this.state.lifePolicyNr);
            }
        } else {
            var idValid = await validateIdNumber.test(this.state.idNumber);
            await this.setState({ linkPolicySubmitted: true, idRegex: idValid });
            if (this.state.idRegex === true) {
                this.props.dispatchHideModal();
                this.props.dispatchLinkCustomer(this.state.idNumber);
            }
        }
    }

    handleDonate(e: any) {
        this.props.dispatchDonateDecreaseToOrganization(this.props.modal.modalProps.donationId, this.props.modal.modalProps.charityName, this.props.modal.modalProps.charityImage);
        this.props.dispatchHideModal();
    }

    async handleCreditShortfallDateChange(date) {
        this.setState({
            selectedCreditShortfallDate: date
        });
    }

    async handleAddAccessorry() {
        let currency = this.props.profile.currencySymbol
        if (this.state.accessorryReplacementValue < 2000) {
            await this.setState({ accessoryError: true, accessoryErrorDescription: "Minimum of " + currency + " 2,000 per item." });
        }
        else if (this.state.accessorryReplacementValue > 50000) {
            await this.setState({ accessoryError: true, accessoryErrorDescription: "Maximum of " + currency + " 50,000 per item." });
        }
        else if (((this.props.sales.carDetails.retailValue * 0.5) < ((Number(this.props.sales.accessoryValue) - Number(this.props.modal.modalProps.accessory.replacementValue)) + Number(this.state.accessorryReplacementValue)))) {
            await this.setState({ accessoryError: true, accessoryErrorDescription: "Sum of accessories must not be more than 50% of the retail value of the car" });
        }
        else {
            await this.props.dispatchAddAccessoryToQoute(this.props.modal.modalProps.accessory, this.state.accessorryReplacementValue)
            await this.setState({ accessorryReplacementValue: "2000", accessoryError: false, accessoryErrorDescription: "" });
        }
    }

    async handleRemoveAccessorry() {
        this.props.dispatchRemoveAccessoryFromQuote(this.props.modal.modalProps.accessory)
        await this.setState({ accessorryReplacementValue: "2000" });
    }

    async handleAddVap() {
        this.props.dispatchAddVapToQuote(this.props.modal.modalProps.vap, "A")
    }

    async handleRemoveVap() {
        this.props.dispatchRemoveVapOnQuote(this.props.modal.modalProps.vap)
    }

    async handleAddVapCarHire() {
        await this.setState({ vapSubmitted: true });
        if (this.state.selectedVap.id) {
            let productCode = this.state.selectedVap.id
            switch (this.state.selectedVap.id) {
                case "1":
                    productCode = "A"
                    break;
                case "2":
                    productCode = "B"
                    break;
                case "3":
                    productCode = "C"
                    break;
                case "4":
                    productCode = "D"
                    break;
                case "5":
                    productCode = "Y"
                    break;
                case "6":
                    productCode = "F"
                    break;
                case "7":
                    productCode = "J"
                    break;
                case "8":
                    productCode = "K"
                    break;
            }
            this.props.dispatchAddVapToQuote(this.props.modal.modalProps.vap, productCode)
            await this.setState({ selectedVap: "", vapSubmitted: false });
        }
    }

    async handleEditVapCarHire() {
        await this.setState({ vapSubmitted: true });
        if (this.state.selectedVap.id) {
            let productCode = this.state.selectedVap.id
            switch (this.state.selectedVap.id) {
                case "1":
                    productCode = "A"
                    break;
                case "2":
                    productCode = "B"
                    break;
                case "3":
                    productCode = "C"
                    break;
                case "4":
                    productCode = "D"
                    break;
                case "5":
                    productCode = "Y"
                    break;
                case "6":
                    productCode = "F"
                    break;
                case "7":
                    productCode = "J"
                    break;
                case "8":
                    productCode = "K"
                    break;
            }
            this.props.dispatchEditVapOnQuote(this.props.modal.modalProps.vap, productCode)
            await this.setState({ selectedVap: "", vapSubmitted: false });
        }
    }

    async handleRemoveVapCarHire() {
        this.props.dispatchRemoveVapOnQuote(this.props.modal.modalProps.vap);
        await this.setState({ selectedVap: "" });
    }

    async handleRemoveVapReason() {
        this.props.dispatchRemoveVapFromQuoteWithReasons(this.props.modal.modalProps.vap.quoteCoverId)
        await this.setState({ selectedVap: "" });
    }

    async handleAddCreditShortfall() {
        this.props.dispatchAddCreditShortfall(this.state.selectedVap.description, this.state.selectedCreditShortfallDate)
        await this.setState({ selectedVap: "" });
    }

    async handleUpdateCreditShortfall() {
        this.props.dispatchUpdateCreditShortfall(this.state.selectedVap.description, this.state.selectedCreditShortfallDate, this.props.modal.modalProps.vap)
        await this.setState({ selectedVap: "" });
    }

    async handleVapItemSelect(e: any) {
        /* eslint eqeqeq: "off" */
        let vapItem = this.props.modal.modalProps.vapList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedVap: vapItem[0] });
        this.setState({ nextDisabled: vapItem[0] === undefined });
    }

    async handleVapItemDropdownToggle(e: any) {
        await this.setState({
            selectedVapDropDown: !this.state.selectedVapDropDown
        });
    }
    async handleRemoveQuoteItem(e: any) {
        this.props.dispatchRemoveProductFromCart(e.target.value)
    }

    async handleAcceptBankingDetails(e: any) {
        this.props.dispatchShowLegalScreen()
    }

    async getLegalQuestion() {
        await postToController(this.props.dispatch, 'GetLegalQuestion', JSON.stringify({})).then(async (response) => {
            if (response != null) {
                await this.setState({ legalList: response });
                return true;
            } else {
                this.props.showErrorModal("Looks like something went wrong on our side... Please try again later")
            }
        })
    }

    async checkSubmit() {
        const { CancelledAnswer } = this.state;
        const { CriminalOffenceAnswer } = this.state;
        const { SpecialTermsAnswer } = this.state;
        const { RefusedAnswer } = this.state;
        const { AdvisedAnswer } = this.state;

        if (CancelledAnswer !== "" && CriminalOffenceAnswer !== "" && SpecialTermsAnswer !== "" && RefusedAnswer !== "" && AdvisedAnswer !== "") {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }

    async handleCancelledClick(e: any) {
        let answer = e.target.value
        await this.setState({
            CancelledYesState: answer === 'yes',
            CancelledNoState: answer === 'no',
            CancelledAnswer: answer
        });
        this.checkSubmit()
    }

    async handleCriminalOffenceClick(e: any) {
        let answer = e.target.value
        await this.setState({
            CriminalOffenceYesState: answer === 'yes',
            CriminalOffenceNoState: answer === 'no',
            CriminalOffenceAnswer: answer
        });
        this.checkSubmit()
    }

    async handleSpecialTermsClick(e: any) {
        let answer = e.target.value
        await this.setState({
            SpecialTermsYesState: answer === 'yes',
            SpecialTermsNoState: answer === 'no',
            SpecialTermsAnswer: answer
        });
        this.checkSubmit()
    }

    async handleRefusedClick(e: any) {
        let answer = e.target.value
        await this.setState({
            RefusedYesState: answer === 'yes',
            RefusedNoState: answer === 'no',
            RefusedAnswer: answer
        });
        this.checkSubmit()
    }

    async handleAdvisedClick(e: any) {
        let answer = e.target.value
        await this.setState({
            AdvisedYesState: answer === 'yes',
            AdvisedNoState: answer === 'no',
            AdvisedAnswer: answer
        });
        this.checkSubmit()
    }

    async handleRemoveCoverReasons(e: any) {
        await this.props.dispatchGetQuoteCancellationReasons();
        this.props.modal.modalProps.handleToggleReasons(true);

        this.props.dispatchIsInEditRemove(true);
        this.props.dispatchHideModal();
    }

    async handleIsFollowUpClick(id: any, destination: any) {
        if (id !== "") {
            this.props.dispatchSetSelectedCover(id);
            this.props.dispatchAction(setFnolReducer("followUp", false))
            this.props.dispatchIsInEdit(false);
            this.props.dispatchHideModal();
        }
        if (destination !== "" && destination !== REFER_A_FRIEND && destination !== CALL_ME_BACK && destination !== ADDCOVER) {
            await this.props.dispatchAction(setFnolReducer("followUp", false))
            this.props.redirectTo(destination);
            this.props.dispatchHideModal();
        } else if (destination === REFER_A_FRIEND) {
            this.props.showReferFriend();
        } else if (destination === CALL_ME_BACK) {
            this.props.dispatchHandleCallMeBack()
        } else if (destination === ADDCOVER) {
            this.props.dispatchShowAddNewItem();
        }
    }

    async handleIsInEditClick(id: any, destination: any) {

        if (id !== "") {
            this.props.dispatchSetSelectedCover(id);

            this.props.dispatchIsInEdit(false);

            this.props.dispatchHideModal();
        }
        if (destination !== "" && destination !== REFER_A_FRIEND && destination !== CALL_ME_BACK && destination !== ADDCOVER) {
            this.props.dispatchIsInEdit(false);
            this.props.redirectTo(destination);
            this.props.dispatchHideModal();
        } else if (destination === REFER_A_FRIEND) {
            this.props.showReferFriend();
        } else if (destination === CALL_ME_BACK) {
            this.props.dispatchHandleCallMeBack()
        } else if (destination === ADDCOVER) {
            this.props.dispatchShowAddNewItem();
        }
    }

    async handleIsInEditRemoveClick(id: any, destination: any) {
        if (id !== "") {
            this.props.dispatchSetSelectedCover(id);
            this.props.dispatchIsInEditRemove(false);
            this.props.dispatchHideModal();
        }

        if (destination !== "" && destination !== REFER_A_FRIEND && destination !== CALL_ME_BACK && destination !== ADDCOVER) {
            this.props.dispatchIsInEditRemove(false);
            this.props.redirectTo(destination);
            this.props.dispatchHideModal();
        } else if (destination === REFER_A_FRIEND) {
            this.props.showReferFriend();
        } else if (destination === CALL_ME_BACK) {
            this.props.dispatchHandleCallMeBack()
        } else if (destination === ADDCOVER) {
            this.props.dispatchShowAddNewItem();
        }
    }

    async handleRemoveUnaddedQuoteItem(id: any, destination: any) {
        await this.props.dispatchRemoveProductFromCartNavigate(this.props.sales.quoteScreenRiskId);
        if (destination !== "" && destination !== REFER_A_FRIEND && destination !== CALL_ME_BACK && destination !== ADDCOVER) {
            this.props.dispatchIsInEdit(false);
            this.props.dispatchSetIsOnQuoteScreen();
            this.props.redirectTo(destination);
            this.props.dispatchHideModal();
        } else if (destination === REFER_A_FRIEND) {
            this.props.showReferFriend();
        } else if (destination === CALL_ME_BACK) {
            this.props.dispatchHandleCallMeBack()
        } else if (destination === ADDCOVER) {
            this.props.dispatchShowAddNewItem();
        }
    }

    async handleSubmitSelfInspect() {
        await this.props.dispatchShowLoadingScreen();
        await this.props.dispatchHideModal();
        await this.props.dispatchSubmitSelfInspect();
        await this.props.dispatchHideLoadingScreen();
    }

    async handleAcceptLegalClick() {
        this.props.dispatchSetLegalQuestions(this.state.CriminalOffenceAnswer, this.state.SpecialTermsAnswer, this.state.RefusedAnswer, this.state.AdvisedAnswer, this.state.CancelledAnswer);
        if (this.state.CriminalOffenceAnswer === 'yes' || this.state.SpecialTermsAnswer === 'yes' || this.state.RefusedAnswer === 'yes' || this.state.AdvisedAnswer === 'yes' || this.state.CancelledAnswer === 'yes') {
            await postToController(this.props.dispatch, 'CreateExternalLeadRequest', JSON.stringify({
                FirstName: this.props.profile.name,
                ContactNumber: this.props.profile.cellphoneNumber,
                MobileNumber: this.props.profile.cellphoneNumber,
                Kpcid: this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? '100097' : '10005',
                Status: 'ACTIVE',
                Comments: 'Please call me',
                CountryId: this.props.profile.countryId,
            })).then((response) => {
                if (response === true) {
                    this.props.dispatchShowInterventionalModal("")
                }
                this.props.redirectTo(DASHBOARD);
            });
        }
        else {
            this.props.dispatchIsInEdit(false);
            if (this.props.profile.policyId === "") {
                this.props.dispatchCreatePolicy();
            } else if (this.props.cart.quote === "" && this.props.cart.quoteId === "") {

                this.props.dispatchAcceptQuote();

                this.props.dispatchUpdatePolicy();
            }
            else {
                this.props.dispatchUpdatePolicy();
            }
        }
    }

    async setInEdit() {
        this.props.dispatchHideModal();
        this.props.dispatchIsInEdit(false);
    }

    checkDamageArr(item, pos) {
        switch (pos) {
            case 'Front':
                return this.state.mbFront.indexOf(item) >= 0 ? true : false;
            case 'Front left':
                return this.state.mbFrontLeft.indexOf(item) >= 0 ? true : false;
            case 'Front right':
                return this.state.mbFrontRight.indexOf(item) >= 0 ? true : false;
            case 'Back left':
                return this.state.mbBackLeft.indexOf(item) >= 0 ? true : false;
            case 'Back right':
                return this.state.mbBackRight.indexOf(item) >= 0 ? true : false;
            case 'Back':
                return this.state.mbBack.indexOf(item) >= 0 ? true : false;
        }
    }

    async handleCheckDuplicateClaim() {
        await this.props.dispatchHideModal();
        await this.props.redirectTo(CLAIM_HISTORY_V2);
    }

    async handleDisclaimerContinue(e: any) {
        this.props.dispatchSetDisclaimer(true);
        this.handleHideModal();
    }
    async handleSubmitGlassClaim(e: any) {
        this.props.dispatchSubmitGlass();
        this.handleHideModal();
    }

    async handleDrivableClaimOther() {
        this.handleRedirect(CLAIM_END_PAGE);
        this.props.dispatchHideModal();
        await this.props.dispatchSubmitDrivableClaim(false, true);
    }

    async handleDrivableClaimRecord() {
        this.handleRedirect(CLAIM_END_PAGE);
        this.props.dispatchHideModal();
        await this.props.dispatchSubmitDrivableClaim(true, false);
    }

    handleRepairers() {
        this.props.dispatchHideModal();
        window.open(OUR_REPAIRERS, "_blank");
    }

    async handleCloseDrivable() {
        this.props.dispatchHideModal();
        await this.props.dispatchAction(updateOutcomeOnClaimRepudiate());
    }

    async handlePrimaryReasonSelection(e: any) {
        await this.setState({ showSecond: false })
        await this.props.dispatchSetQuoteCancellationReasons(e, undefined)
        await this.setState({ showSecond: true })
    }

    async handleSecondaryReasonSelection(e: any) {
        this.props.dispatchSetQuoteCancellationReasons(-1, e)
    }

    handleFacebookLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.dispatchAction(hideModal())
        this.props.signInWithFacebook()
    }

    handleGoogleLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.dispatchAction(hideModal())
        this.props.signInWithGoogle()
    }

    handleAppleLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.dispatchAction(hideModal())
        this.props.signInWithApple()
    }

    render() {
        var modalDamagePhotoTypes = [];

        /// Bling riskItem ///
        const profileState = this.props.profile;
        const cover = this.props.profile.selectedPersonalCover;
        let coverName;
        if (cover && cover !== undefined) {
            if (cover.product === 23) {
                coverName = cover.riskItems[0].blingScreenFixCovers[0];
            } else if (cover.product === 22) {
                coverName = cover.riskItems[0].blingLikeNewCovers[0];
            } else if (cover.product === 6) {
                coverName = profileState.selectedPortablePossession;
            }
        }

        const isMobile = window.innerWidth <= 975;

        let TC = SA_TC_LINK;
        if (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER) {
            TC = NAM_TC_LINK;
        }
        const { modal } = this.props;
        let languageDrop = '';
        if (modal.modalProps.field === FIELD_PREFERREDLANGUAGE) {
            languageDrop = modal.modalProps.languages.map((item) => {
                return <Dropdown.Item key={item} eventKey={item}>{item}</Dropdown.Item>
            });
        }
        let header = () => modal.modalProps.header;
        let body = () => modal.modalProps.body;
        let footer = () =>
            <Button className="btn btn-solid-red btn-lg justify-content-center w-100" onClick={this.handleHideModal} id='closeModal'>
                Okay
            </Button>

        let covers = <div></div>;
        let coversSelfInspect = <div></div>;

        /// Self Inspect Dropdown list ///
        if (this.props.profile.personalPolicies[0] !== undefined) {
            coversSelfInspect = this.props.profile.personalPolicies[0].covers
                .filter(cover => cover.isMainline === true &&
                    (cover.productName.startsWith("Car") || cover.productName.startsWith("Motorbike") || cover.productName.startsWith("Chilli")) && !cover.productName.startsWith("Caravan") && cover.riskItems[0].inspectionRequired)
                .map((cover) => {
                    return <Dropdown.Item eventKey={cover.id} key={cover.id} value={cover.id}>
                        <div className="selfinspect-dropdown-list-actual-item">
                            <div className="row selfinspect-dropdown-row">
                                <div className="selfinspect-dropdown-col-icon">
                                    <div className={"selfinspect-dropdown-icon " + cover.image}></div>
                                </div>
                                <div className="col selfinspect-dropdown-col-productname">
                                    <p>
                                        <span className="selfinspect-dropdown-productname-productname">{cover.productName + ": "}</span>
                                        <span className="selfinspect-dropdown-productname-description">{cover.riskItems[0].description}</span>
                                    </p>
                                </div>
                                <div className="selfinspect-dropdown-col-arrow"> </div>
                            </div>
                            <div className="selfinspect-dropdown-item-dividerline"></div>
                        </div>
                    </Dropdown.Item>
                });
        }
        /// *** *** ///

        if (this.props.profile.personalPolicies[0] !== undefined) {
            if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER_DATE || modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER) {
                covers = this.props.profile.personalPolicies[0].covers
                    .filter(cover => cover.isMainline === true &&
                        (cover.productName.startsWith("Car") || cover.productName.startsWith("Motorbike") || cover.productName.startsWith("Chilli"))
                        && cover.riskItems[0] !== undefined && !cover.productName.startsWith("Caravan"))
                    .map((cover) => {
                        return <Dropdown.Item eventKey={cover.id} key={cover.id} value={cover.id}>
                            <ModalCoverSelect id={cover.id} alertCount="0"
                                headerText={cover.productName}
                                bodyText={cover.riskItems[0].description}
                                image={cover.image}
                            />
                            <hr className="-modal" />
                        </Dropdown.Item>
                    });
            }
            else if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_DATE) {
                covers = this.props.profile.personalPolicies[0].covers
                    .filter(cover => cover.isMainline === true && cover.riskItems[0] !== undefined)
                    .map((cover) => {
                        return <Dropdown.Item eventKey={cover.id} key={cover.id} value={cover.id}>
                            <ModalCoverSelect id={cover.id} alertCount="0"
                                headerText={cover.productName}
                                bodyText={cover.riskItems[0].description}
                                image={cover.image}
                            />
                            <hr className="-modal" />
                        </Dropdown.Item>
                    });
            }
        }

        let vapSelectList = <div></div>;
        if (modal.modalProps.vapList !== undefined) {
            const lastIndex = modal.modalProps.vapList.length - 1;
            vapSelectList = modal.modalProps.vapList.map((vapItem, index) => {
                if (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER) {
                    vapItem.description = vapItem.description.replaceAll(" R ", " " + this.props.profile.currencySymbol + " ")
                }
                if (index === lastIndex) {
                    return <Dropdown.Item className="border-0" eventKey={vapItem.id} key={vapItem.id}>{vapItem.description}</Dropdown.Item>

                } else {
                    return <Dropdown.Item eventKey={vapItem.id} key={vapItem.id}>{vapItem.description}</Dropdown.Item>
                }

            });
        }
        if (modal.modalProps.isHtml === true) {
            header = () => <div dangerouslySetInnerHTML={{ __html: modal.modalProps.header }}></div>
            body = () => <div dangerouslySetInnerHTML={{ __html: modal.modalProps.body }}></div>
        }

        if (modal.modalProps.type === MODAL_TYPE_ERROR) { // Error modal
            header = () =>
                <>
                    <Image src="./Images/icons-checkmark-default-cross-48-px.svg" className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 text-center">{modal.modalProps.header}</h3>
                    </div>
                </>
            if (modal.modalProps.body === ERROR_INVALID_OTP) {
                footer = () =>
                    <Button className="btn btn-solid-red btn-lg justify-content-center w-100" onClick={this.handleRetryOTP} id='closeModal'>
                        Okay
                    </Button>
            }
        }
        else if (modal.modalProps.type === MODAL_TYPE_INTERVENTION) { // Intervention Error modal
            header = () =>
                <>
                    <Image src="./images/icon-headphones-red.svg" className="img-fluid" alt="" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">Oops</h3>
                    </div>
                </>
            body = () =>
                <>
                    <p className="text-center intervention">Based on the info given, we need 1 of our consultants to handle the rest of the process. We'll call you ASAP. Alternatively, you can call us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <a href='tel:0860505050' target="_blank">0860 50 50 50</a>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <a href='tel:0836007000' target="_blank">083 600 7000</a>}</p>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_QUOTE_SOFT_REJECTED) { //  Quote soft rejected Error modal
            header = () =>
                <>
                    <img src="Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 oops">Oops</h3>
                    </div>
                </>
            body = () =>
                <>
                    <p className="text-center intervention">Based on the info given, we need 1 of our consultants to handle the rest of the process. We'll call you ASAP. Alternatively, you can call us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <a href='tel:0860505050' target="_blank">0860 50 50 50</a>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <a href='tel:0836007000' target="_blank">083 600 7000</a>}</p>
                    <div id="CallMeBackButton" className="text-center w-100">
                        <Button className="w-100 btn-solid-red" onClick={() => this.handleCallMeBack(true)}>Call me</Button>
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_TYPE_QUOTE_HARD_REJECTED) { // Quote hard rejected Error modal
            header = () =>
                <>
                    <Image src="./Images/icons-checkmark-default-cross-48-px.svg" className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 oops">Quote rejected</h3>
                    </div>
                </>
            body = () =>
                <>
                    <p className="text-center intervention">Unfortunately, based on the info you’ve given, we can’t insure you.</p>
                    <Button className="btn btn-solid-red btn-lg justify-content-center w-100" onClick={this.handleModalToDashboardDiscardCart} id='closeModal'>
                        Okay, got it
                    </Button>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_TYPE_LOGIN_ERROR) { // Login Error modal
            header = () =>
                <>
                    <Image src="./Images/icons-checkmark-default-cross-48-px.svg" className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0">{modal.modalProps.header}</h3>
                    </div>
                </>
            footer = () =>
                <Button className="btn btn-solid-red btn-lg justify-content-center w-100" onClick={this.handleSignOutAndRefresh} id='closeModal'>
                    Call me
                </Button>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CONFIRM_SIGN_OUT) { // Sign out
            header = () =>
                <div id="signOutModalHeader" className="text-center">
                    <Image src="./Images/icon-sign-out.png" className="img-fluid pl-4" />
                </div>
            footer = () =>
                <div id="signOutModalFooter" className="text-center">
                    <button className="col-12 btn btn-solid-red mb-2" onClick={this.handleSignOut}>Yes, log me out</button>
                    <button className="col-12 btn btn-outline-red" onClick={this.handleHideModal} >No, return to the dashboard</ button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_OK) { // OK
            header = () =>
                <div id="okModalHeader" className="text-center">
                    <Image src="./Images/Checkmark.svg" className="img-fluid checkmark-large" />
                </div>
            footer = () =>
                <div className="row justify-content-center col-12 mt-30px nopa">
                    <button className="btn btn-solid-green w-100 button-ok" onClick={this.handleHideModal} id='closeModal'>Okay</button >
                </div >

        }
        else if (modal.modalProps.type === MODAL_TYPE_NAM_OK) { // OK
            header = () =>
                <div id="okModalHeader" className="text-center">
                    <Image alt="" title="" src="./images/icon-headphones-red.svg" className="img-fluid headphones-large" />
                </div>
            footer = () =>
                <div className="row justify-content-center col-12 mt-30px nopa">
                    <button className="btn btn-solid-green w-100 button-ok" onClick={this.handleHideModal} id='closeModal'>Okay</button >
                </div >
        }
        else if (modal.modalProps.type === MODAL_TYPE_SEND_OTP) { // Request OTP
            let otpOptions = () =>
                <select className="form-control" name="OTPMethod" onChange={this.handleOTPMethodChange}>
                    <option value="0" defaultValue={this.props.profile.cellphoneNumber}>{this.props.profile.cellphoneNumber}</option>
                    <option value="1">{this.props.profile.email}</option>
                </select>

            if (this.props.profile.cellphoneNumber === '' && this.props.profile.email !== '') {
                otpOptions = () =>
                    <select className="form-control" name="OTPMethod" onChange={this.handleOTPMethodChange}>
                        <option value="1" defaultValue={this.props.profile.email}>{this.props.profile.email}</option>
                    </select>
            }
            else if (this.props.profile.cellphoneNumber !== '' && this.props.profile.email === '') {
                otpOptions = () =>
                    <select className="form-control" name="OTPMethod" onChange={this.handleOTPMethodChange}>
                        <option value="0" defaultValue={this.props.profile.cellphoneNumber}>{this.props.profile.cellphoneNumber}</option>
                    </select>
            }

            header = () =>
                <div className="text-center">
                    <h3>OTP verification</h3><p>We will send you a <b>verification code</b> to the <br />number/email below</p>
                </div>

            body = () =>
                <div className='text-center'>
                    <Form.Label className="left-align"><b>Prefered contact details</b></Form.Label>
                    <br />
                    {otpOptions()}
                    <br />
                    <Form.Label className="left-align">Wrong contact details? <a onClick={this.handleCallMeFromOTP} className="red"><b>Call me</b></a></Form.Label>
                </div>

            footer = () =>
                <div id="GetOTPButton" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleGetOTP}>Get OTP</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_VERIFY_OTP) { // Verify OTP
            let businessHours = this.props.profile.countryId === SA_COUNTRY_ID_NUMBER ? 'Our business hours = 08:00 - 17:00, Mondays to Fridays' : 'Our business hours = 08:00 - 16:30, Mondays to Fridays';

            let otpValid = validateOTP.test(this.state.OTP);
            let otpNotice = "";
            if (this.state.OTPSubmitted && !otpValid) {
                otpNotice = "Please enter a 6-digit pin";
            }
            if (this.props.auth.OTPResponseReceived && modal.modalProps.otpInvalid) {
                otpNotice = "Incorrect OTP entered";
                otpValid = false;
            }

            header = () =>
                <div className="text-center">
                    <Image src="./Images/icon-red-warning.svg" className="img-fluid" alt="warningImage" />
                    <h3 className="mt-4">One-time PIN (OTP)</h3>
                </div>

            body = () =>
                <div className='text-center'>
                    <div>
                        We’ve sent you an email/SMS with an OTP. Please check if you’ve received it, and type it here:
                    </div>
                    <br />
                    <KPInputTextArea
                        id="OTPVerificationInput"
                        name="OTP"
                        type="text"
                        className="mb-4"
                        label="OTP"
                        showLabelAfterSelection={true}
                        value={this.state.OTP}
                        notice={!otpValid}
                        noticeType="error"
                        noticeMessage={otpNotice}
                        successTick={otpValid}
                        required={true}
                        readOnly={false}
                        autoFocus={false}
                        minLength={6}
                        maxLength={6}
                        disabled={false}
                        form="mainform"
                        handleChange={(e) => this.handleChange(e)}
                    />
                </div>

            footer = () =>
                <div>
                    <div className="text-center mt-4">
                        <button className="w-100 btn btn-solid-green btnResponsive" onClick={this.handleVerifyOTP} disabled={!otpValid}>Confirm</button>
                    </div>
                    <div className="text-center mt-4">
                        <button className="w-100 btn btn-outline-red btnResponsive" onClick={this.handleResendOTP}>Resend OTP</button>
                    </div>
                    <div className="text-center mt-4">
                        <div>Struggling?</div>
                        <div><span className="customlink red" onClick={this.handleCallMeBackPopup}>Tap here and we’ll call you back.</span></div>
                        <br/>
                        <div><b>Please note:</b> {businessHours}</div>
                    </div>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_VERIFY_OTP_LIFE) { // Verify OTP
            header = () =>
                <div className="text-center">
                    <h3>OTP verification</h3><p><b>Verification code</b> sent</p>
                </div>

            body = () =>
                <div className='text-center'>
                    <Form.Label className="left-align"><b>Enter verification code</b></Form.Label>
                    <br />
                    <Form.Control type="text" placeholder="OTP" id="OTPVerificationInput" name="OTP" value={this.state.OTP} onChange={this.handleChange} />
                    {this.state.OTPSubmitted && !this.state.otpRegex &&
                        <div className="help-block">OTP must have 6 digits</div>
                    }
                    {this.props.auth.OTPResponseReceived && modal.modalProps.otpInvalid === true &&
                        <div className="help-block">Incorrect OTP entered</div>
                    }
                    <br />
                    <Form.Label className="left-align">Didn't receive the OTP? <a onClick={this.handleResendOTP} className="red"><b>Resend OTP</b></a></Form.Label>
                </div>

            footer = () =>
                <div id="VerifyOTPButton" className="col-12 text-center">
                    <Button className="w-100 btn-solid-green" onClick={this.handleVerifyOTPLife}>Verify and proceed</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CALL_ME) { // Call me
            header = () =>
                <div className="text-center p-3">
                    <h3 className="Please-provide-your">Please give us your contact details and we’ll call you back</h3>
                </div>

            if (modal.modalProps.showDropDown === true) {
                body = () =>
                    <div className='text-center'>
                        <Form.Label className="left-align contactLabels ml-15px"><b>What would you like to chat about</b></Form.Label>
                        <br />
                        <Dropdown
                            id="callmeback-dropdown-menu"
                            onSelect={this.handleCallMeBackDropdownSelection}
                            onToggle={this.handleCallMeBackDropdownToggle}
                        >
                            <Dropdown.Toggle variant="success" id="dropdown-basic" className="full-width">
                                <div id="callBackLocation" className="dropdown-basic-title-text">
                                    {this.state.callMeBackDropdownSelection}
                                </div>
                                <Image src='Images/icons-arrow-dropdown-up-grey-24-px.svg' className={this.state.callMeBackDropdownOpen ? 'visible' : 'invisible'} />
                                <Image src='Images/icons-arrow-dropdown-down-grey-24-px.svg' className={this.state.callMeBackDropdownOpen ? 'invisible' : 'visible'} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item eventKey="Client care">Client care</Dropdown.Item>
                                {(!this.props.profile.policyId && this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER) && <Dropdown.Item eventKey="New sales">New sales</Dropdown.Item>}
                                {this.props.profile.policyId &&
                                    <Dropdown.Item eventKey="Claims">Claims</Dropdown.Item>
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                        {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && this.state.callMeBackDropdownSelection === "Client care" &&
                            <>
                                <br />
                                <Form.Label className="left-align contactLabels ml-15px"><b>When can we call you</b></Form.Label>
                                <br />
                                <Dropdown
                                    id="callmeback-dropdown-menu-when"
                                    onSelect={this.handleCallMeBackTimeDropdownSelection}
                                    onToggle={this.handleCallMeBackTimeDropdownToggle}
                                >
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" className="full-width">
                                        <div id="callBackTime" className="dropdown-basic-title-text">
                                            {this.state.callMeBackTimeDropdownSelection}
                                        </div>
                                        <Image src='Images/icons-arrow-dropdown-up-grey-24-px.svg' className={this.state.callMeBackTimeDropdownOpen ? 'visible' : 'invisible'} />
                                        <Image src='Images/icons-arrow-dropdown-down-grey-24-px.svg' className={this.state.callMeBackTimeDropdownOpen ? 'invisible' : 'visible'} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item eventKey="Between 08:00 and 18:00 (office hours)">Between 08:00 and 18:00 (office hours)</Dropdown.Item>
                                        <Dropdown.Item eventKey="Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)">Between 06:00 and 08:00 or 18:00 and 23:00 (after-hours)</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        }
                        <br />
                        <Form.Label className={'left-align temp-text-box-label contactLabels ' + (this.state.fullname !== "" ? "" : " no-opacity")}><b>Name</b></Form.Label>
                        <Form.Control type="text" placeholder="Full name" id="fullname" name="fullname" value={this.state.fullname} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.nameRegex &&
                            <div className="help-block">Please provide a valid name</div>
                        }

                        <br />
                        <Form.Label className={'left-align temp-text-box-label contactLabels ' + (this.state.phoneNumber !== "" ? "" : " no-opacity")}><b>Phone no.</b></Form.Label>
                        <Form.Control type="text" placeholder="Phone no." id="phoneNumber" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.cellphoneNumberRegex &&
                            <div className="help-block">Please provide a valid cell no.</div>
                        }
                    </div>
            }
            else {
                body = () =>
                    <div className="text-center">
                        <Form.Label className={'left-align temp-text-box-label ' + (this.state.fullname !== "" ? "" : " no-opacity")}><b>Name</b></Form.Label>
                        <Form.Control type="text" placeholder="Full name" id="fullname" name="fullname" value={this.state.fullname} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.nameRegex &&
                            <div className="help-block">Please provide a valid name</div>
                        }
                        <br />

                        <Form.Label className={'left-align temp-text-box-label ' + (this.state.phoneNumber !== "" ? "" : " no-opacity")}><b>Phone no.</b></Form.Label>
                        <Form.Control type="text" placeholder="Phone no." id="phoneNumber" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.cellphoneNumberRegex &&
                            <div className="help-block">Please provide a valid cell no.</div>
                        }
                    </div>
            }
            footer = () =>
                <div id="CallMeBackButton" className="text-center w-100">
                    <Button className="w-100 btn-solid-red" onClick={() => this.handleCallMeBack(false)}>Call me back</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_FNOL_CALL_ME) { // fnol callback
            header = () =>
                <div className="text-center p-3">
                    <h3 className="Please-provide-your">We’ll get back to you</h3>
                </div>

            body = () =>
                <div className='text-center'>

                    <Dropdown
                        id="fnol-callmeback-dropdown-menu"
                        onSelect={this.handleFnolCallMeBackDropdownSelection}
                        onToggle={this.handleFnolCallMeBackDropdownToggle}
                    >
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="full-width">
                            <div className="dropdown-basic-title-text">
                                {this.state.fnolCallMeBackDropdownSelection}
                            </div>

                            <Image src='Images/Icons _ Navigation _ Close _Down_ 24px.svg' className={this.state.callMeBackDropdownOpen ? 'visible' : 'invisible'} />
                            <Image src='Images/Icons _ Navigation _ Close _ 24px.svg' className={this.state.callMeBackDropdownOpen ? 'invisible' : 'visible'} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item eventKey="I want to talk to a claims consultant">I want to talk to a claims consultant</Dropdown.Item>

                            <Dropdown.Item eventKey="I need technical assistance">I need technical assistance</Dropdown.Item>

                            <Dropdown.Item eventKey="I want to talk to 1 of your legal advisors">I want to talk to 1 of your legal advisors</Dropdown.Item>

                        </Dropdown.Menu>
                    </Dropdown>

                    <strong className="left-align mt-4 mb-1">Please tell us what you'd like to chat about</strong>

                    <textarea id="fnolCallBackDescription" name="fnolCallBackDescription" rows={4} cols={50} className="form-control" placeholder="Start typing" value={this.state.fnolCallBackDescription} onChange={this.handleChangeFnolCallBackDescription} />
                </div>
            footer = () =>
                <>
                    <div id="FnolCallMeBackButton" className="text-center w-100">
                        <Button className="w-100 btn-solid-red" onClick={this.handleFnolCallMeBack} disabled={this.state.fnolCallMeBackDropdownSelection !== "Who do you want to chat to ?" && this.state.fnolCallBackDescription !== "" ? false : true}>Call me back</Button>
                    </div>
                    <div className="text-center w-100 mt-5">

                        <b><b>Or you can call us on </b>
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <b className="red">0860 50 50 50</b>}
                            {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <b className="red">083 600 7000</b>}
                        </b>
                        {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="mt-1 mb-1"><strong>Please note:</strong> Our business hours = 08:00 - 17:00,</p>}
                        {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="mt-1 mb-1"><strong>Please note:</strong> Our business hours = 08:00 - 16:30,</p>}

                        <p>Mondays to Fridays</p>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_DRIVABLE_NO) {
            header = () =>

                <div className="text-center">
                    <img src="Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png" />
                    <h3>Notification submitted</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        We'll call you within the next 4 business hours to get more info to register your claim (if you've submitted your claim notification after-hours, you can expect a call from us on the next business day) <br /><br />
                        <strong>Business hours:</strong><br />
                        Mondays to Fridays, 08:00 - {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? '17:00' : '16:30'}
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleNotDrivable}>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_FNOL_NOTIFICATION_SUBMIT) {
            header = () =>

                <div className="text-center">
                    <img src="Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png" />
                    <h3>Notification submitted</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        We'll call you within the next 4 business hours to get more info to register your claim (if you've submitted your claim notification after-hours, you can expect a call from us on the next business day) <br /><br />
                        <strong>Business hours:</strong><br />
                        Mondays to Fridays, 08:00 - {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER ? '17:00' : '16:30'}
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleHideModal}>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_SWITCH_TO_MOBILE) {
            header = () =>

                <div className="text-center">
                    <img className="pb-3" src="Images/icons-line-style-info-32-px@2x.png" />
                    <h3>Pick up where you <br /> left off</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p className="modalUp">
                        We see you started a claim on your desktop and decided to switch to your phone... To continue with your claim, tap 'Continue'
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleContinueOnMobile}>Continue</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_LINK_POLICY) { // Link policy to account
            header = () =>

                <div className="text-center">
                    <h3 className="mb-2">Link your policy</h3>
                    <p>How do you want to link your policy?</p>
                </div>

            body = () =>
                <div>
                    <div className="check-box-row col-12 pb-2" >
                        <label htmlFor='LinkPolicyNrRadio' className="col-10 radio-text">
                        <input className="check custom col-1" type="radio" radioGroup='LinkPolicy' id='LinkPolicyNrRadio' name='LinkPolicyNrRadio' checked={this.state.policyLinkMethod === LINK_POLICYNR} onChange={this.handleLinkType} value={LINK_POLICYNR} ></input>
                            Use my policy no.</label>
                    </div>
                    <div id='LinkWithPolicy' className={
                        this.state.policyLinkMethod === LINK_POLICYNR ? 'row enabled' : ''
                    }>
                        <div className="pl-5 pt-2 pb-3">
                            <Form.Label className={"pt-3 " + (this.state.policyNr !== "" ? "" : " no-opacity")}><b>Policy no.</b></Form.Label>
                            <br />
                            <Form.Control className="w-100" type="text" id="LinkPolicyNr" placeholder="Policy no." name="policyNr" value={this.state.policyNr} onChange={this.handleChange} />
                            {this.state.linkPolicySubmitted && !this.state.policyRegex &&
                                <div className="help-block custom">Please provide a valid Policy number</div>
                            }
                        </div>
                    </div>
                    <br />
                    {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                        <>
                            <div className="check-box-row col-12 pb-2">
                                <label htmlFor='LinkIdNumberRadio' className="col-10 radio-text text-center">
                                <input className="check custom col-1" type="radio" id='LinkIdNumberRadio' checked={this.state.policyLinkMethod === LINK_IDNUMBER} onChange={this.handleLinkType} value={LINK_IDNUMBER} />
                                    Use my ID no.</label>
                            </div>
                            < div id='LinkWithID' className={
                                this.state.policyLinkMethod === LINK_IDNUMBER ? 'row enabled' : ''
                            }>
                                <div className="pl-5 pt-2 pb-3">
                                    <Form.Label className={"pt-3 " + (this.state.idNumber !== "" ? "" : " no-opacity")}><b>ID no.</b></Form.Label>
                                    <br />
                                    <Form.Control className="w-100" type="text" id="LinkIdNumber" placeholder="ID no." name="idNumber" value={this.state.idNumber} onChange={this.handleChange} />
                                    {this.state.linkPolicySubmitted && !this.state.idRegex &&
                                        <div className="help-block custom">Please provide a valid ID number</div>
                                    }
                                </div>
                            </div>
                        </>
                    }
                    {this.props.ssp.livinEnabled && this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                        <>
                            <br />
                            <div className="check-box-row col-12 pb-2">
                            <label htmlFor='LinkLifePolicyNrRadio' className="col-10 radio-text">
                                <input className="check custom col-1" type="radio" radioGroup='LinkPolicy' id='LinkLifePolicyNrRadio' name='LinkLifePolicyNrRadio' checked={this.state.policyLinkMethod === LINK_LIFE_POLICYNR} onChange={this.handleLinkType} value={LINK_LIFE_POLICYNR} ></input>
                                    Use my Livin' policy no.</label>
                            </div>
                        </>
                    }
                    <div id='LinkWithLifePolicy' className={
                        this.state.policyLinkMethod === LINK_LIFE_POLICYNR ? 'row enabled' : ''
                    }>
                        <div className="pl-5 pt-2 pb-3">
                            <Form.Label className={"pt-3 " + (this.state.lifePolicyNr !== "" ? "" : " no-opacity")}><b>Policy no.</b></Form.Label>
                            <br />
                            <Form.Control className="w-100" type="text" id="LinkPolicyNr" placeholder="Policy no." name="lifePolicyNr" value={this.state.lifePolicyNr} onChange={this.handleChange} />
                            {this.state.linkPolicySubmitted && !this.state.lifePolicyRegex &&
                                <div className="help-block custom">Please provide a valid Policy number</div>
                            }
                        </div>
                    </div>
                </div >
            footer = () =>
                <div className="w-100 text-center mt-4">
                    <button className="btn btn-solid-red btnResponsive" id="sumbitPolicyLink" onClick={this.linkCustomerPolicies}>Send OTP</button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_LIFE_REMOVE_BENEFICIARY) { // donate decrease confirmation
            let beneficiaryName = modal.modalProps.beneficiaryName;
            let cb = modal.modalProps.callback;

            header = () =>
                <div className="text-center">
                    <Image src="./Images/warning-notification.png" fluid />
                    <h5 className="font-weight-bold mt-4">Are you sure</h5>
                </div>
            body = () =>
                <div className='text-center'>

                    <p>Are you sure you want to remove {beneficiaryName} as a beneficiary?</p>
                </div>
            footer = () =>
                <div className="row text-center w-100">
                    <div className="col-12">
                        <button className="btn btn-solid-red mr-2 mr-sm-2 mb-2 mb-sm-2 d-block w-100" onClick={cb} id='RemoveLifeBeneficiary'>
                            Yes
                        </button>
                    </div>
                    <div className="col-12">
                        <button className="btn btn-outline-red mr-2 mr-sm-2 mb-2 mb-sm-2 d-block w-100" onClick={this.handleHideModal} id='closeModal'>
                            No
                        </button>
                    </div>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_UPDATE_PROFILE) { // update profile info
            header = () =>
                <div className="text-center">
                    <h3>Please enter information</h3>
                </div>
            body = () =>
                <div className='text-center'>
                    {(modal.modalProps.field === FIELD_PHONENUMBER) &&
                        <>
                            <div className="check-box-row">
                                <Form.Label>Enter phone no. to use.</Form.Label>
                            </div>
                            <div>
                                <Form.Control type="text" placeholder="Phone no." name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} />
                            </div>
                        </>
                    }
                    {(modal.modalProps.field === FIELD_ALTPHONENUMBER) &&
                        <>
                            <div className="check-box-row">
                                <Form.Label>Enter alternative contact number to use.</Form.Label>
                            </div>
                            <div>
                                <Form.Control type="text" placeholder="Alternative number" name="altPhoneNumber" value={this.state.altPhoneNumber} onChange={this.handleChange} />
                            </div>
                        </>
                    }
                    {(modal.modalProps.field === FIELD_EMAIL) &&
                        <>
                            <div className="check-box-row">
                                <Form.Label>Enter email address to use.</Form.Label>
                            </div>
                            <div>
                                <Form.Control type="text" placeholder="UpdateEmail" name="email" value={this.state.email} onChange={this.handleChange} />
                            </div>
                        </>
                    }
                    {(modal.modalProps.field === FIELD_WORKADDRESS) &&
                        <>
                            <div className="check-box-row">
                                <Form.Label>Enter work adress to use.</Form.Label>
                            </div>
                            <div>
                                <Form.Control type="text" placeholder="Work address" id="UpdateWorkAddress" name="workAdress" value={this.state.workAddress} onChange={this.handleChange} />
                            </div>
                        </>
                    }
                    {(modal.modalProps.field === FIELD_PREFERREDLANGUAGE) &&
                        <>
                            <div className="check-box-row">
                                <Form.Label>Enter preferred language to use.</Form.Label>
                            </div>
                            <div>
                                <br />
                                <Dropdown
                                    id="callmeback-dropdown-menu"
                                    onSelect={this.handlePreferredLanguageSelection}
                                    onToggle={this.handlePreferredLanguageDropdownToggle}
                                >
                                    <Dropdown.Toggle variant="success" id="dropdown-basic" >
                                        <div className="dropdown-basic-title-text">
                                            {this.state.preferredLanguageSelection}
                                        </div>
                                        <Image src='Images/red-arrow-up-24-px.svg' className={this.state.preferredLanguageDropdownOpen ? 'visible' : 'invisible'} />
                                        <Image src='Images/red-arrow-down-24-px.svg' className={this.state.preferredLanguageDropdownOpen ? 'invisible' : 'visible'} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu id='languageDropDown'>
                                        {languageDrop}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </>
                    }
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleUpdateCustomerInfo}>Update</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS) { // requestDocs
            header = () =>
                <div className="mt-2 pb-0">
                    <div className="col-12 row">
                        <div className="col-3 col-lg-2">
                            <Image src='Images/RequestDocuments/icons-line-style-folder-red-32-px-active.png' className="img-fluid mr-2" />
                        </div>
                        <div className="col-9 col-lg-10 text-left">
                            <p className="RequestTitle mb-1">Email request</p>
                            <p className="">Let us know where we should email this doc to</p>
                        </div>
                    </div>
                </div>
            body = () =>
                <div className='text-center pt-0'>
                    <p className="text-left">Email</p>
                    <Form.Control type="text" id="documentMail" name="documentMail" value={this.state.documentMail} onChange={this.handleChange} />
                    {this.state.documentSubmitted && !this.state.documentMailRegex &&
                        <div className="help-block">Please provide a valid email address</div>
                    }
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleRequestDocument}>Send</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER) { // requestDocs with vehicle cover select
            header = () =>
                <div className="mt-2 mb-2">
                    <div className="col-12 row">
                        <div>
                            <Image src='Images/RequestDocuments/icons-line-style-folder-red-32-px-active.png' className="img-fluid mr-2" />
                        </div>
                        <div className="col-10 text-left">
                            <p className="RequestTitle mb-1">Email request</p>
                            <p className="">Let us know where we should email this doc to</p>
                        </div>
                    </div>
                </div>

            body = () =>
                <>
                    {this.state.documentSubmitted && this.state.requestError &&
                        <div className='help-block'>Please provide all required details</div>
                    }
                    <div className='col-12 pl-0 text-center'>
                        <Form.Control type="text" placeholder="Email" id="documentMail" name="documentMail" value={this.state.documentMail} onChange={this.handleChange} />
                        {this.state.documentSubmitted && !this.state.documentMailRegex &&
                            <div className="help-block">Please provide a valid email address</div>
                        }
                    </div>
                    <div className="col-12 mt-4" style={{ paddingLeft: "10px" }}>
                        <Dropdown id="CoverSelect"
                            onSelect={this.handleCoverSelection}
                            onToggle={this.handleCoverDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" className="pl-1 pb-2">
                                <div className="dropdown-basic-title-text">
                                    <a>
                                        {this.state.selectedCover &&
                                            <>
                                                <p className="title mb-1">Policy item</p>
                                                <p className="hide-overflow">{this.state.selectedCover.riskItems[0].description}</p>
                                            </>
                                        }
                                        {!this.state.selectedCover &&
                                            <p>Choose an item</p>
                                        }
                                    </a>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Choose an item" id="nav-dropdown" className="pb-3">
                                {covers}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            footer = () =>
                <div id="sumbitPolicyLink" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleRequestDocument}>Send</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_DATE) { // requestDocs with start and end date
            header = () =>
                <div className="mt-2 mb-2">
                    <div className="col-12 row">
                        <div>
                            <Image src='Images/RequestDocuments/icons-line-style-folder-red-32-px-active.png' className="img-fluid mr-2" />
                        </div>
                        <div className="col-10 text-left">
                            <p className="RequestTitle mb-1">Email request</p>
                            <p className="">Let us know where we should email this doc to</p>
                        </div>
                    </div>
                </div>

            body = () =>
                <>
                    {this.state.documentSubmitted && this.state.requestError &&
                        <div className='help-block'>Please provide all required details</div>
                    }
                    <div className='col-12 pl-0 text-center'>
                        <Form.Control type="text" placeholder="Email" id="documentMail" name="documentMail" value={this.state.documentMail} onChange={this.handleChange} />
                        {this.state.documentSubmitted && !this.state.documentMailRegex &&
                            <div className="help-block">Please provide a valid email address</div>
                        }
                    </div>
                    <div className="col-12 mt-4" style={{ paddingLeft: "10px" }}>
                        <Dropdown id="CoverSelect"
                            onSelect={this.handleTaxCoverSelection}
                            onToggle={this.handleCoverDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" className="pl-1">
                                <div className="dropdown-basic-title-text">
                                    <a>
                                        {this.state.selectedTaxCover &&
                                            <>
                                                <p className="title mb-1">Policy item</p>
                                                <p className="hide-overflow">{this.state.selectedTaxCover.riskItems[0].description}</p>
                                            </>
                                        }
                                        {!this.state.selectedTaxCover &&
                                            <p>Choose an item</p>
                                        }
                                    </a>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                                {covers}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className='col-12 pl-0 text-center requestDoc'>
                        <ModernDatepicker
                            date={this.state.startDateTax}
                            format={'DD-MM-YYYY'}
                            showBorder
                            onChange={(date) => this.changeStartTaxDate(date)}
                            placeholder={'Select a start date'}
                            className="calendar-inline-icon overlay"
                            maxDate={this.state.maxDate}
                        />
                    </div>
                    <div className='col-12 pl-0 mt-4 text-center requestDoc'>
                        <ModernDatepicker
                            date={this.state.endDateTax}
                            format={'DD-MM-YYYY'}
                            showBorder
                            onChange={(date) => this.changeEndTaxDate(date)}
                            placeholder={'Select an end date'}
                            className="calendar-inline-icon overlay"
                            maxDate={this.state.maxDate}
                        />
                    </div>
                </>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleRequestDocument}>Send</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REQUEST_DOCS_COVER_DATE) { // requestDocs with cover select and start and end date
            header = () =>
                <div className="mt-2 mb-2">
                    <div className="col-12 row">
                        <div>
                            <Image src='Images/RequestDocuments/icons-line-style-folder-red-32-px-active.png' className="img-fluid mr-2" />
                        </div>
                        <div className="col-10 text-left">
                            <p className="RequestTitle mb-1">Email request</p>
                            <p className="">Let us know where we should email this doc to</p>
                        </div>
                    </div>
                </div>

            body = () =>
                <>
                    {this.state.documentSubmitted && this.state.requestError &&
                        <div className='help-block'>Please provide all required details</div>
                    }
                    <div className='col-12 pl-0 text-center'>
                        <Form.Control type="text" placeholder="Email" id="documentMail" name="documentMail" value={this.state.documentMail} onChange={this.handleChange} />
                        {this.state.documentSubmitted && !this.state.documentMailRegex &&
                            <div className="help-block">Please provide a valid email address</div>
                        }
                    </div>
                    <div className="col-12 mt-4" style={{ paddingLeft: "10px" }}>
                        <Dropdown id="CoverSelect"
                            onSelect={this.handleCoverSelection}
                            onToggle={this.handleCoverDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" className="pl-1">
                                <div className="dropdown-basic-title-text">
                                    <a>
                                        {this.state.selectedCover &&
                                            <>
                                                <p className="title mb-1">Policy item</p>
                                                <p className="hide-overflow">{this.state.selectedCover.riskItems[0].description}</p>
                                            </>
                                        }
                                        {!this.state.selectedCover &&
                                            <p>Choose an item</p>
                                        }
                                    </a>
                                </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Choose an item" id="nav-dropdown">
                                {covers}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className='col-12 pl-0 text-center requestDoc'>
                        <ModernDatepicker
                            date={this.state.startDate}
                            format={'DD-MM-YYYY'}
                            showBorder
                            onChange={(date) => this.changeStartDate(date)}
                            placeholder={'Select a start date'}
                            className="calendar-inline-icon overlay form-control"
                            minDate={this.state.maxDate}
                        />
                    </div>
                    <div className='col-12 pl-0 mt-4 text-center requestDoc'>
                        <ModernDatepicker
                            date={this.state.endDate}
                            format={'DD-MM-YYYY'}
                            showBorder
                            onChange={(date) => this.changeEndDate(date)}
                            placeholder={'Select an end date'}
                            className="calendar-inline-icon overlay form-control"
                            minDate={this.state.maxDate}
                        />
                    </div>
                </>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12 text-center">
                    <Button className="w-100 btn-solid-red" onClick={this.handleRequestDocument}>Send</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_DONATE) { // donate decrease confirmation
            let charityName = modal.modalProps.charityName;
            let charityImage = modal.modalProps.charityImage;

            if (modal.modalProps.stopDecrease === true) {
                header = () =>
                    <div id="donateDecreaseModalHeader" className="text-center">
                        <Image src="./images/DonateDecrease/icon-dmd-learn-to-earn.png" fluid />
                    </div>
                body = () =>
                    <div className='text-center'>

                        <p>Are you sure you want to stop donating your decrease every month?</p>
                    </div>
                footer = () =>
                    <div className="donateDecreaseModalButtons text-center">
                        <button className="btn btn-outline-red mr-2 mr-sm-2 mb-2 mb-sm-2" onClick={this.handleHideModal} id='closeModal'>
                            No, go back
                        </button>
                        <button className="btn btn-solid-red mr-2 mr-sm-2 mb-2 mb-sm-2" onClick={this.handleDonate} id='SaveDonation'>
                            Yes
                        </button>
                    </div>
            }
            else {
                header = () =>
                    <div id="donateDecreaseModalHeader" className="text-center">
                        <Image src={charityImage} fluid />
                    </div>
                body = () =>
                    <div className='text-center'>
                        <p className="Fantastic">Fantastic!</p>
                        <p>So, just to confirm... You’d like to donate your monthly decrease to <b>{charityName}</b>?</p>
                    </div>
                footer = () =>
                    <div className="donateDecreaseModalButtons text-center">
                        <button className="btn btn-outline-red mr-2 mb-2" onClick={this.handleHideModal} id='closeModal'>
                            No, go back
                        </button>
                        <button className="btn btn-solid-red mr-2 mb-2" onClick={this.handleDonate} id='DonateToCharity'>
                            Confirm
                        </button>
                    </div>
            }
        }
        else if (modal.modalProps.type === MODAL_THANK_YOU) { // donate decrease thank you
            let charityName = modal.modalProps.charityName;
            header = () =>

                <div id="donateDecreaseModalHeader" className="text-center">
                    <Image src="./images/thumbs-up.svg" fluid />
                </div>

            body = () =>
                <div className='text-center'>
                    <p className="Thank-you">All done!</p>
                    <p>Thanks for supporting<br /><b>{charityName}</b></p>
                </div>

            footer = () =>
                <button className="btn btn-solid-green btn-lg justify-content-center w-100" onClick={this.handleHideModal} id='closeModal'>
                    Okay
                </button>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REFER_A_FRIEND) {//Refer a friend
            header = () =>

                <div id="ReferFriendModalHeader" className="text-center">
                    <h3 className="refer-friend-header text-white">It pays to have friends <br/>(literally)</h3>
                </div>
            footer = () =>
                <>
                    <Button className={(isMobile ? "col" : "col-4") +" btn btn-solid-green btn-lg justify-content-center"} onClick={this.handleReferFriend} id='referAFriendSubmit' disabled={!this.state.acceptedTCs}>
                        Refer
                    </Button>
                </>

            body = () =>
                <>
                    <div className="text-center">
                        <p className="text-white Spread-the-word-spr">
                            Refer friends and get up to
                        </p>
                        <p className="R400-off">{this.props.profile.currencySymbol}10,000</p>
                        <p className="text-white Spread-the-word-spr">
                            credit towards your next debit order/s
                        </p>
                        <br />
                        <p className="text-white Spread-the-word-spr">
                            Enter your friend’s details below
                        </p>

                        <div className="text-center">
                            <Form.Label className={'left-align temp-text-box-label text-white ' + (this.state.referFullname !== "" ? "pt-4" : "no-opacity")}><b>Name</b></Form.Label>
                            <br />
                            <Form.Control type="text" placeholder="Name" id="referFullname" name="referFullname" value={this.state.referFullname} onChange={this.handleChange} />
                            {this.state.referFriendSubmitted && !this.state.nameRegex &&
                                <div className="help-block-refer-friend">Please provide a valid name</div>
                            }

                            <Form.Label className={'left-align temp-text-box-label text-white ' + (this.state.referPhoneNumber !== "" ? "pt-4" : "no-opacity")}><b>Phone no.</b></Form.Label>
                            <br />
                            <Form.Control type="number" placeholder="Phone no." id="referPhoneNumber" name="referPhoneNumber" value={this.state.referPhoneNumber} onChange={this.handleChange} />
                            {this.state.referFriendSubmitted && !this.state.cellphoneNumberRegex &&
                                <div className="help-block-refer-friend">Please provide a valid cell no.</div>
                            }
                        </div>

                        <div className="mt-4 mb-3 ts-and-cs">
                            <div className="row ml-2">
                                <div className="slider-col">
                                    <label className="switch">
                                        <input type="checkbox" onClick={(e) => this.handleToggleTC(e)} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                    <div className="col ts-and-cs text-left">
                                        I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/terms-and-conditions/">King Price’s T’s & C’s</a> and <a className="w-bold" target="_blank" href="https://www.kingprice.co.za/privacy-policy/">POPIA policy</a>.
                                    </div>
                                }

                                {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                                    <div className="col ts-and-cs text-left">
                                        I agree to <a className="w-bold" target="_blank" href="https://www.kingprice.co.na/Home/terms-and-conditions/">King Price’s T’s & C’s</a>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="text-white Spread-the-word-spr Spread-the-word-tc-text">
                            By hitting the ‘refer’ button, I confirm that my friend has given me permission to share their info and for King Price to contact them.
                        </div>

                        <div className="text-white Spread-the-word-spr Spread-the-word-detail">
                            <div className="Spread-the-word-detail-label mt-3 mb-3">In a nutshell</div>
                            <div>
                                Share the joy of simple cheap insurance with your friends. If they sign up, we’ll add the value of your friend’s monthly premium to your policy as a credit, towards your next debit order/s. Ka-ching!
                            </div>

                            <div className="Spread-the-word-detail-label mt-3 mb-3">Here's an example</div>
                            <div>
                                If you refer your friend to us and their premium is R2,000 per month, and your premium is only R1,000 per month, your premium won’t be debited by us for 2 months, YAY!
                            </div>
                        </div>

                        <div className="mt-4 text-white Spread-the-word-spr">
                            Refer more, earn more!
                        </div>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REFER_AGAIN) {
            header = () =>

                footer = () =>
                    <>
                        <div className="row justify-content-center col-12 mt-3">
                            <button className="btn btn-outline-red col-12 full-width high-5-btn" onClick={this.referAgain}>Refer again</button>
                            <button className="btn btn-solid-green col-12 full-width mt-3 high-5-btn" onClick={this.handleHideModal} id='closeModal'>Done</button>
                        </div>
                    </>

            body = () =>
                <>
                    <div className="text-center">
                        <img className="pb-3" src="./images/thumbs-up.svg" />
                        <h3>High-5!</h3>
                    </div>
                    <div className="text-center">
                        <p>Thanks for referring your friend</p>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_COMING_SOON) { // coming soon
            header = () =>
                <div id="ComingSoonModalHeader" className="text-center">
                    <Image src="./Images/ComingSoon/coming-soon.svg" fluid />
                </div>
            body = () =>
                <div className="col-12 text-center">
                    <p className="feature mb-1">This feature is <br /> on its way</p>
                    <br />
                    <p>Watch this space</p>
                </div>
            footer = () =>
                <Button className="col-12 btn btn-solid-green btn-lg justify-content-center w-100" onClick={this.handleHideModal} id='closeModal'>
                    Okay
                </Button>
        }
        else if (modal.modalProps.type === MODAL_TYPE_BROKER_DOCS) { // Broker doc
            header = () =>
                <>
                    <div className="text-center">
                        <Image src="./Images/Broker/iconBroker.png" fluid />
                    </div>
                    <div className='text-center'>
                        <p className="broker-policy-header">{BROKER_DOC_HEADER}</p>
                    </div>
                </>
            body = () =>
                <div className='text-center'>
                    <p>{BROKER_DOC_DESCRIPTION}</p>
                </div>
            footer = () =>
                <button className="btn btn-solid-red" onClick={this.handleHideModal} id='closeModal'>
                    Got it
                </button>
        }
        else if (modal.modalProps.type === MODAL_TYPE_QUOTE_PAYMENT) { // Quote payment options
            header = () =>
                <>
                    <div className="text-center">
                        <Image src="./Images/Payment/group-62.png" fluid />
                    </div>
                    <div className='text-center'>
                        <p className="payment-method-header">Choose your payment</p>
                        <p className="payment-method-header-2">method</p>
                    </div>
                </>
            body = () =>
                <div>
                    <div className="check-box-row col-12">
                        <label htmlFor='PaymentMethodDebit' className="col-10 radio-text text-center">
                            <input className="check col-1 text-center" type="radio" id='PaymentMethodDeditRadio' checked={this.state.paymentMethod === PAYMENT_TYPE_DEBIT} onChange={this.handlePaymentType} value={PAYMENT_TYPE_DEBIT} radioGroup="PaymentMethod" />
                            Debit order</label>
                    </div>
                    <br />
                    <div className="check-box-row col-12" >
                        <label htmlFor='PaymentMethodCredit' className="col-11 radio-text"> <input className="check col-1" type="radio" radioGroup='PaymentMethod' id='PaymentMethodCreditRadio' checked={this.state.paymentMethod === PAYMENT_TYPE_CREDIT} onChange={this.handlePaymentType} value={PAYMENT_TYPE_CREDIT} ></input>
                            Credit card
                        </label>
                    </div>
                    {this.state.paymentMethod === PAYMENT_TYPE_CREDIT &&
                        <div className="help-block-credit-spacing" >
                            <label className="help-block-credit">You’ll be redirected to iVeri, our credit card partner</label>
                        </div>
                    }
                </div>
            footer = () =>
                <>
                    <form id="iveriSubmission" name="iveriSubmission" method="POST" action={this.props.sales.iveriSubmissionUrl} className={this.state.paymentMethod === PAYMENT_TYPE_CREDIT ? "col-12 p-0 text-center" : "d-none"}>
                        <input type="hidden" name="firebaseToken" id="firebaseToken" value={this.props.sales.firebaseToken} />
                        <input type="hidden" name="quoteId" id="quoteId" value={this.props.sales.quoteId} />
                        <div>
                            <input type="submit" id="btnsubmit" name="btnsubmit" className="btn btn-solid-red payment-method-btn" value="Next" />
                        </div>
                    </form>
                    <button className={this.state.paymentMethod === PAYMENT_TYPE_DEBIT ? "btn btn-solid-red payment-method-btn col-10 text-center" : "d-none"} onClick={this.handleHideModal} id='closeModal'>
                        Next
                    </button>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_VAP) { // Add Vap to quote
            header = () =>
                <>
                    <div className="text-center">
                        <div className={modal.modalProps.vap.icon} />
                    </div>
                    <div className='text-center'>
                        <p className="vap-header">{modal.modalProps.vap.title}</p>
                    </div>
                    <div className='text-center'>
                        <p>{modal.modalProps.vap.description}</p>
                    </div>
                </>
            body = () =>
                <>
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.subtitle &&
                        <div className='text-center vap-premium'>
                            <h2>{this.props.profile.currencySymbol} {modal.modalProps.vap.subtitle} pm</h2>
                        </div>
                    }
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.premium !== "0.00" &&
                        <div className='text-center '>
                            <p className="red-text vap-premium"><b>{this.props.profile.currencySymbol} {modal.modalProps.vap.premium}</b></p>
                        </div>
                    }
                </>
            footer = () =>
                <>
                    {!modal.modalProps.vap.isActive &&
                        <button className="btn btn-solid-green full-width" onClick={this.handleAddVap} id='closeModal'>
                            Add
                        </button>
                    }

                    {modal.modalProps.vap.isActive &&
                        <button className="btn btn-outline-red full-width" onClick={this.handleRemoveVap} id='closeModal'>
                            Remove
                        </button>
                    }
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIM_COST_BREAKDOWN) {
            header = () =>
                <>
                    <div className="text-center">
                        <Image alt="" title="" src="./images/Info.svg" className="img-fluid claim_cost_breakdow-info-large" />
                    </div>
                    <div className="text-center">
                        <p className="breakdown-header mb-0px">Breakdown of repair costs</p>
                    </div>
                </>
            body = () =>
                <>
                    <div className="full-width mt-20px">
                        <div className="date-changed-body">
                            <p className="text-center mb-0px">For a detailed list of your car's repair costs, tap on 'Call me back'.</p>
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="text-center mt-20px mb-0"> <strong>Our business hours:</strong><br />
                                Mondays to Fridays, 08:00 - 17:00
                            </p>}
                            {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="text-center mt-20px mb-0"> <strong>Our business hours:</strong><br />
                                Mondays to Fridays, 08:00 - 16:30
                            </p>}
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center noma mt-30px">
                        <Button className="btn-solid-red claim_cost_breakdown-button" onClick={this.handleDamageReportCallBack}>Call me back</Button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_GET_BACK_DAMAGE) {
            header = () =>
                <div className="text-center">
                    <img src="Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png" />
                    <h3 className="mb-0">We’ll get back to you</h3>
                </div>
            body = () =>
                <>
                    <p className="text-center pt-0">
                        Thanks for reaching out to us!
                        <br />
                        We'll give you a call soon.
                        <br />

                    </p>
                    {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="text-center pt-2 mb-0">
                        <strong>Business hours:</strong><br />
                        Mondays to Fridays, 08:00 - 17:00
                    </p>}
                    {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="text-center pt-2 mb-0">
                        <strong>Business hours:</strong><br />
                        Mondays to Fridays, 08:00 - 16:30
                    </p>}
                </>
            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleHideModal} id='closeModal'>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_RAFF_ASSIST) {
            header = () =>
                <>
                    <div className="text-center">
                        <div className={modal.modalProps.vap.isActive == true ? 'icons-vap-icons-raf-active' : 'icons-vap-icons-raf-inactive'} />
                    </div>
                    <div className='text-center'>
                        <p className="vap-header">{modal.modalProps.vap.title}</p>
                    </div>
                    <div className='text-center'>
                        <p>{modal.modalProps.vap.description}</p>
                    </div>
                </>
            body = () =>
                <>
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.subtitle &&
                        <div className='text-center vap-premium'>
                            <h2>{this.props.profile.currencySymbol} {modal.modalProps.vap.subtitle} pm</h2>
                        </div>
                    }
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.premium !== "0.00" &&
                        <div className='text-center'>
                            <p className="red-text vap-premium"><b>{this.props.profile.currencySymbol} {modal.modalProps.vap.premium}</b></p>
                        </div>
                    }
                </>
            footer = () =>
                <>
                    {!modal.modalProps.vap.isActive &&
                        <button className="btn btn-solid-green full-width" onClick={this.handleAddVap} id='closeModal'>
                            Add
                        </button>
                    }

                    {modal.modalProps.vap.isActive &&
                        <button className="btn btn-outline-red full-width" onClick={this.handleRemoveVap} id='closeModal'>
                            Remove
                        </button>
                    }
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_VAP_CAR_HIRE) { // Add Vap car hire to quote
            header = () =>
                <>
                    <div className="text-center">
                        <div className={modal.modalProps.vap.icon} />
                    </div>
                    <div className='text-center'>
                        <p className="vap-header">{modal.modalProps.vap.title}</p>
                    </div>
                    <div className='text-center'>
                        <p>{modal.modalProps.vap.description}</p>
                    </div>

                    <div className="col-12 mt-4">
                        <Dropdown id="VapSelect" className="car-hire-vap"
                            onSelect={this.handleVapItemSelect}
                            onToggle={this.handleVapItemDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" >
                                <a>
                                    {this.state.selectedVap &&
                                        <>
                                            <p className="hide-overflow">{this.state.selectedVap.description}</p>
                                        </>
                                    }
                                    {!this.state.selectedVap &&
                                        <p>Choose an item</p>
                                    }
                                </a>
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Choose an item" id="carhire-dropdown">
                                {vapSelectList}
                            </Dropdown.Menu>
                            <hr />
                        </Dropdown>
                    </div>
                    {this.state.vapSubmitted &&
                        <div className='text-center'>
                            <p className="help-block-credit">Please select an option to continue</p>
                        </div>
                    }
                </>
            body = () =>
                <>
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.subtitle &&
                        <div className='text-center vap-premium'>
                            <h2>{this.props.profile.currencySymbol} {modal.modalProps.vap.subtitle} pm</h2>
                        </div>
                    }
                    {
                        modal.modalProps.vap.isActive && modal.modalProps.vap.premium !== "0.00" &&
                        <div className='text-center'>
                            <p className="red-text vap-premium"><b>{this.props.profile.currencySymbol} {modal.modalProps.vap.premium}</b></p>
                        </div>
                    }
                </>
            footer = () =>
                <>
                    {
                        !modal.modalProps.vap.isActive &&
                        <button className="btn btn-solid-green full-width" onClick={this.handleAddVapCarHire} id='closeModal'>
                            Add
                        </button>
                    }

                    {modal.modalProps.vap.isActive &&
                        <>
                            <button className="btn btn-solid-green col-5" onClick={this.handleEditVapCarHire} id='closeModal'>
                                Update
                            </button>

                            <button className="btn btn-outline-red col-5" onClick={this.handleRemoveVapCarHire} id='closeModal'>
                                Remove
                            </button>
                        </>
                    }
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_ACCESSORRY) { // Add Accessorry to quote
            header = () =>
                <>
                    <div className="text-center">
                        <div className={modal.modalProps.accessory.icon} />
                    </div>
                    <div className='text-center'>
                        <p className="vap-header">{modal.modalProps.accessory.title}</p>
                    </div>
                    <div className='text-center'>
                        <p>{modal.modalProps.accessory.description}</p>
                    </div>
                    <div className='text-center row'>
                        <label className="col-1 accessory-value currency-margin">{this.props.profile.currencySymbol}</label>
                        <input className="col-10 text-center accessory-value" type="number" name="accessorryReplacementValue" value={this.state.accessorryReplacementValue} onChange={this.handleChange} />
                    </div>
                    {this.state.accessoryError &&
                        <div className='text-center'>
                            <p className="help-block-credit">{this.state.accessoryErrorDescription}</p>
                        </div>
                    }
                </>
            footer = () =>
                <>
                    {!modal.modalProps.accessory.isActive &&
                        <button className="btn btn-solid-green full-width" onClick={this.handleAddAccessorry} id='closeModal'>
                            Add
                        </button>
                    }

                    {modal.modalProps.accessory.isActive &&
                        <>
                            <button className="btn btn-solid-green col-5" onClick={this.handleAddAccessorry} id='closeModal'>
                                Update
                            </button>

                            <button className="btn btn-outline-red col-5" onClick={this.handleRemoveAccessorry} id='closeModal'>
                                Remove
                            </button>
                        </>
                    }
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_CREDIT_SHORTFALL) { //Add credit shortfall to quote
            header = () =>
                <>
                    <div className="text-center">
                        <div className={modal.modalProps.vap.icon} />
                    </div>
                    <div className='text-center'>
                        <p className="vap-header">{modal.modalProps.vap.title}</p>
                    </div>
                    <div className='text-center'>
                        <p>{modal.modalProps.vap.description}</p>
                    </div>
                    <div className='text-center'>
                        <p>Do you have a balloon payment?</p>
                    </div>
                    <div className="col-12 mt-4">
                        <Dropdown id="VapSelect"
                            onSelect={this.handleVapItemSelect}
                            onToggle={this.handleVapItemDropdownToggle}>
                            <Dropdown.Toggle id="dropdown-basic" >
                                <a>
                                    {this.state.selectedVap &&
                                        <>
                                            <p className="hide-overflow">{this.state.selectedVap.description}</p>
                                        </>
                                    }
                                    {!this.state.selectedVap &&
                                        <p>Choose an item</p>
                                    }
                                </a>
                            </Dropdown.Toggle>
                            <Dropdown.Menu title="Choose an item" id="vap-dropdown">
                                {vapSelectList}
                            </Dropdown.Menu>
                            <hr />
                        </Dropdown>
                    </div>
                    <div className='text-center'>
                        <p>When did your loan start?</p>
                    </div>
                    <div className="mb-4">
                        <Form.Label className={'left-align temp-text-box-label pl-1' + (this.state.selectedCreditShortfallDate !== "" ? "" : " no-opacity")}>Loan start date (YYYY-MM-DD)</Form.Label>
                        <ModernDatepicker
                            date={this.state.selectedCreditShortfallDate}
                            format={'YYYY-MM-DD'}
                            showBorder
                            onChange={(date) => this.handleCreditShortfallDateChange(date)}
                            placeholder={'Loan start date (YYYY-MM-DD)'}
                            className="calendar-inline-icon"
                            maxDate={this.state.maxDate}
                        />
                        {this.state.hasSubmitted && this.state.selectedCreditShortfallDate &&
                            <div className="help-block">Loan start date is required</div>
                        }
                    </div>
                </>
            footer = () =>
                <>
                    {!modal.modalProps.vap.isActive &&
                        <button className="btn btn-solid-green full-width" onClick={this.handleAddCreditShortfall} id='closeModal'>
                            Add
                        </button>
                    }

                    {modal.modalProps.vap.isActive &&
                        <>
                            <button className="btn btn-solid-green col-5" onClick={this.handleUpdateCreditShortfall} id='closeModal'>
                                Update
                            </button>

                            <button className="btn btn-outline-red col-5" onClick={this.handleRemoveVap} id='closeModal'>
                                Remove
                            </button>
                        </>
                    }
                </>
        }
        else if (modal.modalProps.type === MODAL_TOW_ASSIST) { //Edit page popup
            header = () =>
                <>
                    <div className="text-center">
                        <img src="Images/Claims/tow-truck-red.png" />
                        <h3 className="pt-4">Tow truck assistance</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center w-100">
                        <p className="noma">Please call our tow truck assistance on:</p>
                        {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p>0860 55 55 23.</p>}
                        {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p>083 600 7000.</p>}
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <strong>Operational 24 hours a day 7 days a week</strong>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ADD_NEW_QUOTE_ITEM) { //Add new item to quote
            header = () =>
                <>
                </>
            body = () =>
                <>
                    <OnlineJourneySelect />
                </>
            footer = () =>
                <>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_QUOTE_ITEM) { //Remove item from quote
            header = () =>
                <>
                    <div className="text-center">
                        <Image className="img-fluid" alt="" src="\Images\icons-line-style-info-32-px.png" />
                    </div>
                </>
            body = () =>
                <>
                    <div className='text-center'>
                        <p><b>Are you sure you want to remove this cover from your quote</b></p>
                    </div>
                    <div className='text-center'>
                        <p>You'll have to start a new quote if you want to add this cover again</p>
                    </div>
                </>
            footer = () =>
                <>
                    <button className="btn btn-solid-red col-12 full-width" onClick={this.handleRemoveQuoteItem} value={modal.modalProps.removeItemId} id='closeModal'>Yes</button>
                    <button className="btn btn-outline-red col-12 full-width" onClick={this.handleHideModal} id='closeModal'>No</button>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SHOW_BANKING) {
            header = () =>
                <>
                    <div className="text-center">
                        <span className="banking-header"><b>Confirm banking details</b></span>
                    </div>
                </>
            body = () =>
                <>
                    {(this.props.profile.isLinked && this.props.profile.bankingDetails && this.props.profile.bankingDetails.bankAccountType !== "Credit") &&
                        <>
                            <div>
                                <p className="m-0">New total monthly premium</p>
                                <p className="green-text"><b>{this.props.profile.currencySymbol} {this.props.sales.totalPremium}</b></p>
                            </div>
                            <div>
                                {(this.props.sales.selectedPortableDetail !== "" || this.props.sales.selectedBlingDetail !== "") &&
                                    <>
                                        <p className="m-0">New item insurance premium</p>
                                        <p className="green-text"><b>{this.props.profile.currencySymbol} {this.props.sales.carPremium}</b></p>
                                    </>
                                }

                                {this.props.sales.selectedPortableDetail === "" && this.props.sales.selectedBlingDetail === "" &&
                                    <>
                                        <p className="m-0">New car insurance premium</p>
                                        <p className="green-text"><b>{this.props.profile.currencySymbol} {this.props.sales.carPremium}</b></p>
                                    </>
                                }

                            </div>
                            <hr />
                            <div className='row'>
                                <p className="col-6">Bank</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.bank}</b></p>
                            </div>
                            <div className='row'>
                                <p className="col-6">Account no.</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.accountNumber}</b></p>
                            </div>
                            <div className='row'>
                                <p className="col-6">Branch</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.branch}</b></p>
                            </div>
                            {this.props.profile.bankingDetails.sourceOfIncomeDescription !== "" && this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                                <div className="row">
                                    <p className="col-6">Source of income</p>
                                    <p className="text-right col-6"><b>{this.props.profile.bankingDetails.sourceOfIncomeDescription}</b></p>
                                </div>
                            }
                            <div className='row'>
                                <p className="col-6">Policy start date</p>
                                <p className="text-right col-6"><b>Today</b></p>
                            </div>
                        </>
                    }
                    {(this.props.profile.isLinked && this.props.profile.bankingDetails && this.props.profile.bankingDetails.bankAccountType === "Credit" && this.props.profile.bankingDetails.creditCard) &&
                        <>
                            <div>
                                <p className="m-0">New total monthly premium</p>
                                <p className="green-text"><b>{this.props.profile.currencySymbol} {this.props.sales.totalPremium}</b></p>
                            </div>
                            <div>
                                <p className="m-0">New car insurance premium</p>
                                <p className="green-text"><b>{this.props.profile.currencySymbol} {this.props.sales.carPremium}</b></p>
                            </div>
                            <hr />
                            <div className='row'>
                                <p className="col-6">Name on card</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.creditCard.fullName}</b></p>
                            </div>
                            <div className='row'>
                                <p className="col-6">Account no.</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.creditCard.accountNumber}</b></p>
                            </div>
                            <div className='row'>
                                <p className="col-6">Expiry date</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.creditCard.expiryDate.substr(5, 2) + "/" + this.props.profile.bankingDetails.creditCard.expiryDate.substr(0, 4)}</b></p>
                            </div>
                            <div className='row'>
                                <p className="col-6">Policy start date</p>
                                <p className="text-right col-6"><b>Today</b></p>
                            </div>
                            {this.props.profile.bankingDetails.sourceOfIncomeDescription !== "" &&
                                <div className='row'>
                                    <p className="col-6">Source of income</p>
                                    <p className="text-right col-6"><b>{this.props.profile.bankingDetails.sourceOfIncomeDescription}</b></p>
                                </div>
                            }
                        </>
                    }
                    {this.props.profile.bankingDetails.debitOrderDay === 1 && this.props.profile.bankingDetails.bankAccountType !== "Credit" &&
                        <>
                            <div className='row'>
                                <p className="col-6">Debit order date</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.debitOrderDay}st of every month</b></p>
                            </div>
                            <hr />
                            <div>
                                <p>We want to make sure you’re covered properly. So, a pro rata amount of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.proRata}</span> will be deducted immediately from your account.<br />
                                    <br />
                                    Then, on the {this.props.profile.bankingDetails.debitOrderDay}st of every month, your total monthly premium of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.totalPremium}</span> will be deducted from your account {this.props.profile.bankingDetails.accountNumber} and will reflect as 'King Price' on your bank statement.<br />
                                    <br />
                                    Do you confirm the changes to your policy, which will be effective from {this.state.maxDate.getDate()}-{this.state.maxDate.getMonth() + 1}-{this.state.maxDate.getFullYear()}?</p>
                            </div>
                        </>
                    }
                    {this.props.profile.bankingDetails.debitOrderDay !== 1 && this.props.profile.bankingDetails.bankAccountType !== "Credit" &&
                        <>
                            <div className='row'>
                                <p className="col-6">Debit order date</p>
                                <p className="text-right col-6"><b>{this.props.profile.bankingDetails.debitOrderDay}th of every month</b></p>
                            </div>
                            <hr />
                            <div>
                                <p>We want to make sure you’re covered properly. So, a pro rata amount of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.proRata}</span> will be deducted immediately from your account.<br />
                                    <br />
                                    Then, on the {this.props.profile.bankingDetails.debitOrderDay}th of every month, your total monthly premium of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.totalPremium}</span> will be deducted from your account {this.props.profile.bankingDetails.accountNumber} and will reflect as 'King Price' on your bank statement.<br />
                                    <br />
                                    Do you confirm the changes to your policy, which will be effective from {this.state.maxDate.getDate()}-{this.state.maxDate.getMonth() + 1}-{this.state.maxDate.getFullYear()}?</p>
                            </div>
                        </>}
                    {this.props.profile.bankingDetails.bankAccountType === "Credit" &&
                        <>
                            <div className='row'>
                                <p className="col-6">Debit order date</p>
                                <p className="text-right col-6"><b>1st of every month</b></p>
                            </div>
                            <hr />
                            <div>
                                <p>We want to make sure you’re covered properly. So, a pro rata amount of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.proRata}</span> will be deducted immediately from your account.<br />
                                    <br />
                                    Then, on the {this.props.profile.bankingDetails.debitOrderDay}st of every month, your total monthly premium of <span className="per-month">{this.props.profile.currencySymbol} {this.props.sales.totalPremium}</span> will be deducted from your account {this.props.profile.bankingDetails.creditCard.accountNumber} and will reflect as 'King Price' on your bank statement.<br />
                                    <br />
                                    Do you confirm the changes to your policy, which will be effective from {this.state.maxDate.getDate()}-{this.state.maxDate.getMonth() + 1}-{this.state.maxDate.getFullYear()}?</p>
                            </div>
                        </>
                    }
                    <div className="text-center">
                        <img alt="Secure Connection" title="" src="./Images/Secure payment.svg" className="img-fluid" />
                    </div>
                </>
            footer = () =>
                <>
                    <button className="btn btn-solid-green col-12 full-width" onClick={this.handleAcceptBankingDetails}>Confirm</button>
                    <button className="btn btn-outline-red col-12 full-width" onClick={this.handleHideModal} id='closeModal'>Cancel</button>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SHOW_LEGAL) { //Legal page popup <LegalQuestions />
            header = () =>
                <>

                </>
            body = () =>
                <LegalQuestions />
            footer = () =>
                <>
                    <div className="row justify-content-center mt-3">
                        <div className="col-12">
                            <div className="text-center">
                                <button className="btn btn-solid-red IAccept" disabled={this.state.nextDisabled} onClick={this.handleAcceptLegalClick}>I accept</button>
                            </div>
                        </div>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CHANGE_CREDIT_CARD) { // Change credit card
            header = () =>
                <>
                    <div className="text-center">
                        <Image src="./Images/Payment/group-62.png" fluid />
                    </div>
                </>
            body = () =>
                <div className="text-center">
                    <p>You’ll be redirected to iVeri, our credit card partner</p>
                </div>
            footer = () =>
                <>
                    <form id="iveriSubmission" name="iveriSubmission" method="POST" action={this.props.sales.iveriSubmissionUrl} className={this.state.paymentMethod === PAYMENT_TYPE_CREDIT ? "col-12 p-0 text-center" : "d-none"}>
                        <input type="hidden" name="firebaseToken" id="firebaseToken" value={this.props.sales.firebaseToken} />
                        <input type="hidden" name="quoteId" id="quoteId" value={this.props.profile.customerId} />
                        <div>
                            <input type="submit" id="btnsubmit" name="btnsubmit" className="btn btn-solid-red payment-method-btn" value="Next" />
                        </div>
                    </form>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SHOW_EDIT) { //Edit page popup
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>Whoops, you haven’t saved your changes yet</b></h3>
                        <p className="text-center">Are you sure you want to leave this page? <br /> You’ll lose any changes you’ve made so far.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">

                        <button className="btn btn-outline-red col-12 full-width" onClick={() => this.handleIsInEditClick(modal.modalProps.id, modal.modalProps.destination)}>Yes, leave</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>

                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_QUOTE_ITEM_DISCARD) { //Edit page popup
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>Whoops, you haven’t added this item to your cart yet</b></h3>
                        <p className="text-center">Are you sure you want to leave this page? <br /> You’ll have to start a new quote to add this <b>{this.props.sales.quoteScreenRiskDescription}</b> if you want to add this cover again.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" onClick={() => this.handleRemoveUnaddedQuoteItem(modal.modalProps.id, modal.modalProps.destination)}>Yes, leave</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>
                    </div>
                </>
        }
        if (modal.modalProps.type === MODAL_TYPE_REQUET_CANCELATION) { //Edit page popup
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>Request cancellation</b></h3>
                        <br />
                        <p className="text-center mb-0">We'll contact you within 4 business hours (08:00 - 17:00, Mondays to Fridays) so listen out for our call. <br /><br /> Or you can give us a call on<br /></p>
                        {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                            <span className='call-me-back-number'>083 600 7000.</span>
                        }
                        {this.props.profile.countryId !== NAM_COUNTRY_ID_NUMBER &&
                            <span className='call-me-back-number'>0860 50 50 50.</span>
                        }
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-red col-12 full-width" onClick={this.handleCallMeBackPopup}>Call me back</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>
                    </div>
                </>
        } if (modal.modalProps.type === MODAL_TYPE_REQUEST_CANCEL_LIFE_POLICY) {
            header = () =>
                <>
                    <div className="text-center mt-3">
                        <h5 className=""><b>We'll get back to you ASAP</b></h5>
                    </div>
                </>
            body = () =>
                <>
                    <div className="px-3 pb-3">
                        <div className='form-group text-center row'>
                            <Form.Label className={'new-form-label' + (this.props.profile.cellphoneNumber !== "" ? "" : " no-opacity")}><b>Name</b></Form.Label>
                            <Form.Control className="underline" type="text" placeholder="" id="cellphoneNumberClaimContinue" name="cellphoneNumber" value={this.props.lifePolicy.policy.contact.name} />
                        </div>
                        <div className='for m-group text-center row'>
                            <Form.Label className={'new-form-label' + (this.props.profile.cellphoneNumber !== "" ? "" : " no-opacity")}><b>Phone no.</b></Form.Label>
                            <Form.Control className="underline" type="text" placeholder="Phone no." id="cellphoneNumberClaimContinue" name="cellphoneNumber" value={this.props.lifePolicy.policy.contact.phoneMobile} />
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="justify-content-center request-cancel-life-policy col-12 mt-3">
                        <button className="btn btn-solid-red col-12 full-width" onClick={this.handleWeWillGetBackToYouAsap}>Call me back</button>
                        <p className="text-center request-cancel-life-policy__call-us mt-4">Or you can call us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <b className="text-red">0860 50 50 50</b>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <b className="text-red">083 600 7000</b>}</p>
                        <p className="text-center request-cancel-life-policy__business-hours mt-4">Business hours: Mondays to Fridays,</p>
                        <p className="text-center request-cancel-life-policy__time">08:00 - 18:00</p>
                    </div>
                </>
        }
        if (modal.modalProps.type === MODAL_TYPE_CANCEL_POLICY_EDIT) { //Edit page popup
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>Are you sure you want to cancel</b></h3>
                        <p className="text-center"><br />You’ll lose any changes you’ve made to your policy so far</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" onClick={this.setInEdit}>Yes, cancel</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>
                    </div>
                </>
        }
        if (modal.modalProps.type === MODAL_TYPE_ANOTHER_SELF_INSPECTION) { //Another self inspection
            header = () =>
                <></>
            body = () =>
                <>
                    <div className="selfinspection-inspect-another-modal-body">
                        <h3>Let's get started</h3>
                        <p className="selfinspection-inspect-another-p-choose-car-bike">Choose another car/motorbike to inspect</p>
                        <p className="selfinspection-inspect-another-p-choose-item">Choose an item</p>
                        <div className="selfinspection-inspect-another-drop-down-holder">
                            <Dropdown id="CoverSelect"
                                onSelect={this.handleSelfInspectCoverSelection}
                                onToggle={this.handleCoverDropdownToggle}>
                                {/*/// Dropdown for selected: ///*/}
                                <Dropdown.Toggle id="dropdown-basic" className="selfinspection-inspect-another-dropdown">
                                    <div className="dropdown-basic-title-text">
                                        <a>
                                            {this.state.selectedSelfInspectCover &&
                                                <>
                                                    <div className="selfinspect-dropdown-selected-actual-item">
                                                        <div className="row selfinspect-dropdown-row">
                                                            <div className="selfinspect-dropdown-col-icon">
                                                                <div className={"selfinspect-dropdown-icon " + this.state.selectedSelfInspectCover.image}></div>
                                                            </div>
                                                            <div className="col selfinspect-dropdown-col-productname">
                                                                <p>
                                                                    <span className="selfinspect-dropdown-productname-productname">{this.state.selectedSelfInspectCover.productName + ": "}</span>
                                                                    <span className="selfinspect-dropdown-productname-description">{this.state.selectedSelfInspectCover.riskItems[0].description}</span>
                                                                </p>
                                                            </div>
                                                            <div className="selfinspect-dropdown-col-arrow">
                                                                <div className="selfinspect-dropdown-arrow-state"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {!this.state.selectedSelfInspectCover &&
                                                <p className="dropdown-basic-title-text-actual">
                                                    <div className="row selfinspect-dropdown-placeholder-row">
                                                        <div className="col-10">
                                                            Choose an item
                                                        </div>
                                                        <div className="selfinspect-dropdown-col-arrow">
                                                            <div className="selfinspect-dropdown-arrow-state"></div>
                                                        </div>
                                                    </div>
                                                </p>
                                            }
                                        </a>
                                    </div>
                                </Dropdown.Toggle>
                                {/*/// Dropdown for choose: ///*/}
                                <Dropdown.Menu title="Choose an item" id="nav-dropdown" className="selfinspection-inspect-another-dropdown">
                                    {coversSelfInspect}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <hr className="modal-hr" />
                </>
            footer = () =>
                <>
                    <div className="row modal-selfinspection-footer">
                        <div className="col-12">
                            <button className="btn btn-solid-red w-100" onClick={this.handleSetSelfInspectCoverSelection}>Start self-inspection</button>
                        </div>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SUBMIT_SELF_INSPECTION) { //Submit Self inspect
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.svg" className="img-fluid modal-selfinspection-icon" />
                </>
            body = () =>
                <>
                    <div className="text-center selfinspection-modal-body">
                        <h3>Self-inspection</h3>
                        <p className="text-center">
                            You’re about to submit a self-inspection for your
                            <b>{" " + this.props.selfInspect.selectedPersonalCover.riskItems[0].description}</b>.
                            Is this correct?
                        </p>
                        <p className="selfinspect-remember">
                            (Remember, incorrect info can affect the outcome of your claims.)
                        </p>
                    </div>
                    <hr className="modal-hr" />

                </>
            footer = () =>
                <>
                    <div className="row modal-selfinspection-footer">
                        <div className="col modal-selfinspection-col-no">
                            <button className="btn btn-outline-red w-100" onClick={this.handleHideModal} id='closeModal'>No</button>
                        </div>
                        <div className="col modal-selfinspection-col-no">
                            <button className="btn btn-solid-red w-100 ml-2" onClick={this.handleSubmitSelfInspect}>Yes</button>
                        </div>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE) { //Continue claim on phone
            header = () =>
                <>
                    <Image alt="" src="./Images/icons-line-style-info-32-px.png" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-13px"><b>You're about to switch to your phone</b></h3>
                        <p className="text-center mb-1">We're going to send you an SMS with the link to our self-service portal.</p>
                        <p className="text-center">Please confirm or change the phone number we have on record for you.</p>
                    </div>

                    <KPInputTextArea id="claimSwitchToPhoneNumber" type="text" name="claimContinuePhoneNumber" className="underline"
                        label={"Phone no."}
                        placeholder={"Phone no."}
                        value={this.state.claimContinuePhoneNumber}
                        defaultValue={this.state.claimContinuePhoneNumber}
                        notice={!this.state.claimContinuePhoneNumberError}
                        noticeType={"error"}
                        noticeMessage={"Please fill in a valid phone no. (10-digits)"}
                        alwaysShowLabel={false}
                        maxLength={10}
                        handleChange={(e) => this.handleChangeContinueOnPhone(e)}
                        dataType={"textarea"}
                    />
                </>
            footer = () =>
                <>
                    <div className="row text-center justify-content-center col-12 mt-3 nopa">
                        <button className="btn btn-solid-green col-12 mb-2" onClick={this.handleContinueClaim} disabled={this.state.claimContinuePhoneNumberIsBusy}>Confirm</button>
                        <button className="btn btn-outline-red col-12" onClick={this.handleHideModal} id='closeModal'>Go back</button>
                    </div>
                </>

        }
        else if (modal.modalProps.type === MODAL_TYPE_SEND_CONTINUE_CLAIM_ON_PHONE_DIFFERENT) { //Continue claim on phone
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>You're about to switch to your phone</b></h3>
                        <p className="text-center mb-1">We're going to send you an SMS with the link to our self service portal.</p>
                        <p className="text-center">Please enter the phone number to send the link to.</p>
                    </div>
                    <div className={'form-group text-center row' + (this.state.claimContinuePhoneNumberError && !this.state.claimContinuePhoneNumber ? ' has-error' : '')}>
                        <Form.Label className={'new-form-label' + (this.state.claimContinuePhoneNumber !== "" ? "" : " no-opacity")}><b>Phone no.</b></Form.Label>
                        <Form.Control className={(this.state.claimContinuePhoneNumberSubmitted && !this.state.claimContinuePhoneNumberError ? 'redunderline' : "underline")} type="text" placeholder="Phone no." id="vinNrInput" name="claimContinuePhoneNumber" value={this.state.claimContinuePhoneNumber} onChange={this.handleChange} />
                        {this.state.claimContinuePhoneNumberSubmitted && !this.state.claimContinuePhoneNumberError &&
                            <div className="help-block">Please enter a valid phone number</div>
                        }
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row text-center justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-green col-12 mb-2" onClick={this.handleContinueClaimDifferent} disabled={this.state.claimContinuePhoneNumberIsBusy}>Confirm</button>
                        <button className="btn btn-outline-red col-12" onClick={this.handleContinueClaimBack} id='closeModal'>Go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CONTINUE_CLAIM_ON_PHONE) { //Continue claim on phone
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>Pick up where you left off</b></h3>
                        <p className="text-center">We see you started a claim on your desktop and decided to switch to your phone... To continue with your claim, tap 'Continue'</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-red col-12 mb-2" onClick={this.handlePhoneClaimsComeback}>Continue</button>
                        <button className="btn btn-solid-red col-12 mb-2" id='closeModal' onClick={this.handleHideModal}>Remind me later</button>
                        <button className="btn btn-outline-red col-12" onClick={this.handleCancelClaimContinue} >Cancel</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CONTINUE_INSPECTION_ON_PHONE) { //Continue claim on phone
            header = () =>
                <>
                    <Image alt="" src="./Images/icons-line-style-info-32-px.png" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-13px"><b>Pick up where you left off</b></h3>
                        <p className="text-center">We see you started a self-inspection on your desktop and decided to switch to your phone... To continue with your self-inspection, tap 'Continue'</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3 nopa">
                        <button className="btn btn-solid-green col-12 mb-2" onClick={this.handlePhoneInspectionComeback}>Continue</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIM_CONTINUE_SUCCESS) { //Continue claim on phone sms successs
            header = () =>
                <>
                    <Image src="./Images/icon-checkmark-fill-green@3x.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>SMS sent</b></h3>
                        <p className="text-center">You'll receive an SMS soon, with the link to our self-service portal</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-green col-12" onClick={this.handleContinueOnPhone} >Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_INSPECTION_CONTINUE_SUCCESS) { //Continue claim on phone sms successs
            header = () =>
                <>
                    <Image alt="" src="./Images/icon-checkmark-fill-green@3x.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-1"><b>SMS sent</b></h3>
                        <p className="text-center">You'll receive an SMS soon, with the link to our self-service portal</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-green col-12" onClick={this.handleHideModal} >Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === FNOL_SELECTED_DAMAGE_MB_SHOW) { //FNOL selected damage
            header = () =>
                <>
                    <div className="text-left">
                        {(modal.modalProps.position === "front") &&
                            <>
                                <h3 className="positionHeading">Front</h3>
                                <p className="positionParagraph">Which of these are damaged on the front side of the motorbike</p>
                            </>
                        }
                        {(modal.modalProps.position === "frontRight") &&
                            <>
                                <h3 className="positionHeading">Front right</h3>
                                <p className="positionParagraph">Which of these are damaged on the front right side of the motorbike</p>
                            </>
                        }
                        {(modal.modalProps.position === "frontLeft") &&
                            <>
                                <h3 className="positionHeading">Front left</h3>
                                <p className="positionParagraph">Which of these are damaged on the front left side of the motorbike</p>
                            </>
                        }
                        {(modal.modalProps.position === "back") &&
                            <>
                                <h3 className="positionHeading">Back</h3>
                                <p className="positionParagraph">Which of these are damaged on the back side of the motorbike</p>
                            </>
                        }
                        {(modal.modalProps.position === "backLeft") &&
                            <>
                                <h3 className="positionHeading">Back left</h3>
                                <p className="positionParagraph">Which of these are damaged on the back left side of the motorbike</p>
                            </>
                        }
                        {(modal.modalProps.position === "backRight") &&
                            <>
                                <h3 className="positionHeading">Back right</h3>
                                <p className="positionParagraph">Which of these are damaged on the back right side of the motorbike</p>
                            </>
                        }
                    </div>
                </>
            body = () =>
                <>
                    {this.props.claimSubmit.claimDamagePhotoTypes.length > 0 &&
                        <>
                            <div className="fnol-damage-report-list-overflow row">
                                <div className="col fnol-damage-report-list-overflow-col">
                                    {this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => photoType.location === modal.modalProps.position))
                                        .map((photoType) =>
                                            <>
                                                <div className="row cursor-pointer fnol-damage-report-areas-holder" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                    <div className="col"  >
                                                        <p className="coverItems">{photoType.description}</p>
                                                    </div>
                                                    <div className="greyChecks align-self-center" title={photoType.description}  >
                                                        <Image alt="" id={photoType.description} src={photoType.isSelected ? "/my-policy/Images/Claims/grey-checkmark-checked.png" : "/my-policy/Images/Claims/grey-checkmark-unchecked.png"} />
                                                    </div>
                                                </div>
                                                <hr className="line-unpadded" />
                                            </>
                                        )}
                                </div>
                            </div>
                        </>
                    }

                    <div className="text-center fnol-damage-report-modal-buttons-holder">
                        <button className="btn btn-solid-green col-12 mb-19px damage-add-buttons" disabled={this.state.modalDamagePhotoTypes.length == 0} onClick={this.handleHideModalDamageReport} id='closeModal'>Add to report</button>
                        <br />
                        <button className="btn btn-outline-red col-12 damage-add-buttons" onClick={this.handleAddToReport} id='closeModal'>Cancel</button>
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === FNOL_SELECTED_DAMAGE_CAR_SHOW) { //FNOL selected damage
            header = () =>
                <>
                    <div className="text-left">
                        {(modal.modalProps.position === "front") &&
                            <>
                                <h3 className="positionHeading">Front</h3>
                                <p className="positionParagraph">Which of these are damaged on the front side of the car </p>
                            </>
                        }
                        {(modal.modalProps.position === "frontRight") &&
                            <>
                                <h3 className="positionHeading">Front right</h3>
                                <p className="positionParagraph">Which of these are damaged on the front right side of the car </p>
                            </>
                        }
                        {(modal.modalProps.position === "frontLeft") &&
                            <>
                                <h3 className="positionHeading">Front left</h3>
                                <p className="positionParagraph">Which of these are damaged on the front left side of the car </p>
                            </>
                        }
                        {(modal.modalProps.position === "back") &&
                            <>
                                <h3 className="positionHeading">Back</h3>
                                <p className="positionParagraph">Which of these are damaged on the back side of the car </p>
                            </>
                        }
                        {(modal.modalProps.position === "backLeft") &&
                            <>
                                <h3 className="positionHeading">Back left</h3>
                                <p className="positionParagraph">Which of these are damaged on the back left side of the car </p>
                            </>
                        }
                        {(modal.modalProps.position === "backRight") &&
                            <>
                                <h3 className="positionHeading">Back right</h3>
                                <p className="positionParagraph">Which of these are damaged on the back right side of the car </p>
                            </>
                        }

                    </div>
                </>
            body = () =>
                <>
                    {this.props.claimSubmit.claimDamagePhotoTypes.length > 0 &&
                        <>
                            {(modal.modalProps.position === "front") &&
                                <>
                                    <div className="fnol-damage-report-list-overflow row">
                                        <div className="col fnol-damage-report-list-overflow-col ">
                                            {this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => photoType.location === modal.modalProps.position))
                                                .map((photoType) =>
                                                    <>
                                                        <div className="row cursor-pointer fnol-damage-report-areas-holder" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                            <div className="col">
                                                                <p className="coverItems">{photoType.description}</p>
                                                            </div>
                                                            <div className="greyChecks" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                                <img id={photoType.description} src={photoType.isSelected ? "/my-policy/Images/Claims/grey-checkmark-checked.png" : "/my-policy/Images/Claims/grey-checkmark-unchecked.png"} alt="" title="" onClick={() => this.setClaimDamagePhotoTypes(photoType)} />
                                                            </div>
                                                        </div>
                                                        <hr className="line-unpadded" />
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </>
                            }

                            {(modal.modalProps.position === "back") &&
                                <>
                                    <div className="fnol-damage-report-list-overflow row">
                                        <div className="col fnol-damage-report-list-overflow-col ">
                                            {this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => photoType.location === modal.modalProps.position))
                                                .map((photoType) =>
                                                    <>
                                                        <div className="row cursor-pointer fnol-damage-report-areas-holder" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                            <div className="col">
                                                                <p className="coverItems">{photoType.description}</p>
                                                            </div>
                                                            <div className="greyChecks" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                                <img id={photoType.description} src={photoType.isSelected ? "/my-policy/Images/Claims/grey-checkmark-checked.png" : "/my-policy/Images/Claims/grey-checkmark-unchecked.png"} onClick={() => this.setClaimDamagePhotoTypes(photoType)} />
                                                            </div>
                                                        </div>
                                                        <hr className="line-unpadded" />
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </>
                            }

                            {modal.modalProps.position !== 'front' && modal.modalProps.position !== 'back' &&
                                <>
                                    <div className="fnol-damage-report-list-overflow row">
                                        <div className="col fnol-damage-report-list-overflow-col ">
                                            {this.props.claimSubmit.claimDamagePhotoTypes.filter((photoType => photoType.location === modal.modalProps.position))
                                                .map((photoType) =>
                                                    <>
                                                        <div className="row cursor-pointer fnol-damage-report-areas-holder" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                            <div className="col">
                                                                <p className="coverItems">{photoType.description}</p>
                                                            </div>
                                                            <div className="greyChecks" onClick={() => this.setClaimDamagePhotoTypes(photoType)} title={photoType.description}>
                                                                <img id={photoType.description} src={photoType.isSelected ? "/my-policy/Images/Claims/grey-checkmark-checked.png" : "/my-policy/Images/Claims/grey-checkmark-unchecked.png"} onClick={() => this.setClaimDamagePhotoTypes(photoType)} />
                                                            </div>
                                                        </div>
                                                        <hr className="line-unpadded" />
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    }
                    <div className="text-center fnol-damage-report-modal-buttons-holder">
                        <button className="btn btn-solid-green col-12 mb-19px damage-add-buttons" disabled={this.state.modalDamagePhotoTypes.length == 0} onClick={this.handleHideModalDamageReport} id='closeModal'>Add to report</button>
                        <br />
                        <button className="btn btn-outline-red col-12 damage-add-buttons" onClick={this.handleAddToReport} id='closeModal'>Cancel</button>
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_GET_BACK_TO_YOU) {
            header = () =>
                <>
                    <img title="" alt="" src="Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png" className="img-fluid get-back-headset-large" />
                </>

            body = () =>
                <>
                    <div className="row noma get-back-body">
                        <div className="col-12 nopa">
                            <div className="full-width">
                                <div className="text-center">
                                    <p className="font-size-22px font-weight-bold line-height-normal mt-10px mb-20px">We’ll get back to you</p>
                                    {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                                        <p>
                                            Thanks for reaching out to us! We’ll give you a call in the next 4 business hours.
                                            <br />
                                            <br />
                                            <strong>Business hours:</strong><br />
                                            Mondays to Fridays, 08:00 - 16:30
                                        </p>
                                    }
                                    {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                        <>
                                            <p className="font-weight-normal line-height-normal mb-20px">Thanks for reaching out to us! We’ll give you a call soon from this number: <span className="text-red font-weight-bold">012 001 8342</span>.</p>
                                            <p className="font-weight-normal line-height-normal mb-20px">If you’ve had an accident or mechanical breakdown, or need emergency roadside, medical or home assistance,
                                                call <span className="text-red font-weight-bold">0860 50 50 50</span> and <span className="text-red font-weight-bold">press 9</span>.</p>
                                            <p className="font-weight-normal line-height-normal mb-0px"><b>Business hours:</b><br />
                                                Mondays to Fridays, 08:00 - 17:00</p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center noma mt-22px">
                        <button className="btn btn-solid-green date-completion-button" onClick={this.handleHideModal} id="closeModal">Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_DUPLICATE_CLAIM) {
            header = () =>
                <div className="text-center">
                    <img src="Images/FNOL/Notifications.svg" />
                    <br />
                    <br />
                    <h3>Claim already submitted</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        You've already submitted a claim for this item and incident. Click on 'View claim progress' to learn more
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleCheckDuplicateClaim} id='duplicateClaimButton'>View claim progress</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TAKE_FNOL_PHOTOS) { //Take FNOL Photos
            header = () =>

                <div className="text-center">
                    <img src="Images/FNOL/fnol-take-photo.svg" />
                    <h3>Would you like to take photos of the damage</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        You don’t need to take photos in order to complete your claim notification, but it would be super cool if you did!
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink">
                    <button className="btn btn-solid-red w-100" onClick={this.handleTakeFNOLPhoto} id='closeModal'>Take photos of the damage</button>
                    <button className="btn btn-outline-red w-100 mt-2" onClick={this.handleSubmitFNOL} id='closeModal'>No thanks</button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE) { //Switch to your phone
            header = () =>
                <div className="mt-14px">
                    <h3 className="switch_phone">Switch to your phone to <br />take photos</h3>
                </div>
            body = () =>
                <div className="full-width mt-15px">
                    <div className="text-center switch-to-phone-body">
                        <p className="mb-0px">We’re going to send you an SMS with the link to our self-service portal <br /><br />Please confirm or change the phone number we have on record for you</p>
                    </div>
                    <div className="mt-30px">
                        <p className="text-left mb-6px contactLabels"><b>Phone no.</b></p>
                        <Form.Control type="text" placeholder="Phone no." id="swichToPhoneNumber" name="swichToPhoneNumber" value={this.state.swichToPhoneNumber} onChange={this.handleChange} />
                        {this.state.swichToPhoneSubmitted && !this.state.cellphoneNumberRegex &&
                            <div className="help-block">Please provide a valid cell no.</div>
                        }
                    </div>
                    <hr className="switch-to-phone-hr" />
                </div>
            footer = () =>
                <div className="row justify-content-center noma">
                    <button id="sumbitSwichToPhone" className="btn-solid-green switch-to-phone-button" onClick={this.handleSwichToPhoneSendSms}>Okay, send SMS</button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SMS_SENT) { //SMS sent
            header = () =>
                <>
                    <img src="./images/Checkmark.svg" title="" alt="" className="img-fluid sms-sent-image" />
                    <h3 className="font-size-18px mt-23px mb-14px"><b>SMS sent</b></h3>
                </>

            body = () =>
                <div className="row noma">
                    <div className="col-12 nopa">
                        <div className="text-center sms-sent-body">
                            <p className="mb-0px">You’ll receive an SMS soon, with the <br /> link to our self-service portal </p>
                        </div>
                        <div className="mb-10px mt-20px text-center sms-sent-body-2">
                            <p className="mb-0px"><b>Once logged in to the self-service portal, follow these steps:</b></p>
                        </div>
                        <ul className="text-left list-item">
                            <li>Go to the ‘Claims’ tab on the menu and tap on ‘View claim progress’</li>
                            <li>Find your claim in the list and tap on the ‘Notification of claim’ step.</li>
                            <li>Tap ‘Take photos’ and follow the instructions</li>
                        </ul>
                    </div>
                    <hr className="sms-sent-hr" />
                </div>
            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleCallMeBackClaims}>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIM_ESTIMATED_TIME) { //What we mean by 'estimated completion date'
            header = () =>
                <>
                    <Image alt="" title="" src="./images/Info.svg" className="img-fluid date-completion-info-large" />
                </>
            body = () =>
                <>
                    <div className="row noma date-completion-body">
                        <div className="col-12 nopa">
                            <div className="full-width">
                                <div className="text-center">
                                    <p className="font-size-18px mb-15px"><b>What we mean by 'estimated completion date'</b></p>
                                    <p className="text-center mb-0px">This is the date on which this step in the process is likely to be finalised (if there are no hiccups along the way). The 'latest date' is the last possible date for this to be completed</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center noma mt-22px">
                        <button className="btn btn-solid-green date-completion-button" onClick={this.handleHideModal}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP) { //each step 'estimated completion date'
            header = () =>
                <>
                    <Image alt="" title="" src="./images/Info.svg" className="img-fluid date-completion-info-large" />
                </>
            body = () =>
                <>
                    <div className="row noma date-completion-body">
                        <div className="col-12 nopa">
                            <div className="full-width">
                                <div className="text-center">
                                    <p className="font-size-18px mb-15px"><b>What we mean by 'estimated completion date'</b></p>
                                    <p className="text-center mb-10px">This is the date on which this step in the process is likely to be finalised (if there are no hiccups along the way)</p>
                                    <p className="text-center mb-0px"> Please check the FAQs at the bottom of the screen for more info</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center noma mt-22px">
                        <button className="btn btn-solid-green date-completion-button" onClick={this.handleHideModal}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REQUEST_A_CAR) { //Request a car
            body = () =>
                <div className="text-center w-100">
                    <img alt="" title="" src="Images/Claims/car-hire.png" />
                    <h3>Request a car</h3>
                    <p>
                        We'll give you a call to make arrangements for your rental wheels (if we haven’t done so already)
                    </p>
                </div>

            footer = () =>
                <div id="sumbitPolicyLink" className="col-12">
                    <Button className="w-100 btn-solid-green" onClick={this.handleHideModal} id='closeModal'>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REPAIRS_TAKING_LONGER) { //Repairs taking too long
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <p className="step-title mb-3"><b>About your car's repairs</b></p>
                        <p className="text-center">Hmm this is taking a bit longer than expected… You can call the repairer to get an update:</p>
                    </div>
                    <div className="text-center ma-top-20px">
                        <button className="btn btn-solid-red col-12" onClick={this.handleHideModal}>Call repairer</button>
                    </div>
                    <div className="text-center ma-top-30px">
                        <p>Or, we can find out what's happening for you. <br /><a className="text-red" onClick={this.showFNOLCallMeBack}>Tap here for a call back.</a></p>
                        {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="font-size-12px"><b>Please note:</b> Our business hours = 08:00 - 17:00,<br /> Mondays to Fridays</p>}
                        {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="font-size-12px"><b>Please note:</b> Our business hours = 08:00 - 16:30,<br /> Mondays to Fridays</p>}
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK) { // Glass/Window claims -confirmation modal
            header = () =>
                <></>
            body = () =>
                <>
                    <div className="text-center">
                        <Image alt="" title="" src="./images/Info.svg" className="img-fluid mb-10px" />
                        <p className="step-title mb-20px">Heads up</p>
                        <p className="text-center">You’re about to report a/an <span className="font-weight-600">{this.props.claimSubmit.incidentType.description}</span> claim for your <span className="font-weight-600">{this.props.claimSubmit.selectedRiskItem.riskItems[0].description}.</span> </p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3px nopa">
                        <button className="btn btn-solid-red col-12 mb-20px nopa">Continue</button>
                        <button className="btn btn-outline-red col-12 nopa">Go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_ESTIMATED_DATE_CHANGED) { //estimated date changed
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center date-changed-body">
                            <p className="step-title mt-15px mb-15px">Why has the estimated completion date changed</p>
                            <p className="text-center pb-0px mb-0px">Hmm this is taking a bit longer than expected… We'll find out why and give you feedback within the next 4 business hours</p>
                        </div>

                        <div className="text-center ma-top-30px">
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                <p className="font-size-12px mb-0px"><b>Please note:</b> Our business hours = 08:00 - 17:00,<br /> Mondays to Fridays</p>
                            }
                            {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER &&
                                <p className="font-size-12px mb-0px"><b>Please note:</b> Our business hours = 08:00 - 16:30,<br /> Mondays to Fridays</p>
                            }
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleHideModal} className="w-100 btn-solid-red date-changed-button">Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE) { // Glass/Window claims -  repaires please note
            header = () =>
                <></>
            body = () =>
                <>
                    <div className="text-center">
                        <Image alt="" title="" src="./images/Info.svg" className="img-fluid mb-10px" />
                        <p className="step-title mb-20px">Please note</p>
                        <p className="text-center font-weight-normal">While our suppliers normally come to you for repairs, they may schedule an appointment at 1 of their fitment centres if you have a high-value car, live in a remote location, or if there's very bad weather</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3px nopa">
                        <button className="btn btn-solid-red col-12 nopa" onClick={this.handleSubmitGlassClaim}>Continue</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIM_DISCLAIMER) { // Claim disclaimer
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center date-changed-body">
                            <p className="step-title mt-15px mb-20px">Heads up</p>
                            {this.props.claimSubmit.selectedRiskItem.productName === 'Car warranty' && 
                                <p className="text-center pb-0px mb-0px mt-0px">You’re about to report a <b>car warranty</b> claim for your <b>{this.props.claimSubmit.selectedRiskItem.riskItems[0].description}</b>.
                                </p>
                            ||
                                <p className="text-center pb-0px mb-0px mt-0px">You’re about to report a/an <b>{this.props.claimSubmit.incidentType.description.toLowerCase()}</b> claim for your <b>{this.props.claimSubmit.selectedRiskItem.riskItems[0].description}</b>.
                                </p>
                            }
                        </div>

                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleDisclaimerContinue} className="w-100 btn-solid-red button-disclaimer">Continue</button>
                    </div>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleHideModal} className="btn btn-outline-red w-100 mt-0px button-disclaimer">Go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS) { //Edit page popup
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid oops-portable-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center portable-body">
                            <p className="step-title mt-10px mb-20px">Oops</p>
                            <p className="text-center mb-0px">It looks like you don't have car, motorbike, bling, or home contents insurance with us... You'll have to get 1 of these before you can get portable possessions insurance.</p>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-green w-100 button-portable-possessions" onClick={this.handleHideModal}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS) { //Edit page popup
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid oops-portable-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center portable-body">
                            <p className="step-title mt-10px mb-20px">Oops</p>
                            <p className="text-center mb-0px">It looks like you don't have car, motorbike, bling, or home contents insurance with us... You'll have to get 1 of these before you can get portable possessions insurance.</p>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-green w-100 button-portable-possessions" onClick={this.handleHideModal}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CALL_BACK_REQUEST) { //Call back request
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icon-headphones-red.svg" className="img-fluid headphones-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center call-back-body">
                            <p className="step-title mt-10px mb-20px">Call back request</p>
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="mb-0px line-height-call-request">We’ll give you a call ASAP,<br /> or you can give us a call on <br />{this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <span className="call-number">0860 50 50 50.</span>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <span className="call-number">083 600 7000.</span>}<br /><br />
                                <span><b>Business hours:</b></span><br />Mondays to Fridays, 08:00 - 17:00</p>}
                            {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="mb-0px line-height-call-request">We’ll give you a call ASAP,<br /> or you can give us a call on <br />{this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <span className="call-number">0860 50 50 50.</span>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <span className="call-number">083 600 7000.</span>}<br /><br />
                                <span><b>Business hours:</b></span><br />Mondays to Fridays, 08:00 - 16:30</p>}
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-red w-100 button-portable-possessions" onClick={this.handleCallBack}>Request call back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE) {
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icon-headphones-red.svg" className="img-fluid headphones-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center call-back-body">
                            <p className="step-title mt-10px mb-20px">Oops</p>
                            <p className="mb-0px line-height-call-request">The total replacement value of your items are more than we allow, so we need 1 of our consultants to handle the rest of the process.<br /><br /></p>
                            {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <p className="mb-0px line-height-call-request">We’ll call you ASAP, or you can give us a call on <br />{this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <span className="call-number">0860 50 50 50.</span>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <span className="call-number">083 600 7000.</span>}<br /><br />
                                <span><b>Business hours:</b></span><br />Mondays to Fridays, 08:00 - 17:00</p>}
                            {this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <p className="mb-0px line-height-call-request">We’ll call you ASAP, or you can give us a call on <br />{this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <span className="call-number">0860 50 50 50.</span>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <span className="call-number">083 600 7000.</span>}<br /><br />
                                <span><b>Business hours:</b></span><br />Mondays to Fridays, 08:00 - 16:30</p>}
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-red w-100 button-portable-possessions" onClick={this.handlePortableCallBack}>Call me</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_QUOTE_MAINLINE_REMOVAL) { // Claim disclaimer
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center date-changed-body">
                            <p className="step-title mt-10px mb-20px">Are you sure you want to remove this cover from your quote</p>
                            <p className="mb-0px line-height-call-request">By removing {modal.modalProps.removeItemName} insurance from your quote, portable possessions insurance will also be removed because you need the one to get insurance for the other.
                                <br />
                                <br />
                                By choosing ‘Yes’, you’ll be cancelling your quote completely and have to start a new quote if you want to add this cover again</p>
                        </div>

                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleDiscardCart} className="w-100 btn-solid-red button-disclaimer">Yes</button>
                    </div>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleHideModal} className="btn btn-outline-red w-100 mt-0px button-disclaimer">No</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SEND_IMEI_NUMBER) { //Send IMEI number
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center mt-10px">
                        <h3 className="font-weight-bold font-size-22px mb-20px">Please send us your IMEI number</h3>
                        <p className="mb-22px">To get your IMEI number, please <b>dial *#06#</b> on the insured cellphone <b>({coverName.description}, phone no. {coverName.cellPhoneNumber})</b>. You'll get a number back, which you need to type into the 'IMEI no.’ field below.</p>
                        <p className="mb-0px">If you get 2 IMEI numbers back, use the first 1.</p>
                    </div>
                    <div className="form-group mb-0px mt-30px">
                        <KPInputTextArea id="imeiInput" type="text" name="IMEINumber" className=""
                            label={"IMEI no."}
                            placeholder={"Tap here to start typing..."}
                            value={this.state.IMEINumber}
                            notice={(!this.state.IMEINumberRegex && this.state.IMEINumberSubmitted)}
                            noticeType={"error"}
                            noticeMessage={"IMEI number must be 15 digits long"}
                            alwaysShowLabel={false}
                            maxLength={15}
                            handleChange={(e) => this.handleChangeNumbers(e)}
                            dataType={"numbers"}
                        />
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row text-center justify-content-center col-12 mt-20px pl-0px pr-0px">
                        <button className="btn btn-solid-red col-12" onClick={this.handleSendIMEINumber} id='closeModal'>Done</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE) {
            header = () =>

                <div className="text-center">
                    <Image src="./Images/Checkmark.svg" className="img-fluid" />
                    <h3 className="mt-15px mb-0">Claim notification submitted</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        Thanks, we'll close this claim and confirm (in writing) that you'll be claiming directly from someone else.
                    </p>
                </div>

            footer = () =>
                <div id="drivableClaimOther" className="col-12">
                    <Button id="drivableClaimOther" className="w-100 btn-solid-green" onClick={this.handleDrivableClaimOther}>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES) {
            header = () =>

                <div className="text-center">
                    <Image src="./Images/Checkmark.svg" className="img-fluid" />
                    <h3 className="mt-15px mb-0">Claim notification submitted</h3>
                </div>

            body = () =>
                <div className="text-center w-100">
                    <p>
                        Thanks, we'll close this claim and confirm (in writing) that you've reported this for record purposes only.
                    </p>
                </div>

            footer = () =>
                <div id="drivableClaimRecord" className="col-12">
                    <Button id="drivableClaimRecordBtn" className="w-100 btn-solid-green" onClick={this.handleDrivableClaimRecord}>Okay</Button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM) {
            header = () =>
                <div id="donateDecreaseModalHeader" className="text-center">
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid" />
                    <h3 className="mt-15px mb-0px">Are you sure you want to cancel (close) this claim</h3>
                </div>

            body = () =>
                <div className='text-center'>
                    <p>A closed claim means you’ve decided you don’t want proceed with this claim anymore.</p>
                    <p>If you choose ‘Yes, close claim’ then we’ll cancel it on our side. We’ll still note this as an incident on your profile, so that we have a complete history for you.</p>
                </div>
            footer = () =>
                <div id="closeDrivable">
                    <button id="yesCloseClaim" className="btn btn-solid-red btn-lg mt-5px" onClick={this.handleCloseDrivable}>
                        Yes, close claim
                    </button>

                    <button className="btn btn-outline-red btn-lg mt-20px" onClick={this.handleHideModal} id='closeModal'>
                        No, continue with claim
                    </button>
                </div>
        }
        else if (modal.modalProps.type === MODAL_TYPE_POLICY_VIEW_AMENDMENTS) { // policy view amendments
            header = () =>
                <>
                    <Image alt="" title="" src="./images/icons-line-style-info-32-px.svg" className="img-fluid date-changed-info-large" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center date-changed-body">
                            <p className="font-size-22px font-weight-bold line-height-normal mt-10px mb-20px">You’re about to update your policy and your total monthly premium may change.</p>
                            <p className="font-weight-normal line-height-normal mb-0px">Are you okay with that?</p>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handlePolicyUpdate} className="w-100 btn btn-outline-red button-disclaimer">Yes</button>
                    </div>
                    <div className="row justify-content-center col-12 mt-20px nopa">
                        <button onClick={this.handleHideModal} className="btn btn-outline-red w-100 mt-0px button-disclaimer">No</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_COVER) {
            header = () =>
                <>
                    <Image src="./Images/icon-red-warning.svg" className="img-fluid" alt="warningImage" />
                </>
            body = () =>
                <>
                    <div className="text-center mt-10px">
                        <h3 className="mb-10px"><b>Remove cover</b></h3>
                        <p className="text-center">Are you sure you want to remove <b>{modal.modalProps.removeItem.name}</b> from your policy</p>
                        <br />
                        <p className="text-center">You're about to update your policy and your total monthly premium may change. These changes will be effective immediately.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" onClick={() => this.handleRemoveCoverReasons(modal.modalProps.id)}>Yes</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_COVER_COMPLETE) {
            header = () =>
                <div id="donateDecreaseModalHeader" className="text-center">
                    <Image alt='' src="./images/thumbs-up.svg" fluid className='date-changed-info-large mb-10px' />
                </div>
            body = () =>
                <div className='text-center'>
                    <p className="Thank-you">Cover removed</p>
                    <p>Your <b>{modal.modalProps.productName}</b> for <b>{modal.modalProps.riskItemDescription}</b> has been removed from your policy effective immediately.
                        <br />
                        <br />
                        Your total new premium, effective today, will be <b>{this.props.profile.currencySymbol} {this.props.profile.selectedPersonalPolicy.totalPolicyPremium}</b>.</p>
                    {this.props.sales.creditAmount != 0 && <p>
                        The updates you've made mean we have to credit your account with <b>{this.props.profile.currencySymbol} {Math.abs(this.props.sales.creditAmount)}</b> and it'll be credited to your next debit order.</p>}
                </div>

            footer = () =>
                <>
                    <button className="btn btn-solid-green btn-lg justify-content-center w-100" onClick={this.handleHideModalToDashboard} id='closeModal'>
                        Okay
                    </button>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_LAST_COVER) {
            header = () =>
                <>
                    <Image alt="" title="" src="./Images/icon-red-warning.svg" className="img-fluid date-changed-info-large mb-10px" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center portable-body">
                            <p className="step-title mt-10px mb-20px">Remove cover</p>
                            <p className="text-center intervention mb-0px">Legally, we have to speak to the policyholder first to finalise your request.
                                <br />
                                <br />
                                Please contact us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <a href='tel:0860505050' target="_blank">0860 50 50 50</a>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <a href='tel:0836007000' target="_blank">083 600 7000</a>}<br />
                                or email <a href={"mailto:" + (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_RETENTIONS_EMAIL : SA_RETENTIONS_EMAIL)} target="_blank">{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_RETENTIONS_EMAIL : SA_RETENTIONS_EMAIL}</a>
                            </p>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-green w-100 button-portable-possessions" onClick={this.handleHideModalToDashboard}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS) {
            header = () =>
                <>
                    <Image alt="" title="" src="./Images/icon-red-warning.svg" className="img-fluid date-changed-info-large mb-10px" />
                </>
            body = () =>
                <>
                    <div className="full-width">
                        <div className="text-center portable-body">
                            <p className="step-title mt-10px mb-20px">Remove cover</p>
                            <p className="text-center intervention mb-0px">Because <b>{modal.modalProps.dependents}</b> {modal.modalProps.copy} <b>{modal.modalProps.product}</b>.
                                <br />
                                <br />
                                We are required, by law, to confirm the removal with the policyholder.
                                <br />
                                <br />
                                Please contact us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <a href='tel:0860505050' target="_blank">0860 50 50 50</a>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <a href='tel:0836007000' target="_blank">083 600 7000</a>}<br />
                                or email <a href={"mailto:" + (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_RETENTIONS_EMAIL : SA_RETENTIONS_EMAIL)} target="_blank">{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_RETENTIONS_EMAIL : SA_RETENTIONS_EMAIL}</a>

                            </p>
                        </div>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-30px nopa">
                        <button className="btn btn-solid-green w-100 button-portable-possessions" onClick={this.handleHideModalToDashboard}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_SHOW_EDIT_REMOVE) { //Edit page popup
            header = () =>
                <>
                    <Image src="./Images/icons-line-style-info-32-px.png" className="img-fluid date-changed-info-large mb-10px" />
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <h3 className="mb-20px"><b>Before you go</b></h3>
                        <p className="text-center">Are you sure you want to leave this page? Your policy will remain as is if you leave now.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" onClick={() => this.handleIsInEditRemoveClick(modal.modalProps.id, modal.modalProps.destination)}>Yes, leave</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_REMOVE_REASONS) { //Show Vap Remove reason
            header = () =>
                <>
                    <div className="row noma">
                        <div className="col-12 nopa">
                            <Image src='./Images/FNOL/Notifications.svg' alt='Notification' className='img-fluid mb-10px' />
                            <h3>Remove item</h3>
                            <p>Are you sure you want to remove <b>{this.props.modal.modalProps.vap.title.toLowerCase()}</b> from your policy<br /><br />This item will be removed immediately.</p>
                        </div>
                    </div>
                </>
            body = () =>
                <>
                    <div className="row noma mr-20px">
                        <div className="col-12 nopa mb-25px pl-0 pr-0">
                            <KPDropdown
                                id={"primary-cancellation-reason"}
                                isImageDropdown={false}
                                showLabelAfterSelection={true}
                                showLabelInside={true}
                                showLabelOutside={false}
                                isRiskItem={true}
                                labelAfterSelection={"Reason for removal"}
                                title={"Reason for removal"}
                                label={"Reason for removal"}
                                data={this.props.sales.quoteCancellationReasons.primaryCancellationReasons}
                                handleSelection={(e) => this.handlePrimaryReasonSelection(e)}
                                selectedValue={Number(this.props.sales.primaryQuoteCancellationReason) ? this.props.sales.quoteCancellationReasons.primaryCancellationReasons.filter(x => x.id == Number(this.props.sales.primaryQuoteCancellationReason))[0].description : ""}
                            />
                        </div>
                        {this.props.sales.primaryQuoteCancellationReason && this.state.showSecond &&
                            <div className="col-12 nopa mb-25px pl-0 pr-0">
                                <KPDropdown
                                    id={"primary-cancellation-reason"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"Please tell us more"}
                                    title={"Please tell us more"}
                                    label={"Please tell us more"}
                                    data={this.props.sales.quoteCancellationReasons.secondaryCancellationReasons.filter(x => x.primaryCancellationReasonId == Number(this.props.sales.primaryQuoteCancellationReason))}
                                    handleSelection={(e) => this.handleSecondaryReasonSelection(e)}
                                    selectedValue={Number(this.props.sales.secondaryQuoteCancellationReason) ? this.props.sales.quoteCancellationReasons.secondaryCancellationReasons.filter(x => x.id == Number(this.props.sales.secondaryQuoteCancellationReason))[0].description : ""}
                                />
                            </div>
                        }
                    </div>
                </>
            footer = () =>
                <>
                    <button disabled={this.props.sales.secondaryQuoteCancellationReason === undefined} className={"btn btn-outline-red align-self-center mb-20px w-100"} type="button" onClick={this.handleRemoveVapReason} >Yes</button>
                    <button className={"btn btn-outline-red align-self-center mb-20px w-100"} type="button" onClick={this.handleHideModal} >No</button>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_VIEW_INSPECTION_PHOTO) { // self inspection view photo
            header = () =>
                <>
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <img className="img-fluid" src={modal.modalProps.photo} alt="" />
                    </div>
                </>
            footer = () =>
                <>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_VIEW_POLICE_REPORT) { //Police report info
            header = () =>
                <>
                    <Image alt="" title="" src="./Images/info.svg" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center mb-10px">
                        <p className="font-size-22px font-weight-bold line-height-normal mb-0px">Report to the police</p>
                    </div>
                    <div className="text-center">
                        <p>To continue with your claim, you first need to report this incident to the police. Please get this done ASAP and try again? Thanks</p>
                    </div>
                    <div className="text-center ma-top-20px">
                        <button className="btn btn-solid-red col-12 mb-15px" onClick={this.handleHideModal} id="closeModal">Continue</button>
                        <button className="btn btn-outline-red col-12 w-100" onClick={this.handleHideModalToDashboard} id="exitClaim">Exit claim</button>
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_TYPE_VIEW_BLACKLIST_PHONE) { //Blacklist phone info
            header = () =>
                <>
                    <Image alt="" title="" src="./Images/info.svg" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="font-size-22px font-weight-bold line-height-noraml mb-0px">Blacklist your phone</p>
                    </div>
                    <div className="text-center">
                        <p>To continue, you first need to make double sure that your phone’s been blacklisted by your service provider. Once they do this, you’ll receive a reference number, which you then need to give to us.</p>
                    </div>
                    <div className="text-center ma-top-20px">
                        <button className="btn btn-solid-red col-12 mb-15px" onClick={this.handleHideModal} id="closeModal">Continue</button>
                        <button className="btn btn-outline-red col-12 w-100" onClick={this.handleHideModalToDashboard} id="exitClaim">Exit claim</button>
                    </div>
                </>
            footer = () =>
                <></>
        }
        else if (modal.modalProps.type === MODAL_TYPE_NO_LONGER_MAINLINE) { //Edit page popup
            header = () =>
                <>
                    <Image src="./images/Info.svg" className="img-fluid date-changed-info-large mb-10px" />
                    <div className="text-center">
                        <h3 className="mb-20px"><b>Oops</b></h3>
                    </div>
                    <div className="text-center mb-0px">
                        <p className="mb-0px">It looks like you don't have car, motorbike, home contents, or buildings insurance with us... You'll have to get 1 of these before you can add another cellphone.</p>
                    </div>
                </>
            body = () =>
                <>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-green w-100 button-portable-possessions" onClick={() => this.props.dispatchShowAddNewItem()}>Get a quote</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={() => this.props.dispatchHandleCallMeBack()} id='closeModal'>Call me back</button>
                    </div>
                    <div>
                        <p className="text-center intervention mt-10px">Alternatively, you can call us on {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && <a href='tel:0860505050' target="_blank">0860 50 50 50</a>}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && <a href='tel:0836007000' target="_blank">083 600 7000</a>}<br />
                            or email <a href={"mailto:" + (this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_CLIENT_CARE_EMAIL : SA_CLIENT_CARE_EMAIL)} target="_blank">{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER ? NAM_CLIENT_CARE_EMAIL : SA_CLIENT_CARE_EMAIL}</a>
                        </p>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CELLPHONE_PLEASE_WAIT) {//CELLPHONE_PLEASE_WAIT
            header = () =>
                <>
                    <Image alt="" title="" src="./Images/info.svg" className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 oops">Please note</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center">
                        <ul className="text-left list-item">
                            <li>It's super important that you keep your phone's damaged parts until your claim's finalised.</li>
                            <li>Please also keep any proof that your phone's been repaired/replaced, as well as receipts which show how
                                much it cost.</li>
                            <li>If your claim's approved, we'll pay out the amount we would've paid if you'd used 1 of our suppliers.
                            </li>
                            <li>If you still have your original phone box, please keep it close, in case we need proof of ownership</li>
                        </ul>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLAIMS_ADDRESS_CHANGE) { // Claim address change modal
            header = () =>
                <>
                    <Image src="./images/icon-headphones-red.svg" className="img-fluid" alt="headphones" title="headphone-icon" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">Please note</h3>
                    </div>
                </>
            footer = () =>
                <>
                    <button className={"btn btn-solid-red align-self-center mb-20px w-100"} type="button" onClick={this.handleHideModal} id="closeModal">Continue</button>
                </>
            body = () =>
                <>
                    <p className="text-center">1 of our consultants will give you a call to confirm the new home address that you've entered. As soon as that conversation has taken place, we'll change it on your policy as well.</p>
                </>
            footer = () =>
                <>
                    <button className="btn btn-solid-green w-100 button-ok" onClick={this.handleHideModal} id='closeModal'>Okay</button >
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_CLICK_AWAY) { //Follow up questions - clickaway
            header = () =>
                <>
                    <Image alt="infoImage" src="./Images/info.svg" className="img-fluid" />
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="font-size-22px font-weight-bold line-height-noraml mb-0px">Before you go</p>
                    </div>
                    <div className="text-center">
                        <p className="text-center">Are you sure you want to leave this page? <br /> You will lose the information you have provided in the follow up questions if you leave now.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" id="btnYesLeaveFollowUp" onClick={() => this.handleIsFollowUpClick(modal.modalProps.id, modal.modalProps.destination)}>Yes, leave</button>
                        <button className="btn btn-outline-red col-12 full-width mt-3" onClick={this.handleHideModal} id='closeModal'>No, go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_REDIRECT_NAM) { //Redirect to nam
            header = () =>
                <>
                    <Image alt="infoImage" src='./images/icon-red-warning.svg' className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">Oops</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="font-size-18px line-height-noraml mb-0px">You're trying to log in from our South African page, but we see you're a Namibian client. Let's take you to the right page, real quick.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <a className="btn btn-solid-red col-12 full-width" id="btnOkayNam" href="https://www.kingprice.co.na/my-policy/" >Okay</a>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_REDIRECT_ZA) { //Redirect to ZA
            header = () =>
                <>
                    <Image alt="infoImage" src='./images/icon-red-warning.svg' className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">Oops</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="font-size-18px line-height-noraml mb-0px">You're trying to log in from our Namibian page, but we see you're a South African client. Let's take you to the right page, real quick.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <a className="btn btn-solid-red col-12 full-width" id="btnOkayNam" href="https://www.kingprice.co.za/my-policy/" >Okay</a>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_CLEAR_PARTY) {
            header = () =>
                <></>
            body = () =>
                <>
                    <div className="text-center">
                        <Image alt="" title="" src="./images/Info.svg" className="img-fluid mb-10px" />
                        <p className="step-title mb-20px">Heads up</p>
                        <p className="text-center">Are you sure you want to select no? You’ll lose the information you’ve filled in to this section.</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3px nopa">
                        <button className="btn btn-solid-red col-12 mb-20px nopa" id="YesChangeAnswer" onClick={() => this.handleClearParties(modal.modalProps.partyType, modal.modalProps.reducerName)}>Yes, change answer</button>
                        <button className="btn btn-outline-red col-12 nopa" id="NoAnswer" onClick={this.handleHideModal}>No, go back</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_SIGN_IN) {
            header = () =>
                <></>
            body = () =>
                <>
                    <h2 className="log-in-text">Log in</h2>
                    <p className="font-weight-bold mb-0 pb-0">Continue with</p>
                    <div className="row">
                        <div className="col-4 col-sm-4 text-center p-0">
                            <Button id="facebook" type="button" className="mt-4 btn" onClick={this.handleFacebookLogin} >
                                <Image src="./Images/icon-facebook.svg" />
                            </Button>
                        </div>
                        <div className="col-4 col-sm-4 text-center p-0">
                            <Button id="google" type="button" className="mt-4 btn" onClick={this.handleGoogleLogin}>
                                <Image src="./Images/icon-google.svg" />
                            </Button>
                        </div>
                        <div className="col-4 col-sm-4 text-center p-0">
                            <Button id="apple" type="button" className="mt-4 btn" onClick={this.handleAppleLogin}>
                                <Image src="./Images/icon-apple.svg" />
                            </Button>
                        </div>
                    </div>
                    <div className="mt-4 row">
                        <div className="line2 col-lg-5 col-md-5 col-5 ml-3 p-md-0 p-lg-0"></div>
                        <div className="Or col-lg-1 col-md-1 col-1 p-md-0 p-lg-0">Or</div>
                        <div className="line2 col-lg-5 col-md-5 col-5 p-md-0 p-lg-0"></div>
                    </div>
                    <div className="text-center">
                        <BasicAuthSignIn />
                    </div>
                </>
            footer = () =>
                <>
                </>
        } else if (modal.modalProps.type === EXISTING_CLIENT_ERROR) {
            header = () =>
                <>
                    <Image alt="infoImage" src='./images/icon-red-warning.svg' className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">Hang 10</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="font-size-18px line-height-noraml mb-0px">It looks like you're on our system already... We'll call you soon to chat</p>
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-red col-12 full-width" id="goToDashboard" onClick={() => this.handleHideModal()}>Okay</button>
                    </div>
                </>
        }
        else if (modal.modalProps.type === MODAL_TYPE_POLICY_VIEW_AMENDMENTS_RENEWAL) {
            header = () =>
                <>
                    <Image alt="infoImage" src='./images/Info.svg' className="img-fluid" />
                    <div id="errorModalHeader" className="text-center">
                        <h3 className="mt-3 mb-0 step-title">We'll have to stop you there</h3>
                    </div>
                </>
            body = () =>
                <>
                    <div className="text-center mb-20px">
                        <p className="line-height-noraml mb-0px">Because your policy renewal date is coming up, we unfortunately can’t update your info via our self-service portal. (Sorry!)<br /><br />
                            Our agents are more than happy to help you, though. Simply call us on (<span className="line-height-noraml mb-0px text-red">{this.props.profile.countryId === SA_COUNTRY_ID_NUMBER && "0860 50 50 50"}{this.props.profile.countryId === NAM_COUNTRY_ID_NUMBER && "083 600 7000"}</span>),
                            or leave your details and we’ll call you back:</p>
                    </div>
                    <div>
                        <Form.Label className={'left-align temp-text-box-label contactLabels ' + (this.state.fullname !== "" ? "" : " no-opacity")}><b>Name</b></Form.Label>
                        <Form.Control type="text" placeholder="Full name" id="fullname" name="fullname" value={this.state.fullname} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.nameRegex &&
                            <div className="help-block">Please provide a valid name</div>
                        }

                        <br />
                        <Form.Label className={'left-align temp-text-box-label contactLabels ' + (this.state.phoneNumber !== "" ? "" : " no-opacity")}><b>Phone no.</b></Form.Label>
                        <Form.Control type="text" placeholder="Phone no." id="phoneNumber" name="phoneNumber" value={this.state.phoneNumber} onChange={this.handleChange} />
                        {this.state.callBackSubmitted && !this.state.cellphoneNumberRegex &&
                            <div className="help-block">Please provide a valid cell no.</div>
                        }
                    </div>
                </>
            footer = () =>
                <>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-solid-red col-12 full-width" id="callMeBack" onClick={() => this.handleCallMeBack(false)}>Call me</button>
                    </div>
                    <div className="row justify-content-center col-12 mt-3">
                        <button className="btn btn-outline-red col-12 full-width" id="hideModal" onClick={() => this.handleHideModal()}>Go back</button>
                    </div>
                </>
        }

        return (
            /// ACTUAL MODAL GENERATION ////
            <Modal
                show={modal.visible}
                onHide={this.handleHideModal}
                backdrop="static"
                keyboard={false}
                centered
                animation={false}
                onEnter={this.handleShowModal}
                onShow={this.handleShowModal}
                className={(modal.modalProps.type === MODAL_TYPE_REFER_A_FRIEND ? " model-red-background" : "") || (modal.modalProps.type === MODAL_TYPE_SUBMIT_SELF_INSPECTION ? " selfinspect-modal" : "") || (modal.modalProps.type === MODAL_TYPE_ANOTHER_SELF_INSPECTION ? " selfinspect-inspect-another-modal" : "")
                    || (modal.modalProps.type === MODAL_TYPE_ESTIMATED_DATE_CHANGED ? " modal-claim-history-date-changed" : "") || (modal.modalProps.type === MODAL_TYPE_NOTIFICATION_SWITCH_TO_PHONE ? "modal_notification_switch_to_phone" : "")
                    || (modal.modalProps.type === MODAL_TYPE_SMS_SENT ? " modal-sms-sent" : "") || (modal.modalProps.type === MODAL_TYPE_CLAIM_ESTIMATED_TIME ? "modal_claim_estimated_time" : "") || (modal.modalProps.type === MODAL_TYPE_CLAIM_ESTIMATED_TIME_EACH_STEP ? "modal_claim_estimated_time_each_step" : "")
                    || (modal.modalProps.type === MODAL_GET_BACK_TO_YOU ? "modal_get_back_to_you" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_REPAIRS_TAKING_LONGER ? " modal_repairs_taking_longer" : "") || (modal.modalProps.type === MODAL_TYPE_CLAIM_COST_BREAKDOWN ? " modal_claim_cost_breakdown" : "")
                    || (modal.modalProps.type === MODAL_TYPE_ESTIMATED_DATE_CHANGED ? " modal-claim-history-date-changed" : "") || (modal.modalProps.type === MODAL_TYPE_CLAIM_DISCLAIMER || modal.modalProps.type === MODAL_TYPE_QUOTE_MAINLINE_REMOVAL ? " modal-claim-disclaimer" : "")
                    || (modal.modalProps.type === MODAL_TYPE_ADD_NEW_QUOTE_ITEM ? "modal-add-new_quote_item" : "") || (modal.modalProps.type === MODAL_TYPE_OOPS_PORTABLE_POSSESSIONS ? "modal-oops-portable-possessions" : "")
                    || ((modal.modalProps.type === MODAL_TYPE_CALL_BACK_REQUEST || modal.modalProps.type === MODAL_TYPE_PORTABLE_POSSESSIONS_REPLACEMENT_VALUE) ? "modal-call-back-request" : "") || (modal.modalProps.type === FNOL_SELECTED_DAMAGE_MB_SHOW ? "modal-fnol-damage-mb-show" : "")
                    || (modal.modalProps.type === FNOL_SELECTED_DAMAGE_CAR_SHOW ? "modal-fnol-damage-car-show" : "")
                    || (modal.modalProps.type === MODAL_TYPE_SHOW_LEGAL ? "modal-show-legal" : "") || (modal.modalProps.type === MODAL_TYPE_SEND_IMEI_NUMBER ? "modal-show-send-imei-number" : "") || ((modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_FROM_SOMEONE_ELSE || modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_RECORD_PURPOSES) ? "modal-drivable-submit" : "")
                    || (modal.modalProps.type === MODAL_TYPE_POLICY_VIEW_AMENDMENTS ? "modal-show-policy-view-amendments" : "")
                    || (modal.modalProps.type === FNOL_SELECTED_DAMAGE_CAR_SHOW ? "modal-fnol-damage-car-show" : "") || (modal.modalProps.type === MODAL_TYPE_SHOW_LEGAL ? "modal-show-legal" : "")
                    || (modal.modalProps.type === MODAL_TYPE_SEND_IMEI_NUMBER ? "modal-show-send-imei-number" : "") || (modal.modalProps.type === MODAL_TYPE_POLICY_VIEW_AMENDMENTS ? "modal-show-policy-view-amendments" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_REMOVE_LAST_COVER_DEPENDENT_ITEMS ? "modal-show-send-imei-number" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_REMOVE_LAST_COVER ? "modal-show-send-imei-number" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_REMOVE_COVER_COMPLETE ? "modal-show-send-imei-number" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_SHOW_EDIT_REMOVE ? "modal-cover-removal-before-you-go" : "") ||
                    (modal.modalProps.type === MODAL_TYPE_REMOVE_COVER ? "modal-cover-removal" : "") || (modal.modalProps.type === MODAL_TYPE_NO_LONGER_MAINLINE ? "modal-no-longer-mainline" : "")
                    || (modal.modalProps.type === MODAL_TYPE_VIEW_POLICE_REPORT ? "modal-police-report" : "") || (modal.modalProps.type === MODAL_TYPE_VIEW_BLACKLIST_PHONE ? "modal-blacklist-phone" : "")}
            >
                <Modal.Header className="col-12 text-center no-border">
                    <Modal.Title className="w-100">
                        {modal.modalProps.type !== MODAL_TYPE_QUOTE_SOFT_REJECTED &&
                            <div className="float-right">
                                <button className="btn-modal-close" onClick={this.handleHideModal}><img src={modal.modalProps.type === MODAL_TYPE_REFER_A_FRIEND ? "./images/Close-cross-white-16px.svg" : "./images/icons-navigation-close-16-px-dark-grey.svg"} alt="close" title="close" /></button>
                            </div>
                        }
                        {header()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={(modal.modalProps.type === MODAL_TYPE_DRIVABLE_CLAIM_CLOSE_CLAIM || modal.modalProps.type === MODAL_TYPE_VIEW_INSPECTION_PHOTO) ? "p-0" : ""}>
                    {body()}
                </Modal.Body>
                <Modal.Footer className={modal.modalProps.type === MODAL_TYPE_REFER_A_FRIEND || modal.modalProps.type === FNOL_SELECTED_DAMAGE_CAR_SHOW || modal.modalProps.type == MODAL_TYPE_CLAIM_COST_BREAKDOWN || modal.modalProps.type === FNOL_SELECTED_DAMAGE_MB_SHOW || modal.modalProps.type === MODAL_TYPE_REPAIRS_TAKING_LONGER || modal.modalProps.type === MODAL_TYPE_FNOL_CALL_ME || modal.modalProps.type == MODAL_TYPE_GET_BACK_DAMAGE || modal.modalProps.type == MODAL_TYPE_GLASS_REPAIRS_PLEASE_NOTE || modal.modalProps.type === MODAL_TYPE_VIEW_INSPECTION_PHOTO || modal.modalProps.type === MODAL_TYPE_QUOTE_SOFT_REJECTED || modal.modalProps.type === MODAL_TYPE_QUOTE_HARD_REJECTED  ? "border border-0" : ""}>
                    {footer()}
                </Modal.Footer>
            </Modal>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        modal: state.modal,
        profile: state.profile,
        auth: state.auth,
        sales: state.sales,
        lifePolicy: state.lifePolicy,
        ssp: state.ssp,
        selfInspect: state.selfInspect,
        claimSubmit: state.claimSubmit,
        cart: state.cart
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideModal: () => dispatch(hideModal()),
        dispatchSignOut: () => dispatch(signOut()),
        dispatchGetOTP: (OTPToPhone) => dispatch(requestOTP(OTPToPhone)),
        dispatchResendOTP: () => dispatch(showRequestOTPModal()),
        dispatchVerifyOTP: (OTP) => dispatch(verifyOTP(OTP)),
        dispatchVerifyOTPLife: (OTP) => dispatch(verifyOTPLife(OTP)),
        dispatchShowVerifyOTPModal: () => dispatch(showVerifyOTPModal()),
        dispatchFnolCallMeModal: () => dispatch(showFnolCallMeModal()),
        dispatchCallMeBack: (fullname, phoneNumber, department, callTime, dispCallBack, toggleComment) => dispatch(callMeBack(fullname, phoneNumber, department, callTime, dispCallBack, toggleComment)),
        dispatchDamageReportCallBack: (fullname, phoneNumber, department, dispCallBack) => dispatch(damageReportCallBack(fullname, phoneNumber, department, dispCallBack)),
        dispatchFnolCallMeBack: (fullName, cellphoneNumber, comments, department) => dispatch(fnolCallMeBack(fullName, cellphoneNumber, comments, department)),
        dispatchUpdateInfo: (infoField, infoData) => dispatch(updateInfo(infoField, infoData)),
        dispatchLinkCustomer: (parameter) => dispatch(requestOTP(parameter)),
        dispatchLinkLifeCustomer: (parameter) => dispatch(linkLifeCustomer(parameter)),
        dispatchDonateDecreaseToOrganization: (id, name) => dispatch(donateDecreaseToOrganization(id, name)),
        dispatchRequestDocument: (parameter) => dispatch(requestDocument(parameter)),
        dispatchRequestLifeDocument: (parameter) => dispatch(requestLifeDocument(parameter)),
        dispatchReferFriend: (name, surname, number) => dispatch(referAFriend(name, surname, number)),
        dispatchRefreshCacheAndReload: () => RefreshCacheAndReload(),
        dispatchAddVapToQuote: (vap, productCode) => dispatch(addVapToQuote(vap, productCode)),
        dispatchEditVapOnQuote: (vap, productCode) => dispatch(editVapCoverOnQuote(vap, productCode)),
        dispatchRemoveVapOnQuote: (vap) => dispatch(RemoveVapCoverOnQuote(vap)),
        dispatchAddAccessoryToQoute: (accessorry, replacementValue) => dispatch(addAccessoryToQoute(accessorry, replacementValue)),
        dispatchAddCreditShortfall: (balloonPaymnet, loanDate) => dispatch(addCreditShortfall(balloonPaymnet, loanDate)),
        dispatchUpdateCreditShortfall: (balloonPaymnet, loanDate, vap) => dispatch(updateCreditShortfall(balloonPaymnet, loanDate, vap)),
        dispatchRemoveAccessoryFromQuote: (accessorry) => dispatch(removeAccessoryFromQuote(accessorry)),
        dispatchRemoveProductFromCart: (riskItemId) => dispatch(removeProductFromCart(riskItemId)),
        dispatchRemoveProductFromCartNavigate: (riskItemId) => dispatch(removeProductFromCartNavigate(riskItemId)),
        dispatchShowLegalScreen: () => dispatch(showLegalScreen()),
        dispatchShowInEditScreen: (id, destination) => dispatch(showInEditScreen(id, destination)),
        dispatchIsInEdit: (value) => dispatch(setIsInEdit(value)),
        dispatchIsInEditRemove: (value) => dispatch(setIsInEditRemove(value)),
        dispatchSetLegalQuestions: (criminaloffence: any, specialterms: any, refused: any, advised: any, cancelled: any) => dispatch(setLegalQuestions(criminaloffence, specialterms, refused, advised, cancelled)),
        dispatchShowInterventionalModal: (error) => dispatch(showInterventionErrorModal(error)),
        dispatchCreatePolicy: () => dispatch(createPolicy()),
        dispatchUpdatePolicy: () => dispatch(updatePolicy()),
        dispatchShowGetBackToYou: () => dispatch(showGetBackToYou()),
        dispatchSetSelectedCover: (id) => dispatch(setSelectedCover(id)),
        dispatchHandleCallMeBack: () => dispatch(showCallMeModal(true)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        showReferFriend: () => dispatch(showReferFriend()),
        dispatchShowAddNewItem: () => dispatch(showAddNewItem()),
        dispatchSetSelectedCoverSelfInspect: (id) => dispatch(setSelectedCoverSelfInspect(id)),
        dispatchShowLoadingScreen: () => dispatch(showLoadingScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideLoadingScreen()),
        dispatchSubmitSelfInspect: () => dispatch(submitSelfInspect()),
        dispatchSendSMS: (phoneNumber) => dispatch(sendSMS(phoneNumber)),
        dispatchSendSMSInspection: (phoneNumber) => dispatch(sendInspectionSMS(phoneNumber)),
        dispatchLogContinueOnPhone: () => dispatch(logContinueOnPhone()),
        dispatchLogInspectionContinueOnPhone: () => dispatch(logInspectionContinueOnPhone()),
        dispatchRemoveNotifyFlag: () => dispatch(removeNotifyFlag()),
        dispatchInspectionRemoveNotifyFlag: () => dispatch(removeInspectionNotifyFlag()),
        dispatchGetContinueAndSetData: () => dispatch(getContinueAndSetData()),
        dispatchGetInspectionContinueAndSetData: () => dispatch(getInspectionContinueAndSetData()),
        dispatchShowClaimContinueSuccess: () => dispatch(showClaimContinueSuccess()),
        dispatchShowInspectionContinueSuccess: () => dispatch(showInspectionContinueSuccess()),
        dispatchGetClaimDamagePhotoTypes: (riskItemType) => dispatch(getClaimDamagePhotoTypes(riskItemType)),
        dispatchSetSelectedDamagePhotoTypes: (riskItemType) => dispatch(setSelectedDamagePhotoTypes(riskItemType)),
        dispatchAddDamagePosition: (pos) => dispatch(setDamagePosition(pos)),
        dispatchShowContinueOnPhoneDifferent: () => dispatch(showContinueOnPhoneDifferent()),
        dispatchShowContinueOnPhone: (phoneNumber) => dispatch(showSendContinueOnPhone(phoneNumber)),
        dispatchSetSelectedClaim: (claimId) => dispatch(setSelectedClaim(claimId)),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchSaveDamageSelected: (description) => dispatch(saveDamageSelected(description)),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSubmitFNOL: () => dispatch(submitFNOL()),
        dispatchSubmitFNOLNotDriveable: () => dispatch(submitFNOLNotDriveable()),
        dispatchSetContinueOnMobile: () => dispatch(setContinueOnPhone()),
        dispatchCompleteStep: () => dispatch(completeStep()),
        dispatchshowSMSsent: () => dispatch(showSMSsent()),
        dispatchLifeRequestCancellation: () => dispatch(requestCancellationLife()),
        dispatchSetDisclaimer: (flag) => dispatch(setDisclaimer(flag)),
        dispatchSubmitGlass: () => dispatch(submitGlassClaim()),
        dispatchGetLegalQuestions: () => dispatch(getLegalQuestions()),
        dispatchAcceptQuote: () => dispatch(acceptQuote(true)),
        dispatchDiscardCartPortable: () => dispatch(discardCartPortable()),
        dispatchSendIMEINumber: (IMEINumber) => dispatch(getIsIMEINumberActive(IMEINumber)),
        dispatchSetIsOnQuoteScreen: () => dispatch(setIsOnQuoteScreen(false, "", "")),
        dispatchGetQuoteCancellationReasons: () => dispatch(getQuoteCancellationReasons()),
        dispatchSubmitDrivableClaim: (isRecordPurpose, isThirdPartyclaim) => dispatch(submitDrivableClaim(isRecordPurpose, isThirdPartyclaim)),
        dispatchEditPolicy: (productType, filterItem) => dispatch(editPolicyRiskItems(productType, filterItem)),
        dispatchSetQuoteCancellationReasons: (primaryReason, secondaryReason) => dispatch(setQuoteCancellationReasons(primaryReason, secondaryReason)),
        dispatchRemoveVapFromQuoteWithReasons: (coverId) => dispatch(removeVapFromQuoteWithReasons(coverId)),
        dispatchAction: (e) => dispatch(e),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ModalComponent)